// src/data/municipiosGeoJSON.js
// Dados geográficos oficiais do IBGE com limites municipais e máscara de foco
export const MUNICIPIOS_GEOJSON = Object.freeze({
  "type": "FeatureCollection",
  "features": [
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              -42.548,
              -4.345
            ],
            [
              -42.4826,
              -4.344
            ],
            [
              -42.4479,
              -4.3344
            ],
            [
              -42.4196,
              -4.3435
            ],
            [
              -42.4173,
              -4.3399
            ],
            [
              -42.1959,
              -4.3809
            ],
            [
              -42.1817,
              -4.3819
            ],
            [
              -42.1741,
              -4.3726
            ],
            [
              -42.1775,
              -4.3673
            ],
            [
              -42.1775,
              -4.3577
            ],
            [
              -42.1821,
              -4.3494
            ],
            [
              -42.1818,
              -4.3402
            ],
            [
              -42.178,
              -4.3263
            ],
            [
              -42.1841,
              -4.3075
            ],
            [
              -42.1935,
              -4.2974
            ],
            [
              -42.1852,
              -4.2867
            ],
            [
              -42.1868,
              -4.2777
            ],
            [
              -42.1946,
              -4.2709
            ],
            [
              -42.1786,
              -4.2696
            ],
            [
              -42.1606,
              -4.2709
            ],
            [
              -42.1548,
              -4.2742
            ],
            [
              -42.1333,
              -4.2721
            ],
            [
              -42.1252,
              -4.2735
            ],
            [
              -42.1221,
              -4.2667
            ],
            [
              -42.1112,
              -4.2661
            ],
            [
              -42.1002,
              -4.2706
            ],
            [
              -42.0635,
              -4.2739
            ],
            [
              -42.0415,
              -4.2714
            ],
            [
              -42.0306,
              -4.2667
            ],
            [
              -42.0113,
              -4.2674
            ],
            [
              -42.0005,
              -4.2722
            ],
            [
              -41.9966,
              -4.2452
            ],
            [
              -41.9969,
              -4.2078
            ],
            [
              -42.0154,
              -4.2
            ],
            [
              -42.0511,
              -4.1811
            ],
            [
              -42.0563,
              -4.191
            ],
            [
              -42.0632,
              -4.1917
            ],
            [
              -42.0768,
              -4.2053
            ],
            [
              -42.0938,
              -4.2031
            ],
            [
              -42.11,
              -4.2107
            ],
            [
              -42.1164,
              -4.207
            ],
            [
              -42.13,
              -4.2123
            ],
            [
              -42.1337,
              -4.2171
            ],
            [
              -42.1425,
              -4.2168
            ],
            [
              -42.1563,
              -4.2202
            ],
            [
              -42.1723,
              -4.2174
            ],
            [
              -42.1834,
              -4.2208
            ],
            [
              -42.193,
              -4.2169
            ],
            [
              -42.2078,
              -4.2257
            ],
            [
              -42.213,
              -4.2208
            ],
            [
              -42.2275,
              -4.2273
            ],
            [
              -42.2376,
              -4.2241
            ],
            [
              -42.2354,
              -4.2177
            ],
            [
              -42.2397,
              -4.2121
            ],
            [
              -42.2388,
              -4.2015
            ],
            [
              -42.234,
              -4.1949
            ],
            [
              -42.242,
              -4.1673
            ],
            [
              -42.2489,
              -4.1618
            ],
            [
              -42.2634,
              -4.1703
            ],
            [
              -42.2667,
              -4.1609
            ],
            [
              -42.2612,
              -4.1562
            ],
            [
              -42.2625,
              -4.1503
            ],
            [
              -42.2536,
              -4.1414
            ],
            [
              -42.2509,
              -4.1268
            ],
            [
              -42.2598,
              -4.1223
            ],
            [
              -42.2575,
              -4.1157
            ],
            [
              -42.2589,
              -4.1046
            ],
            [
              -42.2638,
              -4.0895
            ],
            [
              -42.2545,
              -4.0778
            ],
            [
              -42.2573,
              -4.0733
            ],
            [
              -42.2564,
              -4.0628
            ],
            [
              -42.2638,
              -4.0547
            ],
            [
              -42.2581,
              -4.0492
            ],
            [
              -42.2619,
              -4.0278
            ],
            [
              -42.2664,
              -4.025
            ],
            [
              -42.2645,
              -4.0108
            ],
            [
              -42.2595,
              -4.0053
            ],
            [
              -42.2471,
              -3.9996
            ],
            [
              -42.2374,
              -3.9976
            ],
            [
              -42.238,
              -3.9823
            ],
            [
              -42.2295,
              -3.9736
            ],
            [
              -42.2358,
              -3.9594
            ],
            [
              -42.2439,
              -3.9267
            ],
            [
              -42.2454,
              -3.9355
            ],
            [
              -42.2669,
              -3.9394
            ],
            [
              -42.2749,
              -3.9546
            ],
            [
              -42.2722,
              -3.9617
            ],
            [
              -42.2771,
              -3.9788
            ],
            [
              -42.288,
              -3.9759
            ],
            [
              -42.3012,
              -3.986
            ],
            [
              -42.3088,
              -3.9985
            ],
            [
              -42.3255,
              -3.9931
            ],
            [
              -42.3318,
              -3.9853
            ],
            [
              -42.3458,
              -3.9811
            ],
            [
              -42.359,
              -3.9743
            ],
            [
              -42.3734,
              -3.9847
            ],
            [
              -42.3887,
              -3.986
            ],
            [
              -42.4393,
              -3.9686
            ],
            [
              -42.4562,
              -3.9968
            ],
            [
              -42.5127,
              -4.0423
            ],
            [
              -42.5046,
              -4.0549
            ],
            [
              -42.5205,
              -4.0637
            ],
            [
              -42.5305,
              -4.0928
            ],
            [
              -42.5343,
              -4.1003
            ],
            [
              -42.542,
              -4.1045
            ],
            [
              -42.5561,
              -4.1047
            ],
            [
              -42.5901,
              -4.1329
            ],
            [
              -42.6072,
              -4.1303
            ],
            [
              -42.6102,
              -4.1323
            ],
            [
              -42.6231,
              -4.1293
            ],
            [
              -42.6467,
              -4.1309
            ],
            [
              -42.616,
              -4.2379
            ],
            [
              -42.548,
              -4.345
            ]
          ]
        ]
      },
      "properties": {
        "name": "Barras",
        "codarea": "2201200",
        "isPiripiri": false,
        "isMask": false
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              -42.2439,
              -3.9267
            ],
            [
              -42.2358,
              -3.9594
            ],
            [
              -42.2295,
              -3.9736
            ],
            [
              -42.238,
              -3.9823
            ],
            [
              -42.2374,
              -3.9976
            ],
            [
              -42.2471,
              -3.9996
            ],
            [
              -42.2595,
              -4.0053
            ],
            [
              -42.2645,
              -4.0108
            ],
            [
              -42.2664,
              -4.025
            ],
            [
              -42.2619,
              -4.0278
            ],
            [
              -42.2581,
              -4.0492
            ],
            [
              -42.2638,
              -4.0547
            ],
            [
              -42.2564,
              -4.0628
            ],
            [
              -42.2573,
              -4.0733
            ],
            [
              -42.2545,
              -4.0778
            ],
            [
              -42.2638,
              -4.0895
            ],
            [
              -42.2589,
              -4.1046
            ],
            [
              -42.2575,
              -4.1157
            ],
            [
              -42.2598,
              -4.1223
            ],
            [
              -42.2509,
              -4.1268
            ],
            [
              -42.2536,
              -4.1414
            ],
            [
              -42.2625,
              -4.1503
            ],
            [
              -42.2612,
              -4.1562
            ],
            [
              -42.2667,
              -4.1609
            ],
            [
              -42.2634,
              -4.1703
            ],
            [
              -42.2489,
              -4.1618
            ],
            [
              -42.242,
              -4.1673
            ],
            [
              -42.234,
              -4.1949
            ],
            [
              -42.2388,
              -4.2015
            ],
            [
              -42.2397,
              -4.2121
            ],
            [
              -42.2354,
              -4.2177
            ],
            [
              -42.2376,
              -4.2241
            ],
            [
              -42.2275,
              -4.2273
            ],
            [
              -42.213,
              -4.2208
            ],
            [
              -42.2078,
              -4.2257
            ],
            [
              -42.193,
              -4.2169
            ],
            [
              -42.1834,
              -4.2208
            ],
            [
              -42.1723,
              -4.2174
            ],
            [
              -42.1563,
              -4.2202
            ],
            [
              -42.1425,
              -4.2168
            ],
            [
              -42.1337,
              -4.2171
            ],
            [
              -42.13,
              -4.2123
            ],
            [
              -42.1164,
              -4.207
            ],
            [
              -42.11,
              -4.2107
            ],
            [
              -42.0938,
              -4.2031
            ],
            [
              -42.0768,
              -4.2053
            ],
            [
              -42.0632,
              -4.1917
            ],
            [
              -42.0563,
              -4.191
            ],
            [
              -42.0511,
              -4.1811
            ],
            [
              -42.0154,
              -4.2
            ],
            [
              -41.9969,
              -4.2078
            ],
            [
              -41.9966,
              -4.2452
            ],
            [
              -41.9789,
              -4.2462
            ],
            [
              -41.964,
              -4.2341
            ],
            [
              -41.9544,
              -4.2207
            ],
            [
              -41.9332,
              -4.2259
            ],
            [
              -41.9189,
              -4.2239
            ],
            [
              -41.9213,
              -4.1841
            ],
            [
              -41.9328,
              -4.197
            ],
            [
              -41.8971,
              -4.0857
            ],
            [
              -41.9348,
              -4.0693
            ],
            [
              -41.92,
              -4.062
            ],
            [
              -41.9145,
              -4.0516
            ],
            [
              -41.9134,
              -4.0348
            ],
            [
              -41.9062,
              -4.0421
            ],
            [
              -41.8942,
              -4.0461
            ],
            [
              -41.8868,
              -4.0403
            ],
            [
              -41.8779,
              -4.0405
            ],
            [
              -41.8708,
              -4.0447
            ],
            [
              -41.8559,
              -4.0406
            ],
            [
              -41.8476,
              -3.9738
            ],
            [
              -41.9108,
              -3.9408
            ],
            [
              -41.9031,
              -3.8869
            ],
            [
              -41.8984,
              -3.7967
            ],
            [
              -41.9811,
              -3.784
            ],
            [
              -41.9816,
              -3.7738
            ],
            [
              -41.9753,
              -3.7649
            ],
            [
              -41.9754,
              -3.7541
            ],
            [
              -41.9785,
              -3.7309
            ],
            [
              -41.9758,
              -3.7228
            ],
            [
              -41.9754,
              -3.6969
            ],
            [
              -41.9733,
              -3.6898
            ],
            [
              -41.9621,
              -3.6793
            ],
            [
              -42.0503,
              -3.6803
            ],
            [
              -42.0503,
              -3.7913
            ],
            [
              -42.0351,
              -3.7913
            ],
            [
              -42.0246,
              -3.808
            ],
            [
              -42.0203,
              -3.8098
            ],
            [
              -42.0024,
              -3.8012
            ],
            [
              -41.995,
              -3.7995
            ],
            [
              -41.9868,
              -3.8059
            ],
            [
              -41.9798,
              -3.803
            ],
            [
              -41.974,
              -3.8095
            ],
            [
              -41.9878,
              -3.8232
            ],
            [
              -41.9891,
              -3.8314
            ],
            [
              -41.9839,
              -3.8395
            ],
            [
              -41.9772,
              -3.8433
            ],
            [
              -41.9798,
              -3.8511
            ],
            [
              -41.9785,
              -3.8603
            ],
            [
              -41.9911,
              -3.8705
            ],
            [
              -42.0091,
              -3.8749
            ],
            [
              -42.0272,
              -3.8744
            ],
            [
              -42.0441,
              -3.8767
            ],
            [
              -42.0519,
              -3.8859
            ],
            [
              -42.0677,
              -3.8861
            ],
            [
              -42.0625,
              -3.8951
            ],
            [
              -42.065,
              -3.905
            ],
            [
              -42.0724,
              -3.9181
            ],
            [
              -42.0923,
              -3.9158
            ],
            [
              -42.0982,
              -3.9108
            ],
            [
              -42.105,
              -3.9167
            ],
            [
              -42.1175,
              -3.9107
            ],
            [
              -42.1193,
              -3.8987
            ],
            [
              -42.1379,
              -3.9005
            ],
            [
              -42.1487,
              -3.9041
            ],
            [
              -42.1694,
              -3.8897
            ],
            [
              -42.1742,
              -3.8964
            ],
            [
              -42.1733,
              -3.9096
            ],
            [
              -42.1821,
              -3.913
            ],
            [
              -42.1871,
              -3.9058
            ],
            [
              -42.1946,
              -3.9095
            ],
            [
              -42.2044,
              -3.9189
            ],
            [
              -42.2119,
              -3.9156
            ],
            [
              -42.209,
              -3.9055
            ],
            [
              -42.2188,
              -3.8986
            ],
            [
              -42.2335,
              -3.9056
            ],
            [
              -42.2444,
              -3.9143
            ],
            [
              -42.2439,
              -3.9267
            ]
          ]
        ]
      },
      "properties": {
        "name": "Batalha",
        "codarea": "2201507",
        "isPiripiri": false,
        "isMask": false
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              -42.061,
              -4.434
            ],
            [
              -42.0584,
              -4.4035
            ],
            [
              -42.0793,
              -4.3742
            ],
            [
              -42.0269,
              -4.3542
            ],
            [
              -42.0005,
              -4.3441
            ],
            [
              -42.0005,
              -4.2722
            ],
            [
              -42.0113,
              -4.2674
            ],
            [
              -42.0306,
              -4.2667
            ],
            [
              -42.0415,
              -4.2714
            ],
            [
              -42.0635,
              -4.2739
            ],
            [
              -42.1002,
              -4.2706
            ],
            [
              -42.1112,
              -4.2661
            ],
            [
              -42.1221,
              -4.2667
            ],
            [
              -42.1252,
              -4.2735
            ],
            [
              -42.1333,
              -4.2721
            ],
            [
              -42.1548,
              -4.2742
            ],
            [
              -42.1606,
              -4.2709
            ],
            [
              -42.1786,
              -4.2696
            ],
            [
              -42.1946,
              -4.2709
            ],
            [
              -42.1868,
              -4.2777
            ],
            [
              -42.1852,
              -4.2867
            ],
            [
              -42.1935,
              -4.2974
            ],
            [
              -42.1841,
              -4.3075
            ],
            [
              -42.178,
              -4.3263
            ],
            [
              -42.1818,
              -4.3402
            ],
            [
              -42.1821,
              -4.3494
            ],
            [
              -42.1775,
              -4.3577
            ],
            [
              -42.1775,
              -4.3673
            ],
            [
              -42.1741,
              -4.3726
            ],
            [
              -42.1817,
              -4.3819
            ],
            [
              -42.1959,
              -4.3809
            ],
            [
              -42.1846,
              -4.391
            ],
            [
              -42.1768,
              -4.4012
            ],
            [
              -42.1816,
              -4.4112
            ],
            [
              -42.1792,
              -4.4163
            ],
            [
              -42.1674,
              -4.4235
            ],
            [
              -42.1658,
              -4.4374
            ],
            [
              -42.1668,
              -4.4516
            ],
            [
              -42.178,
              -4.4626
            ],
            [
              -42.1684,
              -4.464
            ],
            [
              -42.169,
              -4.4708
            ],
            [
              -42.1617,
              -4.4767
            ],
            [
              -42.1532,
              -4.4739
            ],
            [
              -42.1505,
              -4.4822
            ],
            [
              -42.061,
              -4.434
            ]
          ]
        ]
      },
      "properties": {
        "name": "Boa Hora",
        "codarea": "2201770",
        "isPiripiri": false,
        "isMask": false
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              -41.9213,
              -4.1841
            ],
            [
              -41.9214,
              -4.1814
            ],
            [
              -41.8045,
              -4.2022
            ],
            [
              -41.799,
              -4.1906
            ],
            [
              -41.7999,
              -4.1735
            ],
            [
              -41.7612,
              -4.2088
            ],
            [
              -41.6568,
              -4.2198
            ],
            [
              -41.5776,
              -4.1457
            ],
            [
              -41.5747,
              -4.1594
            ],
            [
              -41.5617,
              -4.1586
            ],
            [
              -41.5456,
              -4.1639
            ],
            [
              -41.5397,
              -4.1603
            ],
            [
              -41.5254,
              -4.1636
            ],
            [
              -41.5139,
              -4.175
            ],
            [
              -41.5038,
              -4.176
            ],
            [
              -41.4973,
              -4.1804
            ],
            [
              -41.4946,
              -4.1832
            ],
            [
              -41.4792,
              -4.1836
            ],
            [
              -41.4736,
              -4.1871
            ],
            [
              -41.4563,
              -4.1863
            ],
            [
              -41.4521,
              -4.192
            ],
            [
              -41.4396,
              -4.1817
            ],
            [
              -41.432,
              -4.1813
            ],
            [
              -41.4278,
              -4.174
            ],
            [
              -41.426,
              -4.1601
            ],
            [
              -41.4151,
              -4.1556
            ],
            [
              -41.41,
              -4.1485
            ],
            [
              -41.4002,
              -4.158
            ],
            [
              -41.3939,
              -4.1611
            ],
            [
              -41.3765,
              -4.1581
            ],
            [
              -41.3713,
              -4.1472
            ],
            [
              -41.3514,
              -4.1402
            ],
            [
              -41.3426,
              -4.1399
            ],
            [
              -41.3326,
              -4.1452
            ],
            [
              -41.3318,
              -4.1513
            ],
            [
              -41.313,
              -4.1472
            ],
            [
              -41.336,
              -4.0515
            ],
            [
              -41.4849,
              -4.0415
            ],
            [
              -41.5006,
              -4.0426
            ],
            [
              -41.5553,
              -4.0574
            ],
            [
              -41.6221,
              -4.0604
            ],
            [
              -41.6319,
              -4.1356
            ],
            [
              -41.7745,
              -4.1005
            ],
            [
              -41.7607,
              -4.0975
            ],
            [
              -41.7502,
              -4.0791
            ],
            [
              -41.738,
              -4.0719
            ],
            [
              -41.7364,
              -4.0635
            ],
            [
              -41.7379,
              -4.0453
            ],
            [
              -41.7718,
              -4.034
            ],
            [
              -41.8558,
              -4.0423
            ],
            [
              -41.8559,
              -4.0406
            ],
            [
              -41.8708,
              -4.0447
            ],
            [
              -41.8779,
              -4.0405
            ],
            [
              -41.8868,
              -4.0403
            ],
            [
              -41.8942,
              -4.0461
            ],
            [
              -41.9062,
              -4.0421
            ],
            [
              -41.9134,
              -4.0348
            ],
            [
              -41.9145,
              -4.0516
            ],
            [
              -41.92,
              -4.062
            ],
            [
              -41.9348,
              -4.0693
            ],
            [
              -41.8971,
              -4.0857
            ],
            [
              -41.9328,
              -4.197
            ],
            [
              -41.9213,
              -4.1841
            ]
          ]
        ]
      },
      "properties": {
        "name": "Brasileira",
        "codarea": "2201960",
        "isPiripiri": false,
        "isMask": false
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              -42.0346,
              -4.5292
            ],
            [
              -42.0131,
              -4.5295
            ],
            [
              -41.9875,
              -4.5282
            ],
            [
              -41.964,
              -4.5293
            ],
            [
              -41.9218,
              -4.5439
            ],
            [
              -41.8954,
              -4.5693
            ],
            [
              -41.8792,
              -4.5901
            ],
            [
              -41.8603,
              -4.6046
            ],
            [
              -41.8402,
              -4.6246
            ],
            [
              -41.8501,
              -4.6313
            ],
            [
              -41.8569,
              -4.6431
            ],
            [
              -41.857,
              -4.6634
            ],
            [
              -41.8643,
              -4.6805
            ],
            [
              -41.8799,
              -4.6805
            ],
            [
              -41.8188,
              -4.6971
            ],
            [
              -41.778,
              -4.6921
            ],
            [
              -41.7768,
              -4.6888
            ],
            [
              -41.7453,
              -4.5904
            ],
            [
              -41.7393,
              -4.5699
            ],
            [
              -41.7556,
              -4.545
            ],
            [
              -41.7666,
              -4.5364
            ],
            [
              -41.7799,
              -4.5321
            ],
            [
              -41.7812,
              -4.5221
            ],
            [
              -41.7932,
              -4.5113
            ],
            [
              -41.8073,
              -4.51
            ],
            [
              -41.8113,
              -4.5049
            ],
            [
              -41.8198,
              -4.5025
            ],
            [
              -41.8204,
              -4.497
            ],
            [
              -41.8345,
              -4.4815
            ],
            [
              -41.8367,
              -4.4711
            ],
            [
              -41.8497,
              -4.4599
            ],
            [
              -41.8604,
              -4.4626
            ],
            [
              -41.8739,
              -4.4576
            ],
            [
              -41.8801,
              -4.4498
            ],
            [
              -41.8886,
              -4.4473
            ],
            [
              -41.8903,
              -4.4356
            ],
            [
              -41.8983,
              -4.4335
            ],
            [
              -41.9026,
              -4.4278
            ],
            [
              -41.9189,
              -4.4317
            ],
            [
              -41.9291,
              -4.432
            ],
            [
              -41.9412,
              -4.4235
            ],
            [
              -41.9587,
              -4.4246
            ],
            [
              -41.9669,
              -4.4155
            ],
            [
              -41.9679,
              -4.4047
            ],
            [
              -41.9875,
              -4.3948
            ],
            [
              -41.9905,
              -4.3889
            ],
            [
              -42.0079,
              -4.3808
            ],
            [
              -42.0125,
              -4.3844
            ],
            [
              -42.0193,
              -4.3811
            ],
            [
              -42.0216,
              -4.3721
            ],
            [
              -42.0164,
              -4.367
            ],
            [
              -42.0269,
              -4.3542
            ],
            [
              -42.0793,
              -4.3742
            ],
            [
              -42.0584,
              -4.4035
            ],
            [
              -42.061,
              -4.434
            ],
            [
              -42.0497,
              -4.4528
            ],
            [
              -42.0574,
              -4.464
            ],
            [
              -42.0557,
              -4.5278
            ],
            [
              -42.0346,
              -4.5292
            ]
          ]
        ]
      },
      "properties": {
        "name": "Capitão de Campos",
        "codarea": "2202406",
        "isPiripiri": false,
        "isMask": false
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              -41.313,
              -4.1472
            ],
            [
              -41.3318,
              -4.1513
            ],
            [
              -41.3326,
              -4.1452
            ],
            [
              -41.3426,
              -4.1399
            ],
            [
              -41.3514,
              -4.1402
            ],
            [
              -41.3713,
              -4.1472
            ],
            [
              -41.3765,
              -4.1581
            ],
            [
              -41.3939,
              -4.1611
            ],
            [
              -41.4002,
              -4.158
            ],
            [
              -41.41,
              -4.1485
            ],
            [
              -41.4151,
              -4.1556
            ],
            [
              -41.426,
              -4.1601
            ],
            [
              -41.4278,
              -4.174
            ],
            [
              -41.432,
              -4.1813
            ],
            [
              -41.4396,
              -4.1817
            ],
            [
              -41.4521,
              -4.192
            ],
            [
              -41.4563,
              -4.1863
            ],
            [
              -41.4736,
              -4.1871
            ],
            [
              -41.4792,
              -4.1836
            ],
            [
              -41.4946,
              -4.1832
            ],
            [
              -41.4973,
              -4.1804
            ],
            [
              -41.525,
              -4.2567
            ],
            [
              -41.495,
              -4.2745
            ],
            [
              -41.4876,
              -4.3037
            ],
            [
              -41.4532,
              -4.3013
            ],
            [
              -41.4153,
              -4.311
            ],
            [
              -41.414,
              -4.3147
            ],
            [
              -41.4275,
              -4.3211
            ],
            [
              -41.4184,
              -4.3482
            ],
            [
              -41.399,
              -4.3885
            ],
            [
              -41.3877,
              -4.4325
            ],
            [
              -41.3807,
              -4.4335
            ],
            [
              -41.363,
              -4.3384
            ],
            [
              -41.3568,
              -4.3429
            ],
            [
              -41.2405,
              -4.3757
            ],
            [
              -41.229,
              -4.3404
            ],
            [
              -41.1194,
              -4.3243
            ],
            [
              -41.1191,
              -4.3065
            ],
            [
              -41.1359,
              -4.2335
            ],
            [
              -41.0991,
              -4.1818
            ],
            [
              -41.0981,
              -4.1805
            ],
            [
              -41.1224,
              -4.1759
            ],
            [
              -41.135,
              -4.1768
            ],
            [
              -41.1426,
              -4.1857
            ],
            [
              -41.1651,
              -4.1876
            ],
            [
              -41.1769,
              -4.1766
            ],
            [
              -41.1768,
              -4.1691
            ],
            [
              -41.1833,
              -4.1584
            ],
            [
              -41.1873,
              -4.1606
            ],
            [
              -41.1962,
              -4.1476
            ],
            [
              -41.2044,
              -4.1461
            ],
            [
              -41.2135,
              -4.156
            ],
            [
              -41.2237,
              -4.1582
            ],
            [
              -41.2333,
              -4.1563
            ],
            [
              -41.2413,
              -4.1452
            ],
            [
              -41.2496,
              -4.1385
            ],
            [
              -41.259,
              -4.1468
            ],
            [
              -41.2657,
              -4.161
            ],
            [
              -41.2809,
              -4.17
            ],
            [
              -41.2946,
              -4.1658
            ],
            [
              -41.297,
              -4.1565
            ],
            [
              -41.3031,
              -4.1548
            ],
            [
              -41.305,
              -4.148
            ],
            [
              -41.313,
              -4.1472
            ]
          ]
        ]
      },
      "properties": {
        "name": "Domingos Mourão",
        "codarea": "2203420",
        "isPiripiri": false,
        "isMask": false
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              -41.6053,
              -4.4095
            ],
            [
              -41.5972,
              -4.4054
            ],
            [
              -41.5887,
              -4.4156
            ],
            [
              -41.5801,
              -4.4132
            ],
            [
              -41.568,
              -4.4148
            ],
            [
              -41.5647,
              -4.4097
            ],
            [
              -41.5496,
              -4.4047
            ],
            [
              -41.5442,
              -4.4075
            ],
            [
              -41.5349,
              -4.4044
            ],
            [
              -41.529,
              -4.4106
            ],
            [
              -41.5204,
              -4.406
            ],
            [
              -41.5187,
              -4.3997
            ],
            [
              -41.5109,
              -4.4003
            ],
            [
              -41.5057,
              -4.3887
            ],
            [
              -41.5061,
              -4.3747
            ],
            [
              -41.5015,
              -4.3573
            ],
            [
              -41.5108,
              -4.3482
            ],
            [
              -41.513,
              -4.3316
            ],
            [
              -41.5302,
              -4.3317
            ],
            [
              -41.5368,
              -4.321
            ],
            [
              -41.5414,
              -4.3288
            ],
            [
              -41.5503,
              -4.3209
            ],
            [
              -41.5594,
              -4.3188
            ],
            [
              -41.5608,
              -4.3103
            ],
            [
              -41.5687,
              -4.3062
            ],
            [
              -41.5786,
              -4.3093
            ],
            [
              -41.5823,
              -4.3037
            ],
            [
              -41.5937,
              -4.3022
            ],
            [
              -41.5966,
              -4.2952
            ],
            [
              -41.6084,
              -4.3018
            ],
            [
              -41.6065,
              -4.3108
            ],
            [
              -41.6165,
              -4.318
            ],
            [
              -41.6128,
              -4.3264
            ],
            [
              -41.6173,
              -4.3389
            ],
            [
              -41.6274,
              -4.34
            ],
            [
              -41.6365,
              -4.35
            ],
            [
              -41.6418,
              -4.3462
            ],
            [
              -41.6482,
              -4.3484
            ],
            [
              -41.6547,
              -4.3446
            ],
            [
              -41.6646,
              -4.3458
            ],
            [
              -41.6674,
              -4.3538
            ],
            [
              -41.6577,
              -4.3839
            ],
            [
              -41.6585,
              -4.3953
            ],
            [
              -41.6414,
              -4.4092
            ],
            [
              -41.6337,
              -4.4065
            ],
            [
              -41.6268,
              -4.4091
            ],
            [
              -41.6117,
              -4.4055
            ],
            [
              -41.6053,
              -4.4095
            ]
          ]
        ]
      },
      "properties": {
        "name": "Lagoa de São Francisco",
        "codarea": "2205573",
        "isPiripiri": false,
        "isMask": false
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              -41.6548,
              -4.7763
            ],
            [
              -41.6187,
              -4.7601
            ],
            [
              -41.5962,
              -4.7557
            ],
            [
              -41.5601,
              -4.745
            ],
            [
              -41.5566,
              -4.7505
            ],
            [
              -41.5572,
              -4.7518
            ],
            [
              -41.5558,
              -4.7527
            ],
            [
              -41.5554,
              -4.7539
            ],
            [
              -41.5559,
              -4.7565
            ],
            [
              -41.5537,
              -4.7572
            ],
            [
              -41.5528,
              -4.7558
            ],
            [
              -41.5514,
              -4.7556
            ],
            [
              -41.5496,
              -4.7559
            ],
            [
              -41.5472,
              -4.7571
            ],
            [
              -41.5449,
              -4.7578
            ],
            [
              -41.5433,
              -4.7593
            ],
            [
              -41.5427,
              -4.762
            ],
            [
              -41.5428,
              -4.7638
            ],
            [
              -41.544,
              -4.7658
            ],
            [
              -41.5395,
              -4.7848
            ],
            [
              -41.5253,
              -4.8283
            ],
            [
              -41.4937,
              -4.8284
            ],
            [
              -41.4729,
              -4.8335
            ],
            [
              -41.451,
              -4.8255
            ],
            [
              -41.4442,
              -4.8412
            ],
            [
              -41.4348,
              -4.8611
            ],
            [
              -41.4124,
              -4.8751
            ],
            [
              -41.384,
              -4.8839
            ],
            [
              -41.3762,
              -4.8786
            ],
            [
              -41.3706,
              -4.8735
            ],
            [
              -41.3681,
              -4.8724
            ],
            [
              -41.3663,
              -4.8724
            ],
            [
              -41.3626,
              -4.8705
            ],
            [
              -41.3576,
              -4.8671
            ],
            [
              -41.3548,
              -4.8661
            ],
            [
              -41.3522,
              -4.8656
            ],
            [
              -41.3477,
              -4.8652
            ],
            [
              -41.3404,
              -4.8682
            ],
            [
              -41.3373,
              -4.8691
            ],
            [
              -41.3339,
              -4.8688
            ],
            [
              -41.3318,
              -4.8678
            ],
            [
              -41.3303,
              -4.8681
            ],
            [
              -41.3276,
              -4.8698
            ],
            [
              -41.3262,
              -4.8713
            ],
            [
              -41.325,
              -4.8713
            ],
            [
              -41.3211,
              -4.8684
            ],
            [
              -41.3164,
              -4.868
            ],
            [
              -41.3138,
              -4.868
            ],
            [
              -41.3119,
              -4.867
            ],
            [
              -41.3104,
              -4.8631
            ],
            [
              -41.3073,
              -4.8593
            ],
            [
              -41.3064,
              -4.8562
            ],
            [
              -41.305,
              -4.8529
            ],
            [
              -41.3029,
              -4.8494
            ],
            [
              -41.2955,
              -4.8527
            ],
            [
              -41.2924,
              -4.8551
            ],
            [
              -41.2893,
              -4.8606
            ],
            [
              -41.2884,
              -4.8603
            ],
            [
              -41.2865,
              -4.8565
            ],
            [
              -41.2841,
              -4.8547
            ],
            [
              -41.2784,
              -4.8534
            ],
            [
              -41.268,
              -4.8116
            ],
            [
              -41.2952,
              -4.8149
            ],
            [
              -41.294,
              -4.6296
            ],
            [
              -41.2935,
              -4.5561
            ],
            [
              -41.3409,
              -4.5615
            ],
            [
              -41.4334,
              -4.5718
            ],
            [
              -41.4858,
              -4.5777
            ],
            [
              -41.5122,
              -4.5807
            ],
            [
              -41.5867,
              -4.5838
            ],
            [
              -41.7294,
              -4.5898
            ],
            [
              -41.7453,
              -4.5904
            ],
            [
              -41.7768,
              -4.6888
            ],
            [
              -41.7469,
              -4.7029
            ],
            [
              -41.7466,
              -4.7033
            ],
            [
              -41.6992,
              -4.7614
            ],
            [
              -41.6954,
              -4.7659
            ],
            [
              -41.6896,
              -4.7642
            ],
            [
              -41.6548,
              -4.7763
            ]
          ]
        ]
      },
      "properties": {
        "name": "Milton Brandão",
        "codarea": "2206357",
        "isPiripiri": false,
        "isMask": false
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              -41.7453,
              -4.5904
            ],
            [
              -41.5122,
              -4.5807
            ],
            [
              -41.2935,
              -4.5561
            ],
            [
              -41.294,
              -4.6296
            ],
            [
              -41.2952,
              -4.8149
            ],
            [
              -41.268,
              -4.8116
            ],
            [
              -41.2597,
              -4.8086
            ],
            [
              -41.2559,
              -4.8006
            ],
            [
              -41.2332,
              -4.8101
            ],
            [
              -41.2325,
              -4.8045
            ],
            [
              -41.2254,
              -4.7978
            ],
            [
              -41.224,
              -4.7907
            ],
            [
              -41.2081,
              -4.7803
            ],
            [
              -41.2128,
              -4.772
            ],
            [
              -41.2339,
              -4.7688
            ],
            [
              -41.2478,
              -4.7618
            ],
            [
              -41.2503,
              -4.7566
            ],
            [
              -41.2352,
              -4.7465
            ],
            [
              -41.2367,
              -4.7388
            ],
            [
              -41.226,
              -4.7265
            ],
            [
              -41.2238,
              -4.7209
            ],
            [
              -41.2025,
              -4.7019
            ],
            [
              -41.1811,
              -4.6732
            ],
            [
              -41.1754,
              -4.6708
            ],
            [
              -41.1856,
              -4.662
            ],
            [
              -41.2028,
              -4.6382
            ],
            [
              -41.2293,
              -4.6201
            ],
            [
              -41.2334,
              -4.6102
            ],
            [
              -41.223,
              -4.5898
            ],
            [
              -41.222,
              -4.5778
            ],
            [
              -41.2398,
              -4.5736
            ],
            [
              -41.2354,
              -4.5702
            ],
            [
              -41.2215,
              -4.5675
            ],
            [
              -41.2141,
              -4.5527
            ],
            [
              -41.2084,
              -4.5488
            ],
            [
              -41.2038,
              -4.5284
            ],
            [
              -41.1908,
              -4.5155
            ],
            [
              -41.1879,
              -4.4861
            ],
            [
              -41.1776,
              -4.4677
            ],
            [
              -41.1785,
              -4.4594
            ],
            [
              -41.1752,
              -4.4495
            ],
            [
              -41.1774,
              -4.4433
            ],
            [
              -41.1651,
              -4.4226
            ],
            [
              -41.1597,
              -4.4106
            ],
            [
              -41.159,
              -4.3921
            ],
            [
              -41.1618,
              -4.3873
            ],
            [
              -41.158,
              -4.3787
            ],
            [
              -41.1491,
              -4.3672
            ],
            [
              -41.1421,
              -4.359
            ],
            [
              -41.1334,
              -4.3401
            ],
            [
              -41.1202,
              -4.3306
            ],
            [
              -41.1194,
              -4.3243
            ],
            [
              -41.229,
              -4.3404
            ],
            [
              -41.2405,
              -4.3757
            ],
            [
              -41.3568,
              -4.3429
            ],
            [
              -41.363,
              -4.3384
            ],
            [
              -41.3807,
              -4.4335
            ],
            [
              -41.3877,
              -4.4325
            ],
            [
              -41.399,
              -4.3885
            ],
            [
              -41.4184,
              -4.3482
            ],
            [
              -41.4275,
              -4.3211
            ],
            [
              -41.414,
              -4.3147
            ],
            [
              -41.4153,
              -4.311
            ],
            [
              -41.4532,
              -4.3013
            ],
            [
              -41.4876,
              -4.3037
            ],
            [
              -41.495,
              -4.2745
            ],
            [
              -41.525,
              -4.2567
            ],
            [
              -41.5608,
              -4.3103
            ],
            [
              -41.5594,
              -4.3188
            ],
            [
              -41.5503,
              -4.3209
            ],
            [
              -41.5414,
              -4.3288
            ],
            [
              -41.5368,
              -4.321
            ],
            [
              -41.5302,
              -4.3317
            ],
            [
              -41.513,
              -4.3316
            ],
            [
              -41.5108,
              -4.3482
            ],
            [
              -41.5015,
              -4.3573
            ],
            [
              -41.5061,
              -4.3747
            ],
            [
              -41.5057,
              -4.3887
            ],
            [
              -41.5109,
              -4.4003
            ],
            [
              -41.5187,
              -4.3997
            ],
            [
              -41.5204,
              -4.406
            ],
            [
              -41.529,
              -4.4106
            ],
            [
              -41.5349,
              -4.4044
            ],
            [
              -41.5442,
              -4.4075
            ],
            [
              -41.5496,
              -4.4047
            ],
            [
              -41.5647,
              -4.4097
            ],
            [
              -41.568,
              -4.4148
            ],
            [
              -41.5801,
              -4.4132
            ],
            [
              -41.5887,
              -4.4156
            ],
            [
              -41.5972,
              -4.4054
            ],
            [
              -41.6053,
              -4.4095
            ],
            [
              -41.6211,
              -4.4389
            ],
            [
              -41.6387,
              -4.4632
            ],
            [
              -41.7303,
              -4.5473
            ],
            [
              -41.7393,
              -4.5699
            ],
            [
              -41.7453,
              -4.5904
            ]
          ]
        ]
      },
      "properties": {
        "name": "Pedro II",
        "codarea": "2207900",
        "isPiripiri": false,
        "isMask": false
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              -41.8559,
              -4.0406
            ],
            [
              -41.8558,
              -4.0423
            ],
            [
              -41.7718,
              -4.034
            ],
            [
              -41.7379,
              -4.0453
            ],
            [
              -41.7364,
              -4.0635
            ],
            [
              -41.738,
              -4.0719
            ],
            [
              -41.7502,
              -4.0791
            ],
            [
              -41.7607,
              -4.0975
            ],
            [
              -41.7745,
              -4.1005
            ],
            [
              -41.6319,
              -4.1356
            ],
            [
              -41.6221,
              -4.0604
            ],
            [
              -41.5553,
              -4.0574
            ],
            [
              -41.5006,
              -4.0426
            ],
            [
              -41.4849,
              -4.0415
            ],
            [
              -41.3659,
              -3.8848
            ],
            [
              -41.2786,
              -3.77
            ],
            [
              -41.3133,
              -3.7394
            ],
            [
              -41.3347,
              -3.6915
            ],
            [
              -41.3358,
              -3.7013
            ],
            [
              -41.3524,
              -3.6999
            ],
            [
              -41.3602,
              -3.7094
            ],
            [
              -41.371,
              -3.7147
            ],
            [
              -41.3759,
              -3.712
            ],
            [
              -41.4007,
              -3.7305
            ],
            [
              -41.4181,
              -3.7535
            ],
            [
              -41.4498,
              -3.7424
            ],
            [
              -41.4487,
              -3.7024
            ],
            [
              -41.4576,
              -3.6698
            ],
            [
              -41.4873,
              -3.6539
            ],
            [
              -41.5066,
              -3.6308
            ],
            [
              -41.5242,
              -3.6058
            ],
            [
              -41.6491,
              -3.64
            ],
            [
              -41.678,
              -3.6647
            ],
            [
              -41.7455,
              -3.6726
            ],
            [
              -41.7466,
              -3.5865
            ],
            [
              -41.7729,
              -3.5727
            ],
            [
              -41.7943,
              -3.6241
            ],
            [
              -41.8666,
              -3.7209
            ],
            [
              -41.8298,
              -3.7534
            ],
            [
              -41.8183,
              -3.7534
            ],
            [
              -41.7131,
              -3.771
            ],
            [
              -41.6866,
              -3.7815
            ],
            [
              -41.6864,
              -3.797
            ],
            [
              -41.8355,
              -3.8484
            ],
            [
              -41.8656,
              -3.8483
            ],
            [
              -41.9031,
              -3.8869
            ],
            [
              -41.9108,
              -3.9408
            ],
            [
              -41.8476,
              -3.9738
            ],
            [
              -41.8559,
              -4.0406
            ]
          ]
        ]
      },
      "properties": {
        "name": "Piracuruca",
        "codarea": "2208304",
        "isPiripiri": false,
        "isMask": false
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              -41.6053,
              -4.4095
            ],
            [
              -41.6117,
              -4.4055
            ],
            [
              -41.6268,
              -4.4091
            ],
            [
              -41.6337,
              -4.4065
            ],
            [
              -41.6414,
              -4.4092
            ],
            [
              -41.6585,
              -4.3953
            ],
            [
              -41.6577,
              -4.3839
            ],
            [
              -41.6674,
              -4.3538
            ],
            [
              -41.6646,
              -4.3458
            ],
            [
              -41.6547,
              -4.3446
            ],
            [
              -41.6482,
              -4.3484
            ],
            [
              -41.6418,
              -4.3462
            ],
            [
              -41.6365,
              -4.35
            ],
            [
              -41.6274,
              -4.34
            ],
            [
              -41.6173,
              -4.3389
            ],
            [
              -41.6128,
              -4.3264
            ],
            [
              -41.6165,
              -4.318
            ],
            [
              -41.6065,
              -4.3108
            ],
            [
              -41.6084,
              -4.3018
            ],
            [
              -41.5966,
              -4.2952
            ],
            [
              -41.5937,
              -4.3022
            ],
            [
              -41.5823,
              -4.3037
            ],
            [
              -41.5786,
              -4.3093
            ],
            [
              -41.5687,
              -4.3062
            ],
            [
              -41.5608,
              -4.3103
            ],
            [
              -41.525,
              -4.2567
            ],
            [
              -41.4973,
              -4.1804
            ],
            [
              -41.5038,
              -4.176
            ],
            [
              -41.5139,
              -4.175
            ],
            [
              -41.5254,
              -4.1636
            ],
            [
              -41.5397,
              -4.1603
            ],
            [
              -41.5456,
              -4.1639
            ],
            [
              -41.5617,
              -4.1586
            ],
            [
              -41.5747,
              -4.1594
            ],
            [
              -41.5776,
              -4.1457
            ],
            [
              -41.6568,
              -4.2198
            ],
            [
              -41.7612,
              -4.2088
            ],
            [
              -41.7999,
              -4.1735
            ],
            [
              -41.799,
              -4.1906
            ],
            [
              -41.8045,
              -4.2022
            ],
            [
              -41.9214,
              -4.1814
            ],
            [
              -41.9213,
              -4.1841
            ],
            [
              -41.9189,
              -4.2239
            ],
            [
              -41.9332,
              -4.2259
            ],
            [
              -41.9544,
              -4.2207
            ],
            [
              -41.964,
              -4.2341
            ],
            [
              -41.9789,
              -4.2462
            ],
            [
              -41.9966,
              -4.2452
            ],
            [
              -42.0005,
              -4.2722
            ],
            [
              -42.0005,
              -4.3441
            ],
            [
              -42.0269,
              -4.3542
            ],
            [
              -42.0164,
              -4.367
            ],
            [
              -42.0216,
              -4.3721
            ],
            [
              -42.0193,
              -4.3811
            ],
            [
              -42.0125,
              -4.3844
            ],
            [
              -42.0079,
              -4.3808
            ],
            [
              -41.9905,
              -4.3889
            ],
            [
              -41.9875,
              -4.3948
            ],
            [
              -41.9679,
              -4.4047
            ],
            [
              -41.9669,
              -4.4155
            ],
            [
              -41.9587,
              -4.4246
            ],
            [
              -41.9412,
              -4.4235
            ],
            [
              -41.9291,
              -4.432
            ],
            [
              -41.9189,
              -4.4317
            ],
            [
              -41.9026,
              -4.4278
            ],
            [
              -41.8983,
              -4.4335
            ],
            [
              -41.8903,
              -4.4356
            ],
            [
              -41.8886,
              -4.4473
            ],
            [
              -41.8801,
              -4.4498
            ],
            [
              -41.8739,
              -4.4576
            ],
            [
              -41.8604,
              -4.4626
            ],
            [
              -41.8497,
              -4.4599
            ],
            [
              -41.8367,
              -4.4711
            ],
            [
              -41.8345,
              -4.4815
            ],
            [
              -41.8204,
              -4.497
            ],
            [
              -41.8198,
              -4.5025
            ],
            [
              -41.8113,
              -4.5049
            ],
            [
              -41.8073,
              -4.51
            ],
            [
              -41.7932,
              -4.5113
            ],
            [
              -41.7812,
              -4.5221
            ],
            [
              -41.7799,
              -4.5321
            ],
            [
              -41.7666,
              -4.5364
            ],
            [
              -41.7556,
              -4.545
            ],
            [
              -41.7393,
              -4.5699
            ],
            [
              -41.7303,
              -4.5473
            ],
            [
              -41.6387,
              -4.4632
            ],
            [
              -41.6211,
              -4.4389
            ],
            [
              -41.6053,
              -4.4095
            ]
          ]
        ]
      },
      "properties": {
        "name": "Piripiri",
        "codarea": "2208403",
        "isPiripiri": true,
        "isMask": false
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              -41.313,
              -4.1472
            ],
            [
              -41.3096,
              -4.1441
            ],
            [
              -41.3071,
              -4.147
            ],
            [
              -41.305,
              -4.148
            ],
            [
              -41.3024,
              -4.147
            ],
            [
              -41.3019,
              -4.1483
            ],
            [
              -41.3022,
              -4.1517
            ],
            [
              -41.3031,
              -4.1548
            ],
            [
              -41.3021,
              -4.1569
            ],
            [
              -41.3011,
              -4.1567
            ],
            [
              -41.2994,
              -4.1554
            ],
            [
              -41.297,
              -4.1565
            ],
            [
              -41.2966,
              -4.1598
            ],
            [
              -41.2958,
              -4.1633
            ],
            [
              -41.2946,
              -4.1658
            ],
            [
              -41.295,
              -4.1675
            ],
            [
              -41.2941,
              -4.1682
            ],
            [
              -41.2929,
              -4.1676
            ],
            [
              -41.2909,
              -4.1689
            ],
            [
              -41.285,
              -4.1694
            ],
            [
              -41.2809,
              -4.17
            ],
            [
              -41.2792,
              -4.169
            ],
            [
              -41.277,
              -4.1686
            ],
            [
              -41.2766,
              -4.1667
            ],
            [
              -41.2713,
              -4.1654
            ],
            [
              -41.2674,
              -4.1631
            ],
            [
              -41.2657,
              -4.161
            ],
            [
              -41.2631,
              -4.1618
            ],
            [
              -41.2624,
              -4.1595
            ],
            [
              -41.2624,
              -4.157
            ],
            [
              -41.2619,
              -4.1554
            ],
            [
              -41.2622,
              -4.1541
            ],
            [
              -41.2611,
              -4.152
            ],
            [
              -41.2604,
              -4.1493
            ],
            [
              -41.2596,
              -4.1486
            ],
            [
              -41.259,
              -4.1468
            ],
            [
              -41.2597,
              -4.1457
            ],
            [
              -41.2594,
              -4.1445
            ],
            [
              -41.2581,
              -4.1439
            ],
            [
              -41.2567,
              -4.1424
            ],
            [
              -41.255,
              -4.1431
            ],
            [
              -41.2535,
              -4.1415
            ],
            [
              -41.2523,
              -4.1411
            ],
            [
              -41.2496,
              -4.1385
            ],
            [
              -41.2477,
              -4.1387
            ],
            [
              -41.2451,
              -4.1407
            ],
            [
              -41.2451,
              -4.1417
            ],
            [
              -41.2413,
              -4.1452
            ],
            [
              -41.2408,
              -4.1472
            ],
            [
              -41.2392,
              -4.1497
            ],
            [
              -41.2393,
              -4.1511
            ],
            [
              -41.2375,
              -4.1525
            ],
            [
              -41.2366,
              -4.1539
            ],
            [
              -41.2333,
              -4.1563
            ],
            [
              -41.2316,
              -4.1569
            ],
            [
              -41.2303,
              -4.1567
            ],
            [
              -41.229,
              -4.1553
            ],
            [
              -41.2276,
              -4.1554
            ],
            [
              -41.2263,
              -4.1563
            ],
            [
              -41.2249,
              -4.1582
            ],
            [
              -41.2237,
              -4.1582
            ],
            [
              -41.2222,
              -4.1558
            ],
            [
              -41.2184,
              -4.1567
            ],
            [
              -41.2173,
              -4.1574
            ],
            [
              -41.2153,
              -4.157
            ],
            [
              -41.2135,
              -4.156
            ],
            [
              -41.211,
              -4.1536
            ],
            [
              -41.2095,
              -4.1513
            ],
            [
              -41.209,
              -4.1497
            ],
            [
              -41.2093,
              -4.1469
            ],
            [
              -41.207,
              -4.1469
            ],
            [
              -41.2044,
              -4.1461
            ],
            [
              -41.2036,
              -4.1472
            ],
            [
              -41.2023,
              -4.1469
            ],
            [
              -41.2012,
              -4.1484
            ],
            [
              -41.1999,
              -4.1487
            ],
            [
              -41.1977,
              -4.1475
            ],
            [
              -41.1962,
              -4.1476
            ],
            [
              -41.1959,
              -4.1497
            ],
            [
              -41.1937,
              -4.1523
            ],
            [
              -41.1933,
              -4.1538
            ],
            [
              -41.1918,
              -4.1548
            ],
            [
              -41.1901,
              -4.1551
            ],
            [
              -41.1908,
              -4.1571
            ],
            [
              -41.1903,
              -4.1593
            ],
            [
              -41.1873,
              -4.1606
            ],
            [
              -41.1853,
              -4.1599
            ],
            [
              -41.1833,
              -4.1584
            ],
            [
              -41.181,
              -4.1607
            ],
            [
              -41.1814,
              -4.1621
            ],
            [
              -41.1808,
              -4.1637
            ],
            [
              -41.1798,
              -4.1645
            ],
            [
              -41.179,
              -4.1663
            ],
            [
              -41.1768,
              -4.1691
            ],
            [
              -41.1759,
              -4.1726
            ],
            [
              -41.1762,
              -4.1737
            ],
            [
              -41.1775,
              -4.1751
            ],
            [
              -41.1769,
              -4.1766
            ],
            [
              -41.1744,
              -4.1784
            ],
            [
              -41.1703,
              -4.1803
            ],
            [
              -41.1687,
              -4.1828
            ],
            [
              -41.1651,
              -4.1876
            ],
            [
              -41.1639,
              -4.1883
            ],
            [
              -41.1615,
              -4.1882
            ],
            [
              -41.1594,
              -4.1866
            ],
            [
              -41.1579,
              -4.1864
            ],
            [
              -41.1556,
              -4.1889
            ],
            [
              -41.1546,
              -4.1887
            ],
            [
              -41.1526,
              -4.1874
            ],
            [
              -41.1511,
              -4.1872
            ],
            [
              -41.1497,
              -4.1856
            ],
            [
              -41.147,
              -4.1858
            ],
            [
              -41.145,
              -4.1854
            ],
            [
              -41.1438,
              -4.186
            ],
            [
              -41.1426,
              -4.1857
            ],
            [
              -41.1402,
              -4.1828
            ],
            [
              -41.139,
              -4.1817
            ],
            [
              -41.1359,
              -4.1774
            ],
            [
              -41.135,
              -4.1768
            ],
            [
              -41.131,
              -4.1767
            ],
            [
              -41.1295,
              -4.1772
            ],
            [
              -41.128,
              -4.1764
            ],
            [
              -41.1258,
              -4.176
            ],
            [
              -41.1241,
              -4.1762
            ],
            [
              -41.1224,
              -4.1759
            ],
            [
              -41.1206,
              -4.1775
            ],
            [
              -41.1185,
              -4.1773
            ],
            [
              -41.1159,
              -4.1765
            ],
            [
              -41.1137,
              -4.178
            ],
            [
              -41.1114,
              -4.1791
            ],
            [
              -41.1095,
              -4.1795
            ],
            [
              -41.1069,
              -4.1791
            ],
            [
              -41.1058,
              -4.1797
            ],
            [
              -41.1036,
              -4.1798
            ],
            [
              -41.1017,
              -4.1804
            ],
            [
              -41.0981,
              -4.1805
            ],
            [
              -41.0909,
              -4.1703
            ],
            [
              -41.0939,
              -4.1699
            ],
            [
              -41.097,
              -4.1707
            ],
            [
              -41.1058,
              -4.1696
            ],
            [
              -41.1113,
              -4.1669
            ],
            [
              -41.1176,
              -4.1657
            ],
            [
              -41.1183,
              -4.1652
            ],
            [
              -41.121,
              -4.1605
            ],
            [
              -41.1231,
              -4.1582
            ],
            [
              -41.1237,
              -4.1562
            ],
            [
              -41.1254,
              -4.1545
            ],
            [
              -41.1268,
              -4.1507
            ],
            [
              -41.1258,
              -4.1485
            ],
            [
              -41.1253,
              -4.1449
            ],
            [
              -41.1281,
              -4.1393
            ],
            [
              -41.1343,
              -4.1317
            ],
            [
              -41.1421,
              -4.1256
            ],
            [
              -41.1431,
              -4.1242
            ],
            [
              -41.1408,
              -4.1236
            ],
            [
              -41.1394,
              -4.121
            ],
            [
              -41.1371,
              -4.1169
            ],
            [
              -41.1344,
              -4.1049
            ],
            [
              -41.1289,
              -4.0973
            ],
            [
              -41.1281,
              -4.0942
            ],
            [
              -41.1276,
              -4.0887
            ],
            [
              -41.1222,
              -4.0772
            ],
            [
              -41.1216,
              -4.0742
            ],
            [
              -41.122,
              -4.0722
            ],
            [
              -41.1275,
              -4.0661
            ],
            [
              -41.1279,
              -4.0639
            ],
            [
              -41.1272,
              -4.0614
            ],
            [
              -41.1258,
              -4.0603
            ],
            [
              -41.1164,
              -4.0541
            ],
            [
              -41.1141,
              -4.0518
            ],
            [
              -41.1132,
              -4.0498
            ],
            [
              -41.1132,
              -4.047
            ],
            [
              -41.1125,
              -4.0442
            ],
            [
              -41.1129,
              -4.0417
            ],
            [
              -41.1143,
              -4.0406
            ],
            [
              -41.1203,
              -4.0363
            ],
            [
              -41.1222,
              -4.037
            ],
            [
              -41.1239,
              -4.0371
            ],
            [
              -41.1302,
              -4.0354
            ],
            [
              -41.1337,
              -4.0352
            ],
            [
              -41.1431,
              -4.0368
            ],
            [
              -41.1533,
              -4.0349
            ],
            [
              -41.16,
              -4.0317
            ],
            [
              -41.1635,
              -4.0318
            ],
            [
              -41.1688,
              -4.0331
            ],
            [
              -41.1718,
              -4.0325
            ],
            [
              -41.176,
              -4.0288
            ],
            [
              -41.1807,
              -4.0277
            ],
            [
              -41.182,
              -4.0267
            ],
            [
              -41.1838,
              -4.0244
            ],
            [
              -41.1822,
              -4.0192
            ],
            [
              -41.1829,
              -4.018
            ],
            [
              -41.1855,
              -4.0172
            ],
            [
              -41.1886,
              -4.0176
            ],
            [
              -41.1916,
              -4.019
            ],
            [
              -41.1926,
              -4.0207
            ],
            [
              -41.1958,
              -4.0203
            ],
            [
              -41.1978,
              -4.0184
            ],
            [
              -41.1995,
              -4.0184
            ],
            [
              -41.2033,
              -4.0225
            ],
            [
              -41.206,
              -4.0243
            ],
            [
              -41.2089,
              -4.0256
            ],
            [
              -41.2107,
              -4.0258
            ],
            [
              -41.2141,
              -4.0242
            ],
            [
              -41.2221,
              -4.0271
            ],
            [
              -41.2229,
              -4.0284
            ],
            [
              -41.2244,
              -4.0286
            ],
            [
              -41.2268,
              -4.0272
            ],
            [
              -41.2309,
              -4.0289
            ],
            [
              -41.2403,
              -4.0308
            ],
            [
              -41.2502,
              -4.0378
            ],
            [
              -41.2521,
              -4.0378
            ],
            [
              -41.2547,
              -4.0371
            ],
            [
              -41.2567,
              -4.0348
            ],
            [
              -41.2556,
              -4.0326
            ],
            [
              -41.2555,
              -4.0297
            ],
            [
              -41.2544,
              -4.0277
            ],
            [
              -41.2529,
              -4.0265
            ],
            [
              -41.2507,
              -4.0268
            ],
            [
              -41.2495,
              -4.0264
            ],
            [
              -41.2446,
              -4.022
            ],
            [
              -41.2438,
              -4.0197
            ],
            [
              -41.2395,
              -4.0169
            ],
            [
              -41.2388,
              -4.0154
            ],
            [
              -41.2392,
              -4.0131
            ],
            [
              -41.2426,
              -4.0099
            ],
            [
              -41.2443,
              -4.0068
            ],
            [
              -41.2457,
              -4.0066
            ],
            [
              -41.2458,
              -4.0039
            ],
            [
              -41.2464,
              -4.0013
            ],
            [
              -41.2479,
              -3.9994
            ],
            [
              -41.2473,
              -3.997
            ],
            [
              -41.2474,
              -3.9932
            ],
            [
              -41.2492,
              -3.9899
            ],
            [
              -41.2477,
              -3.9891
            ],
            [
              -41.2468,
              -3.9879
            ],
            [
              -41.2442,
              -3.9864
            ],
            [
              -41.2441,
              -3.9842
            ],
            [
              -41.2447,
              -3.983
            ],
            [
              -41.2444,
              -3.9798
            ],
            [
              -41.2438,
              -3.9793
            ],
            [
              -41.2416,
              -3.9799
            ],
            [
              -41.2401,
              -3.9792
            ],
            [
              -41.2396,
              -3.9771
            ],
            [
              -41.2386,
              -3.9757
            ],
            [
              -41.2388,
              -3.9739
            ],
            [
              -41.2382,
              -3.9728
            ],
            [
              -41.2338,
              -3.9706
            ],
            [
              -41.2343,
              -3.9678
            ],
            [
              -41.2313,
              -3.9665
            ],
            [
              -41.2289,
              -3.9681
            ],
            [
              -41.2202,
              -3.9415
            ],
            [
              -41.2289,
              -3.9117
            ],
            [
              -41.23,
              -3.9109
            ],
            [
              -41.2326,
              -3.9108
            ],
            [
              -41.2333,
              -3.9103
            ],
            [
              -41.2356,
              -3.906
            ],
            [
              -41.239,
              -3.9035
            ],
            [
              -41.2417,
              -3.9005
            ],
            [
              -41.2453,
              -3.8983
            ],
            [
              -41.2457,
              -3.8964
            ],
            [
              -41.2447,
              -3.8933
            ],
            [
              -41.2466,
              -3.8845
            ],
            [
              -41.2476,
              -3.8823
            ],
            [
              -41.2535,
              -3.8759
            ],
            [
              -41.2554,
              -3.8729
            ],
            [
              -41.2589,
              -3.8703
            ],
            [
              -41.2597,
              -3.8687
            ],
            [
              -41.26,
              -3.8648
            ],
            [
              -41.2613,
              -3.864
            ],
            [
              -41.2669,
              -3.8627
            ],
            [
              -41.2678,
              -3.8612
            ],
            [
              -41.2669,
              -3.8605
            ],
            [
              -41.2668,
              -3.8589
            ],
            [
              -41.2701,
              -3.8544
            ],
            [
              -41.2704,
              -3.8523
            ],
            [
              -41.2681,
              -3.8483
            ],
            [
              -41.269,
              -3.8459
            ],
            [
              -41.2686,
              -3.8445
            ],
            [
              -41.2713,
              -3.8419
            ],
            [
              -41.2707,
              -3.8378
            ],
            [
              -41.272,
              -3.8365
            ],
            [
              -41.2737,
              -3.8357
            ],
            [
              -41.2751,
              -3.8339
            ],
            [
              -41.2752,
              -3.8302
            ],
            [
              -41.2769,
              -3.8256
            ],
            [
              -41.278,
              -3.8245
            ],
            [
              -41.279,
              -3.8246
            ],
            [
              -41.2814,
              -3.8268
            ],
            [
              -41.2827,
              -3.8268
            ],
            [
              -41.2847,
              -3.8255
            ],
            [
              -41.2867,
              -3.8227
            ],
            [
              -41.2879,
              -3.8225
            ],
            [
              -41.2894,
              -3.8255
            ],
            [
              -41.2925,
              -3.8258
            ],
            [
              -41.2942,
              -3.8295
            ],
            [
              -41.2952,
              -3.8302
            ],
            [
              -41.2967,
              -3.8294
            ],
            [
              -41.299,
              -3.8261
            ],
            [
              -41.3008,
              -3.8263
            ],
            [
              -41.2987,
              -3.8232
            ],
            [
              -41.2944,
              -3.8186
            ],
            [
              -41.2898,
              -3.8148
            ],
            [
              -41.2805,
              -3.8055
            ],
            [
              -41.2756,
              -3.8023
            ],
            [
              -41.2708,
              -3.7968
            ],
            [
              -41.2648,
              -3.7916
            ],
            [
              -41.2626,
              -3.7888
            ],
            [
              -41.2541,
              -3.775
            ],
            [
              -41.2538,
              -3.7734
            ],
            [
              -41.2548,
              -3.7703
            ],
            [
              -41.2605,
              -3.7625
            ],
            [
              -41.2612,
              -3.7575
            ],
            [
              -41.2615,
              -3.7519
            ],
            [
              -41.2613,
              -3.7462
            ],
            [
              -41.26,
              -3.7393
            ],
            [
              -41.2585,
              -3.7328
            ],
            [
              -41.2574,
              -3.7299
            ],
            [
              -41.2531,
              -3.7242
            ],
            [
              -41.2519,
              -3.7233
            ],
            [
              -41.2472,
              -3.7221
            ],
            [
              -41.2394,
              -3.7207
            ],
            [
              -41.2385,
              -3.7199
            ],
            [
              -41.2381,
              -3.7178
            ],
            [
              -41.2383,
              -3.7158
            ],
            [
              -41.2393,
              -3.7128
            ],
            [
              -41.2418,
              -3.711
            ],
            [
              -41.2454,
              -3.7109
            ],
            [
              -41.2474,
              -3.7099
            ],
            [
              -41.2502,
              -3.7066
            ],
            [
              -41.2554,
              -3.7033
            ],
            [
              -41.2583,
              -3.7036
            ],
            [
              -41.2717,
              -3.7034
            ],
            [
              -41.2793,
              -3.7007
            ],
            [
              -41.283,
              -3.697
            ],
            [
              -41.2861,
              -3.6922
            ],
            [
              -41.2877,
              -3.6909
            ],
            [
              -41.2908,
              -3.6897
            ],
            [
              -41.2999,
              -3.6875
            ],
            [
              -41.3077,
              -3.6848
            ],
            [
              -41.3169,
              -3.6866
            ],
            [
              -41.3208,
              -3.6868
            ],
            [
              -41.3225,
              -3.6878
            ],
            [
              -41.3265,
              -3.6873
            ],
            [
              -41.3289,
              -3.6863
            ],
            [
              -41.3318,
              -3.6858
            ],
            [
              -41.3342,
              -3.684
            ],
            [
              -41.3347,
              -3.6915
            ],
            [
              -41.3133,
              -3.7394
            ],
            [
              -41.2786,
              -3.77
            ],
            [
              -41.3659,
              -3.8848
            ],
            [
              -41.4504,
              -3.9961
            ],
            [
              -41.4849,
              -4.0415
            ],
            [
              -41.336,
              -4.0515
            ],
            [
              -41.313,
              -4.1472
            ]
          ]
        ]
      },
      "properties": {
        "name": "São João da Fronteira",
        "codarea": "2209872",
        "isPiripiri": false,
        "isMask": false
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              -41.9621,
              -3.6793
            ],
            [
              -41.9694,
              -3.685
            ],
            [
              -41.9724,
              -3.6882
            ],
            [
              -41.9733,
              -3.6898
            ],
            [
              -41.9754,
              -3.6969
            ],
            [
              -41.9759,
              -3.7023
            ],
            [
              -41.9753,
              -3.7059
            ],
            [
              -41.9754,
              -3.7111
            ],
            [
              -41.9768,
              -3.7161
            ],
            [
              -41.9758,
              -3.7228
            ],
            [
              -41.9768,
              -3.7262
            ],
            [
              -41.9781,
              -3.7288
            ],
            [
              -41.9785,
              -3.7309
            ],
            [
              -41.9777,
              -3.7369
            ],
            [
              -41.9782,
              -3.7401
            ],
            [
              -41.9775,
              -3.7429
            ],
            [
              -41.9766,
              -3.7483
            ],
            [
              -41.9757,
              -3.7517
            ],
            [
              -41.9754,
              -3.7541
            ],
            [
              -41.9768,
              -3.7573
            ],
            [
              -41.9766,
              -3.7604
            ],
            [
              -41.9755,
              -3.7631
            ],
            [
              -41.9753,
              -3.7649
            ],
            [
              -41.9759,
              -3.7663
            ],
            [
              -41.9791,
              -3.7695
            ],
            [
              -41.9809,
              -3.7719
            ],
            [
              -41.9816,
              -3.7738
            ],
            [
              -41.9813,
              -3.777
            ],
            [
              -41.9806,
              -3.7797
            ],
            [
              -41.9811,
              -3.784
            ],
            [
              -41.8984,
              -3.7967
            ],
            [
              -41.9019,
              -3.8641
            ],
            [
              -41.9031,
              -3.8869
            ],
            [
              -41.8656,
              -3.8483
            ],
            [
              -41.8355,
              -3.8484
            ],
            [
              -41.6864,
              -3.797
            ],
            [
              -41.6866,
              -3.7926
            ],
            [
              -41.6866,
              -3.7815
            ],
            [
              -41.7131,
              -3.771
            ],
            [
              -41.7418,
              -3.7662
            ],
            [
              -41.8183,
              -3.7534
            ],
            [
              -41.8239,
              -3.7533
            ],
            [
              -41.8252,
              -3.7548
            ],
            [
              -41.8259,
              -3.7548
            ],
            [
              -41.8278,
              -3.7533
            ],
            [
              -41.8298,
              -3.7534
            ],
            [
              -41.8666,
              -3.7209
            ],
            [
              -41.8976,
              -3.6981
            ],
            [
              -41.9041,
              -3.693
            ],
            [
              -41.9245,
              -3.6771
            ],
            [
              -41.9262,
              -3.6788
            ],
            [
              -41.9274,
              -3.6794
            ],
            [
              -41.9345,
              -3.6802
            ],
            [
              -41.9447,
              -3.6806
            ],
            [
              -41.948,
              -3.6795
            ],
            [
              -41.9504,
              -3.6767
            ],
            [
              -41.954,
              -3.6758
            ],
            [
              -41.9571,
              -3.6762
            ],
            [
              -41.9621,
              -3.6793
            ]
          ]
        ]
      },
      "properties": {
        "name": "São José do Divino",
        "codarea": "2210052",
        "isPiripiri": false,
        "isMask": false
      }
    }
  ]
});

export const FULL_MAP_GEOJSON = Object.freeze({
  "type": "FeatureCollection",
  "features": [
    {
      "type": "Feature",
      "properties": {
        "name": "OuterMask",
        "isMask": true,
        "isPiripiri": false
      },
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              -65,
              15
            ],
            [
              -25,
              15
            ],
            [
              -25,
              -30
            ],
            [
              -65,
              -30
            ],
            [
              -65,
              15
            ]
          ],
          [
            [
              -42.548,
              -4.345
            ],
            [
              -42.4826,
              -4.344
            ],
            [
              -42.4479,
              -4.3344
            ],
            [
              -42.4196,
              -4.3435
            ],
            [
              -42.4173,
              -4.3399
            ],
            [
              -42.1959,
              -4.3809
            ],
            [
              -42.1817,
              -4.3819
            ],
            [
              -42.1741,
              -4.3726
            ],
            [
              -42.1775,
              -4.3673
            ],
            [
              -42.1775,
              -4.3577
            ],
            [
              -42.1821,
              -4.3494
            ],
            [
              -42.1818,
              -4.3402
            ],
            [
              -42.178,
              -4.3263
            ],
            [
              -42.1841,
              -4.3075
            ],
            [
              -42.1935,
              -4.2974
            ],
            [
              -42.1852,
              -4.2867
            ],
            [
              -42.1868,
              -4.2777
            ],
            [
              -42.1946,
              -4.2709
            ],
            [
              -42.1786,
              -4.2696
            ],
            [
              -42.1606,
              -4.2709
            ],
            [
              -42.1548,
              -4.2742
            ],
            [
              -42.1333,
              -4.2721
            ],
            [
              -42.1252,
              -4.2735
            ],
            [
              -42.1221,
              -4.2667
            ],
            [
              -42.1112,
              -4.2661
            ],
            [
              -42.1002,
              -4.2706
            ],
            [
              -42.0635,
              -4.2739
            ],
            [
              -42.0415,
              -4.2714
            ],
            [
              -42.0306,
              -4.2667
            ],
            [
              -42.0113,
              -4.2674
            ],
            [
              -42.0005,
              -4.2722
            ],
            [
              -41.9966,
              -4.2452
            ],
            [
              -41.9969,
              -4.2078
            ],
            [
              -42.0154,
              -4.2
            ],
            [
              -42.0511,
              -4.1811
            ],
            [
              -42.0563,
              -4.191
            ],
            [
              -42.0632,
              -4.1917
            ],
            [
              -42.0768,
              -4.2053
            ],
            [
              -42.0938,
              -4.2031
            ],
            [
              -42.11,
              -4.2107
            ],
            [
              -42.1164,
              -4.207
            ],
            [
              -42.13,
              -4.2123
            ],
            [
              -42.1337,
              -4.2171
            ],
            [
              -42.1425,
              -4.2168
            ],
            [
              -42.1563,
              -4.2202
            ],
            [
              -42.1723,
              -4.2174
            ],
            [
              -42.1834,
              -4.2208
            ],
            [
              -42.193,
              -4.2169
            ],
            [
              -42.2078,
              -4.2257
            ],
            [
              -42.213,
              -4.2208
            ],
            [
              -42.2275,
              -4.2273
            ],
            [
              -42.2376,
              -4.2241
            ],
            [
              -42.2354,
              -4.2177
            ],
            [
              -42.2397,
              -4.2121
            ],
            [
              -42.2388,
              -4.2015
            ],
            [
              -42.234,
              -4.1949
            ],
            [
              -42.242,
              -4.1673
            ],
            [
              -42.2489,
              -4.1618
            ],
            [
              -42.2634,
              -4.1703
            ],
            [
              -42.2667,
              -4.1609
            ],
            [
              -42.2612,
              -4.1562
            ],
            [
              -42.2625,
              -4.1503
            ],
            [
              -42.2536,
              -4.1414
            ],
            [
              -42.2509,
              -4.1268
            ],
            [
              -42.2598,
              -4.1223
            ],
            [
              -42.2575,
              -4.1157
            ],
            [
              -42.2589,
              -4.1046
            ],
            [
              -42.2638,
              -4.0895
            ],
            [
              -42.2545,
              -4.0778
            ],
            [
              -42.2573,
              -4.0733
            ],
            [
              -42.2564,
              -4.0628
            ],
            [
              -42.2638,
              -4.0547
            ],
            [
              -42.2581,
              -4.0492
            ],
            [
              -42.2619,
              -4.0278
            ],
            [
              -42.2664,
              -4.025
            ],
            [
              -42.2645,
              -4.0108
            ],
            [
              -42.2595,
              -4.0053
            ],
            [
              -42.2471,
              -3.9996
            ],
            [
              -42.2374,
              -3.9976
            ],
            [
              -42.238,
              -3.9823
            ],
            [
              -42.2295,
              -3.9736
            ],
            [
              -42.2358,
              -3.9594
            ],
            [
              -42.2439,
              -3.9267
            ],
            [
              -42.2454,
              -3.9355
            ],
            [
              -42.2669,
              -3.9394
            ],
            [
              -42.2749,
              -3.9546
            ],
            [
              -42.2722,
              -3.9617
            ],
            [
              -42.2771,
              -3.9788
            ],
            [
              -42.288,
              -3.9759
            ],
            [
              -42.3012,
              -3.986
            ],
            [
              -42.3088,
              -3.9985
            ],
            [
              -42.3255,
              -3.9931
            ],
            [
              -42.3318,
              -3.9853
            ],
            [
              -42.3458,
              -3.9811
            ],
            [
              -42.359,
              -3.9743
            ],
            [
              -42.3734,
              -3.9847
            ],
            [
              -42.3887,
              -3.986
            ],
            [
              -42.4393,
              -3.9686
            ],
            [
              -42.4562,
              -3.9968
            ],
            [
              -42.5127,
              -4.0423
            ],
            [
              -42.5046,
              -4.0549
            ],
            [
              -42.5205,
              -4.0637
            ],
            [
              -42.5305,
              -4.0928
            ],
            [
              -42.5343,
              -4.1003
            ],
            [
              -42.542,
              -4.1045
            ],
            [
              -42.5561,
              -4.1047
            ],
            [
              -42.5901,
              -4.1329
            ],
            [
              -42.6072,
              -4.1303
            ],
            [
              -42.6102,
              -4.1323
            ],
            [
              -42.6231,
              -4.1293
            ],
            [
              -42.6467,
              -4.1309
            ],
            [
              -42.616,
              -4.2379
            ],
            [
              -42.548,
              -4.345
            ]
          ],
          [
            [
              -42.2439,
              -3.9267
            ],
            [
              -42.2358,
              -3.9594
            ],
            [
              -42.2295,
              -3.9736
            ],
            [
              -42.238,
              -3.9823
            ],
            [
              -42.2374,
              -3.9976
            ],
            [
              -42.2471,
              -3.9996
            ],
            [
              -42.2595,
              -4.0053
            ],
            [
              -42.2645,
              -4.0108
            ],
            [
              -42.2664,
              -4.025
            ],
            [
              -42.2619,
              -4.0278
            ],
            [
              -42.2581,
              -4.0492
            ],
            [
              -42.2638,
              -4.0547
            ],
            [
              -42.2564,
              -4.0628
            ],
            [
              -42.2573,
              -4.0733
            ],
            [
              -42.2545,
              -4.0778
            ],
            [
              -42.2638,
              -4.0895
            ],
            [
              -42.2589,
              -4.1046
            ],
            [
              -42.2575,
              -4.1157
            ],
            [
              -42.2598,
              -4.1223
            ],
            [
              -42.2509,
              -4.1268
            ],
            [
              -42.2536,
              -4.1414
            ],
            [
              -42.2625,
              -4.1503
            ],
            [
              -42.2612,
              -4.1562
            ],
            [
              -42.2667,
              -4.1609
            ],
            [
              -42.2634,
              -4.1703
            ],
            [
              -42.2489,
              -4.1618
            ],
            [
              -42.242,
              -4.1673
            ],
            [
              -42.234,
              -4.1949
            ],
            [
              -42.2388,
              -4.2015
            ],
            [
              -42.2397,
              -4.2121
            ],
            [
              -42.2354,
              -4.2177
            ],
            [
              -42.2376,
              -4.2241
            ],
            [
              -42.2275,
              -4.2273
            ],
            [
              -42.213,
              -4.2208
            ],
            [
              -42.2078,
              -4.2257
            ],
            [
              -42.193,
              -4.2169
            ],
            [
              -42.1834,
              -4.2208
            ],
            [
              -42.1723,
              -4.2174
            ],
            [
              -42.1563,
              -4.2202
            ],
            [
              -42.1425,
              -4.2168
            ],
            [
              -42.1337,
              -4.2171
            ],
            [
              -42.13,
              -4.2123
            ],
            [
              -42.1164,
              -4.207
            ],
            [
              -42.11,
              -4.2107
            ],
            [
              -42.0938,
              -4.2031
            ],
            [
              -42.0768,
              -4.2053
            ],
            [
              -42.0632,
              -4.1917
            ],
            [
              -42.0563,
              -4.191
            ],
            [
              -42.0511,
              -4.1811
            ],
            [
              -42.0154,
              -4.2
            ],
            [
              -41.9969,
              -4.2078
            ],
            [
              -41.9966,
              -4.2452
            ],
            [
              -41.9789,
              -4.2462
            ],
            [
              -41.964,
              -4.2341
            ],
            [
              -41.9544,
              -4.2207
            ],
            [
              -41.9332,
              -4.2259
            ],
            [
              -41.9189,
              -4.2239
            ],
            [
              -41.9213,
              -4.1841
            ],
            [
              -41.9328,
              -4.197
            ],
            [
              -41.8971,
              -4.0857
            ],
            [
              -41.9348,
              -4.0693
            ],
            [
              -41.92,
              -4.062
            ],
            [
              -41.9145,
              -4.0516
            ],
            [
              -41.9134,
              -4.0348
            ],
            [
              -41.9062,
              -4.0421
            ],
            [
              -41.8942,
              -4.0461
            ],
            [
              -41.8868,
              -4.0403
            ],
            [
              -41.8779,
              -4.0405
            ],
            [
              -41.8708,
              -4.0447
            ],
            [
              -41.8559,
              -4.0406
            ],
            [
              -41.8476,
              -3.9738
            ],
            [
              -41.9108,
              -3.9408
            ],
            [
              -41.9031,
              -3.8869
            ],
            [
              -41.8984,
              -3.7967
            ],
            [
              -41.9811,
              -3.784
            ],
            [
              -41.9816,
              -3.7738
            ],
            [
              -41.9753,
              -3.7649
            ],
            [
              -41.9754,
              -3.7541
            ],
            [
              -41.9785,
              -3.7309
            ],
            [
              -41.9758,
              -3.7228
            ],
            [
              -41.9754,
              -3.6969
            ],
            [
              -41.9733,
              -3.6898
            ],
            [
              -41.9621,
              -3.6793
            ],
            [
              -42.0503,
              -3.6803
            ],
            [
              -42.0503,
              -3.7913
            ],
            [
              -42.0351,
              -3.7913
            ],
            [
              -42.0246,
              -3.808
            ],
            [
              -42.0203,
              -3.8098
            ],
            [
              -42.0024,
              -3.8012
            ],
            [
              -41.995,
              -3.7995
            ],
            [
              -41.9868,
              -3.8059
            ],
            [
              -41.9798,
              -3.803
            ],
            [
              -41.974,
              -3.8095
            ],
            [
              -41.9878,
              -3.8232
            ],
            [
              -41.9891,
              -3.8314
            ],
            [
              -41.9839,
              -3.8395
            ],
            [
              -41.9772,
              -3.8433
            ],
            [
              -41.9798,
              -3.8511
            ],
            [
              -41.9785,
              -3.8603
            ],
            [
              -41.9911,
              -3.8705
            ],
            [
              -42.0091,
              -3.8749
            ],
            [
              -42.0272,
              -3.8744
            ],
            [
              -42.0441,
              -3.8767
            ],
            [
              -42.0519,
              -3.8859
            ],
            [
              -42.0677,
              -3.8861
            ],
            [
              -42.0625,
              -3.8951
            ],
            [
              -42.065,
              -3.905
            ],
            [
              -42.0724,
              -3.9181
            ],
            [
              -42.0923,
              -3.9158
            ],
            [
              -42.0982,
              -3.9108
            ],
            [
              -42.105,
              -3.9167
            ],
            [
              -42.1175,
              -3.9107
            ],
            [
              -42.1193,
              -3.8987
            ],
            [
              -42.1379,
              -3.9005
            ],
            [
              -42.1487,
              -3.9041
            ],
            [
              -42.1694,
              -3.8897
            ],
            [
              -42.1742,
              -3.8964
            ],
            [
              -42.1733,
              -3.9096
            ],
            [
              -42.1821,
              -3.913
            ],
            [
              -42.1871,
              -3.9058
            ],
            [
              -42.1946,
              -3.9095
            ],
            [
              -42.2044,
              -3.9189
            ],
            [
              -42.2119,
              -3.9156
            ],
            [
              -42.209,
              -3.9055
            ],
            [
              -42.2188,
              -3.8986
            ],
            [
              -42.2335,
              -3.9056
            ],
            [
              -42.2444,
              -3.9143
            ],
            [
              -42.2439,
              -3.9267
            ]
          ],
          [
            [
              -42.061,
              -4.434
            ],
            [
              -42.0584,
              -4.4035
            ],
            [
              -42.0793,
              -4.3742
            ],
            [
              -42.0269,
              -4.3542
            ],
            [
              -42.0005,
              -4.3441
            ],
            [
              -42.0005,
              -4.2722
            ],
            [
              -42.0113,
              -4.2674
            ],
            [
              -42.0306,
              -4.2667
            ],
            [
              -42.0415,
              -4.2714
            ],
            [
              -42.0635,
              -4.2739
            ],
            [
              -42.1002,
              -4.2706
            ],
            [
              -42.1112,
              -4.2661
            ],
            [
              -42.1221,
              -4.2667
            ],
            [
              -42.1252,
              -4.2735
            ],
            [
              -42.1333,
              -4.2721
            ],
            [
              -42.1548,
              -4.2742
            ],
            [
              -42.1606,
              -4.2709
            ],
            [
              -42.1786,
              -4.2696
            ],
            [
              -42.1946,
              -4.2709
            ],
            [
              -42.1868,
              -4.2777
            ],
            [
              -42.1852,
              -4.2867
            ],
            [
              -42.1935,
              -4.2974
            ],
            [
              -42.1841,
              -4.3075
            ],
            [
              -42.178,
              -4.3263
            ],
            [
              -42.1818,
              -4.3402
            ],
            [
              -42.1821,
              -4.3494
            ],
            [
              -42.1775,
              -4.3577
            ],
            [
              -42.1775,
              -4.3673
            ],
            [
              -42.1741,
              -4.3726
            ],
            [
              -42.1817,
              -4.3819
            ],
            [
              -42.1959,
              -4.3809
            ],
            [
              -42.1846,
              -4.391
            ],
            [
              -42.1768,
              -4.4012
            ],
            [
              -42.1816,
              -4.4112
            ],
            [
              -42.1792,
              -4.4163
            ],
            [
              -42.1674,
              -4.4235
            ],
            [
              -42.1658,
              -4.4374
            ],
            [
              -42.1668,
              -4.4516
            ],
            [
              -42.178,
              -4.4626
            ],
            [
              -42.1684,
              -4.464
            ],
            [
              -42.169,
              -4.4708
            ],
            [
              -42.1617,
              -4.4767
            ],
            [
              -42.1532,
              -4.4739
            ],
            [
              -42.1505,
              -4.4822
            ],
            [
              -42.061,
              -4.434
            ]
          ],
          [
            [
              -41.9213,
              -4.1841
            ],
            [
              -41.9214,
              -4.1814
            ],
            [
              -41.8045,
              -4.2022
            ],
            [
              -41.799,
              -4.1906
            ],
            [
              -41.7999,
              -4.1735
            ],
            [
              -41.7612,
              -4.2088
            ],
            [
              -41.6568,
              -4.2198
            ],
            [
              -41.5776,
              -4.1457
            ],
            [
              -41.5747,
              -4.1594
            ],
            [
              -41.5617,
              -4.1586
            ],
            [
              -41.5456,
              -4.1639
            ],
            [
              -41.5397,
              -4.1603
            ],
            [
              -41.5254,
              -4.1636
            ],
            [
              -41.5139,
              -4.175
            ],
            [
              -41.5038,
              -4.176
            ],
            [
              -41.4973,
              -4.1804
            ],
            [
              -41.4946,
              -4.1832
            ],
            [
              -41.4792,
              -4.1836
            ],
            [
              -41.4736,
              -4.1871
            ],
            [
              -41.4563,
              -4.1863
            ],
            [
              -41.4521,
              -4.192
            ],
            [
              -41.4396,
              -4.1817
            ],
            [
              -41.432,
              -4.1813
            ],
            [
              -41.4278,
              -4.174
            ],
            [
              -41.426,
              -4.1601
            ],
            [
              -41.4151,
              -4.1556
            ],
            [
              -41.41,
              -4.1485
            ],
            [
              -41.4002,
              -4.158
            ],
            [
              -41.3939,
              -4.1611
            ],
            [
              -41.3765,
              -4.1581
            ],
            [
              -41.3713,
              -4.1472
            ],
            [
              -41.3514,
              -4.1402
            ],
            [
              -41.3426,
              -4.1399
            ],
            [
              -41.3326,
              -4.1452
            ],
            [
              -41.3318,
              -4.1513
            ],
            [
              -41.313,
              -4.1472
            ],
            [
              -41.336,
              -4.0515
            ],
            [
              -41.4849,
              -4.0415
            ],
            [
              -41.5006,
              -4.0426
            ],
            [
              -41.5553,
              -4.0574
            ],
            [
              -41.6221,
              -4.0604
            ],
            [
              -41.6319,
              -4.1356
            ],
            [
              -41.7745,
              -4.1005
            ],
            [
              -41.7607,
              -4.0975
            ],
            [
              -41.7502,
              -4.0791
            ],
            [
              -41.738,
              -4.0719
            ],
            [
              -41.7364,
              -4.0635
            ],
            [
              -41.7379,
              -4.0453
            ],
            [
              -41.7718,
              -4.034
            ],
            [
              -41.8558,
              -4.0423
            ],
            [
              -41.8559,
              -4.0406
            ],
            [
              -41.8708,
              -4.0447
            ],
            [
              -41.8779,
              -4.0405
            ],
            [
              -41.8868,
              -4.0403
            ],
            [
              -41.8942,
              -4.0461
            ],
            [
              -41.9062,
              -4.0421
            ],
            [
              -41.9134,
              -4.0348
            ],
            [
              -41.9145,
              -4.0516
            ],
            [
              -41.92,
              -4.062
            ],
            [
              -41.9348,
              -4.0693
            ],
            [
              -41.8971,
              -4.0857
            ],
            [
              -41.9328,
              -4.197
            ],
            [
              -41.9213,
              -4.1841
            ]
          ],
          [
            [
              -42.0346,
              -4.5292
            ],
            [
              -42.0131,
              -4.5295
            ],
            [
              -41.9875,
              -4.5282
            ],
            [
              -41.964,
              -4.5293
            ],
            [
              -41.9218,
              -4.5439
            ],
            [
              -41.8954,
              -4.5693
            ],
            [
              -41.8792,
              -4.5901
            ],
            [
              -41.8603,
              -4.6046
            ],
            [
              -41.8402,
              -4.6246
            ],
            [
              -41.8501,
              -4.6313
            ],
            [
              -41.8569,
              -4.6431
            ],
            [
              -41.857,
              -4.6634
            ],
            [
              -41.8643,
              -4.6805
            ],
            [
              -41.8799,
              -4.6805
            ],
            [
              -41.8188,
              -4.6971
            ],
            [
              -41.778,
              -4.6921
            ],
            [
              -41.7768,
              -4.6888
            ],
            [
              -41.7453,
              -4.5904
            ],
            [
              -41.7393,
              -4.5699
            ],
            [
              -41.7556,
              -4.545
            ],
            [
              -41.7666,
              -4.5364
            ],
            [
              -41.7799,
              -4.5321
            ],
            [
              -41.7812,
              -4.5221
            ],
            [
              -41.7932,
              -4.5113
            ],
            [
              -41.8073,
              -4.51
            ],
            [
              -41.8113,
              -4.5049
            ],
            [
              -41.8198,
              -4.5025
            ],
            [
              -41.8204,
              -4.497
            ],
            [
              -41.8345,
              -4.4815
            ],
            [
              -41.8367,
              -4.4711
            ],
            [
              -41.8497,
              -4.4599
            ],
            [
              -41.8604,
              -4.4626
            ],
            [
              -41.8739,
              -4.4576
            ],
            [
              -41.8801,
              -4.4498
            ],
            [
              -41.8886,
              -4.4473
            ],
            [
              -41.8903,
              -4.4356
            ],
            [
              -41.8983,
              -4.4335
            ],
            [
              -41.9026,
              -4.4278
            ],
            [
              -41.9189,
              -4.4317
            ],
            [
              -41.9291,
              -4.432
            ],
            [
              -41.9412,
              -4.4235
            ],
            [
              -41.9587,
              -4.4246
            ],
            [
              -41.9669,
              -4.4155
            ],
            [
              -41.9679,
              -4.4047
            ],
            [
              -41.9875,
              -4.3948
            ],
            [
              -41.9905,
              -4.3889
            ],
            [
              -42.0079,
              -4.3808
            ],
            [
              -42.0125,
              -4.3844
            ],
            [
              -42.0193,
              -4.3811
            ],
            [
              -42.0216,
              -4.3721
            ],
            [
              -42.0164,
              -4.367
            ],
            [
              -42.0269,
              -4.3542
            ],
            [
              -42.0793,
              -4.3742
            ],
            [
              -42.0584,
              -4.4035
            ],
            [
              -42.061,
              -4.434
            ],
            [
              -42.0497,
              -4.4528
            ],
            [
              -42.0574,
              -4.464
            ],
            [
              -42.0557,
              -4.5278
            ],
            [
              -42.0346,
              -4.5292
            ]
          ],
          [
            [
              -41.313,
              -4.1472
            ],
            [
              -41.3318,
              -4.1513
            ],
            [
              -41.3326,
              -4.1452
            ],
            [
              -41.3426,
              -4.1399
            ],
            [
              -41.3514,
              -4.1402
            ],
            [
              -41.3713,
              -4.1472
            ],
            [
              -41.3765,
              -4.1581
            ],
            [
              -41.3939,
              -4.1611
            ],
            [
              -41.4002,
              -4.158
            ],
            [
              -41.41,
              -4.1485
            ],
            [
              -41.4151,
              -4.1556
            ],
            [
              -41.426,
              -4.1601
            ],
            [
              -41.4278,
              -4.174
            ],
            [
              -41.432,
              -4.1813
            ],
            [
              -41.4396,
              -4.1817
            ],
            [
              -41.4521,
              -4.192
            ],
            [
              -41.4563,
              -4.1863
            ],
            [
              -41.4736,
              -4.1871
            ],
            [
              -41.4792,
              -4.1836
            ],
            [
              -41.4946,
              -4.1832
            ],
            [
              -41.4973,
              -4.1804
            ],
            [
              -41.525,
              -4.2567
            ],
            [
              -41.495,
              -4.2745
            ],
            [
              -41.4876,
              -4.3037
            ],
            [
              -41.4532,
              -4.3013
            ],
            [
              -41.4153,
              -4.311
            ],
            [
              -41.414,
              -4.3147
            ],
            [
              -41.4275,
              -4.3211
            ],
            [
              -41.4184,
              -4.3482
            ],
            [
              -41.399,
              -4.3885
            ],
            [
              -41.3877,
              -4.4325
            ],
            [
              -41.3807,
              -4.4335
            ],
            [
              -41.363,
              -4.3384
            ],
            [
              -41.3568,
              -4.3429
            ],
            [
              -41.2405,
              -4.3757
            ],
            [
              -41.229,
              -4.3404
            ],
            [
              -41.1194,
              -4.3243
            ],
            [
              -41.1191,
              -4.3065
            ],
            [
              -41.1359,
              -4.2335
            ],
            [
              -41.0991,
              -4.1818
            ],
            [
              -41.0981,
              -4.1805
            ],
            [
              -41.1224,
              -4.1759
            ],
            [
              -41.135,
              -4.1768
            ],
            [
              -41.1426,
              -4.1857
            ],
            [
              -41.1651,
              -4.1876
            ],
            [
              -41.1769,
              -4.1766
            ],
            [
              -41.1768,
              -4.1691
            ],
            [
              -41.1833,
              -4.1584
            ],
            [
              -41.1873,
              -4.1606
            ],
            [
              -41.1962,
              -4.1476
            ],
            [
              -41.2044,
              -4.1461
            ],
            [
              -41.2135,
              -4.156
            ],
            [
              -41.2237,
              -4.1582
            ],
            [
              -41.2333,
              -4.1563
            ],
            [
              -41.2413,
              -4.1452
            ],
            [
              -41.2496,
              -4.1385
            ],
            [
              -41.259,
              -4.1468
            ],
            [
              -41.2657,
              -4.161
            ],
            [
              -41.2809,
              -4.17
            ],
            [
              -41.2946,
              -4.1658
            ],
            [
              -41.297,
              -4.1565
            ],
            [
              -41.3031,
              -4.1548
            ],
            [
              -41.305,
              -4.148
            ],
            [
              -41.313,
              -4.1472
            ]
          ],
          [
            [
              -41.6053,
              -4.4095
            ],
            [
              -41.5972,
              -4.4054
            ],
            [
              -41.5887,
              -4.4156
            ],
            [
              -41.5801,
              -4.4132
            ],
            [
              -41.568,
              -4.4148
            ],
            [
              -41.5647,
              -4.4097
            ],
            [
              -41.5496,
              -4.4047
            ],
            [
              -41.5442,
              -4.4075
            ],
            [
              -41.5349,
              -4.4044
            ],
            [
              -41.529,
              -4.4106
            ],
            [
              -41.5204,
              -4.406
            ],
            [
              -41.5187,
              -4.3997
            ],
            [
              -41.5109,
              -4.4003
            ],
            [
              -41.5057,
              -4.3887
            ],
            [
              -41.5061,
              -4.3747
            ],
            [
              -41.5015,
              -4.3573
            ],
            [
              -41.5108,
              -4.3482
            ],
            [
              -41.513,
              -4.3316
            ],
            [
              -41.5302,
              -4.3317
            ],
            [
              -41.5368,
              -4.321
            ],
            [
              -41.5414,
              -4.3288
            ],
            [
              -41.5503,
              -4.3209
            ],
            [
              -41.5594,
              -4.3188
            ],
            [
              -41.5608,
              -4.3103
            ],
            [
              -41.5687,
              -4.3062
            ],
            [
              -41.5786,
              -4.3093
            ],
            [
              -41.5823,
              -4.3037
            ],
            [
              -41.5937,
              -4.3022
            ],
            [
              -41.5966,
              -4.2952
            ],
            [
              -41.6084,
              -4.3018
            ],
            [
              -41.6065,
              -4.3108
            ],
            [
              -41.6165,
              -4.318
            ],
            [
              -41.6128,
              -4.3264
            ],
            [
              -41.6173,
              -4.3389
            ],
            [
              -41.6274,
              -4.34
            ],
            [
              -41.6365,
              -4.35
            ],
            [
              -41.6418,
              -4.3462
            ],
            [
              -41.6482,
              -4.3484
            ],
            [
              -41.6547,
              -4.3446
            ],
            [
              -41.6646,
              -4.3458
            ],
            [
              -41.6674,
              -4.3538
            ],
            [
              -41.6577,
              -4.3839
            ],
            [
              -41.6585,
              -4.3953
            ],
            [
              -41.6414,
              -4.4092
            ],
            [
              -41.6337,
              -4.4065
            ],
            [
              -41.6268,
              -4.4091
            ],
            [
              -41.6117,
              -4.4055
            ],
            [
              -41.6053,
              -4.4095
            ]
          ],
          [
            [
              -41.7453,
              -4.5904
            ],
            [
              -41.5122,
              -4.5807
            ],
            [
              -41.2935,
              -4.5561
            ],
            [
              -41.294,
              -4.6296
            ],
            [
              -41.2952,
              -4.8149
            ],
            [
              -41.268,
              -4.8116
            ],
            [
              -41.2597,
              -4.8086
            ],
            [
              -41.2559,
              -4.8006
            ],
            [
              -41.2332,
              -4.8101
            ],
            [
              -41.2325,
              -4.8045
            ],
            [
              -41.2254,
              -4.7978
            ],
            [
              -41.224,
              -4.7907
            ],
            [
              -41.2081,
              -4.7803
            ],
            [
              -41.2128,
              -4.772
            ],
            [
              -41.2339,
              -4.7688
            ],
            [
              -41.2478,
              -4.7618
            ],
            [
              -41.2503,
              -4.7566
            ],
            [
              -41.2352,
              -4.7465
            ],
            [
              -41.2367,
              -4.7388
            ],
            [
              -41.226,
              -4.7265
            ],
            [
              -41.2238,
              -4.7209
            ],
            [
              -41.2025,
              -4.7019
            ],
            [
              -41.1811,
              -4.6732
            ],
            [
              -41.1754,
              -4.6708
            ],
            [
              -41.1856,
              -4.662
            ],
            [
              -41.2028,
              -4.6382
            ],
            [
              -41.2293,
              -4.6201
            ],
            [
              -41.2334,
              -4.6102
            ],
            [
              -41.223,
              -4.5898
            ],
            [
              -41.222,
              -4.5778
            ],
            [
              -41.2398,
              -4.5736
            ],
            [
              -41.2354,
              -4.5702
            ],
            [
              -41.2215,
              -4.5675
            ],
            [
              -41.2141,
              -4.5527
            ],
            [
              -41.2084,
              -4.5488
            ],
            [
              -41.2038,
              -4.5284
            ],
            [
              -41.1908,
              -4.5155
            ],
            [
              -41.1879,
              -4.4861
            ],
            [
              -41.1776,
              -4.4677
            ],
            [
              -41.1785,
              -4.4594
            ],
            [
              -41.1752,
              -4.4495
            ],
            [
              -41.1774,
              -4.4433
            ],
            [
              -41.1651,
              -4.4226
            ],
            [
              -41.1597,
              -4.4106
            ],
            [
              -41.159,
              -4.3921
            ],
            [
              -41.1618,
              -4.3873
            ],
            [
              -41.158,
              -4.3787
            ],
            [
              -41.1491,
              -4.3672
            ],
            [
              -41.1421,
              -4.359
            ],
            [
              -41.1334,
              -4.3401
            ],
            [
              -41.1202,
              -4.3306
            ],
            [
              -41.1194,
              -4.3243
            ],
            [
              -41.229,
              -4.3404
            ],
            [
              -41.2405,
              -4.3757
            ],
            [
              -41.3568,
              -4.3429
            ],
            [
              -41.363,
              -4.3384
            ],
            [
              -41.3807,
              -4.4335
            ],
            [
              -41.3877,
              -4.4325
            ],
            [
              -41.399,
              -4.3885
            ],
            [
              -41.4184,
              -4.3482
            ],
            [
              -41.4275,
              -4.3211
            ],
            [
              -41.414,
              -4.3147
            ],
            [
              -41.4153,
              -4.311
            ],
            [
              -41.4532,
              -4.3013
            ],
            [
              -41.4876,
              -4.3037
            ],
            [
              -41.495,
              -4.2745
            ],
            [
              -41.525,
              -4.2567
            ],
            [
              -41.5608,
              -4.3103
            ],
            [
              -41.5594,
              -4.3188
            ],
            [
              -41.5503,
              -4.3209
            ],
            [
              -41.5414,
              -4.3288
            ],
            [
              -41.5368,
              -4.321
            ],
            [
              -41.5302,
              -4.3317
            ],
            [
              -41.513,
              -4.3316
            ],
            [
              -41.5108,
              -4.3482
            ],
            [
              -41.5015,
              -4.3573
            ],
            [
              -41.5061,
              -4.3747
            ],
            [
              -41.5057,
              -4.3887
            ],
            [
              -41.5109,
              -4.4003
            ],
            [
              -41.5187,
              -4.3997
            ],
            [
              -41.5204,
              -4.406
            ],
            [
              -41.529,
              -4.4106
            ],
            [
              -41.5349,
              -4.4044
            ],
            [
              -41.5442,
              -4.4075
            ],
            [
              -41.5496,
              -4.4047
            ],
            [
              -41.5647,
              -4.4097
            ],
            [
              -41.568,
              -4.4148
            ],
            [
              -41.5801,
              -4.4132
            ],
            [
              -41.5887,
              -4.4156
            ],
            [
              -41.5972,
              -4.4054
            ],
            [
              -41.6053,
              -4.4095
            ],
            [
              -41.6211,
              -4.4389
            ],
            [
              -41.6387,
              -4.4632
            ],
            [
              -41.7303,
              -4.5473
            ],
            [
              -41.7393,
              -4.5699
            ],
            [
              -41.7453,
              -4.5904
            ]
          ],
          [
            [
              -41.8559,
              -4.0406
            ],
            [
              -41.8558,
              -4.0423
            ],
            [
              -41.7718,
              -4.034
            ],
            [
              -41.7379,
              -4.0453
            ],
            [
              -41.7364,
              -4.0635
            ],
            [
              -41.738,
              -4.0719
            ],
            [
              -41.7502,
              -4.0791
            ],
            [
              -41.7607,
              -4.0975
            ],
            [
              -41.7745,
              -4.1005
            ],
            [
              -41.6319,
              -4.1356
            ],
            [
              -41.6221,
              -4.0604
            ],
            [
              -41.5553,
              -4.0574
            ],
            [
              -41.5006,
              -4.0426
            ],
            [
              -41.4849,
              -4.0415
            ],
            [
              -41.3659,
              -3.8848
            ],
            [
              -41.2786,
              -3.77
            ],
            [
              -41.3133,
              -3.7394
            ],
            [
              -41.3347,
              -3.6915
            ],
            [
              -41.3358,
              -3.7013
            ],
            [
              -41.3524,
              -3.6999
            ],
            [
              -41.3602,
              -3.7094
            ],
            [
              -41.371,
              -3.7147
            ],
            [
              -41.3759,
              -3.712
            ],
            [
              -41.4007,
              -3.7305
            ],
            [
              -41.4181,
              -3.7535
            ],
            [
              -41.4498,
              -3.7424
            ],
            [
              -41.4487,
              -3.7024
            ],
            [
              -41.4576,
              -3.6698
            ],
            [
              -41.4873,
              -3.6539
            ],
            [
              -41.5066,
              -3.6308
            ],
            [
              -41.5242,
              -3.6058
            ],
            [
              -41.6491,
              -3.64
            ],
            [
              -41.678,
              -3.6647
            ],
            [
              -41.7455,
              -3.6726
            ],
            [
              -41.7466,
              -3.5865
            ],
            [
              -41.7729,
              -3.5727
            ],
            [
              -41.7943,
              -3.6241
            ],
            [
              -41.8666,
              -3.7209
            ],
            [
              -41.8298,
              -3.7534
            ],
            [
              -41.8183,
              -3.7534
            ],
            [
              -41.7131,
              -3.771
            ],
            [
              -41.6866,
              -3.7815
            ],
            [
              -41.6864,
              -3.797
            ],
            [
              -41.8355,
              -3.8484
            ],
            [
              -41.8656,
              -3.8483
            ],
            [
              -41.9031,
              -3.8869
            ],
            [
              -41.9108,
              -3.9408
            ],
            [
              -41.8476,
              -3.9738
            ],
            [
              -41.8559,
              -4.0406
            ]
          ],
          [
            [
              -41.6053,
              -4.4095
            ],
            [
              -41.6117,
              -4.4055
            ],
            [
              -41.6268,
              -4.4091
            ],
            [
              -41.6337,
              -4.4065
            ],
            [
              -41.6414,
              -4.4092
            ],
            [
              -41.6585,
              -4.3953
            ],
            [
              -41.6577,
              -4.3839
            ],
            [
              -41.6674,
              -4.3538
            ],
            [
              -41.6646,
              -4.3458
            ],
            [
              -41.6547,
              -4.3446
            ],
            [
              -41.6482,
              -4.3484
            ],
            [
              -41.6418,
              -4.3462
            ],
            [
              -41.6365,
              -4.35
            ],
            [
              -41.6274,
              -4.34
            ],
            [
              -41.6173,
              -4.3389
            ],
            [
              -41.6128,
              -4.3264
            ],
            [
              -41.6165,
              -4.318
            ],
            [
              -41.6065,
              -4.3108
            ],
            [
              -41.6084,
              -4.3018
            ],
            [
              -41.5966,
              -4.2952
            ],
            [
              -41.5937,
              -4.3022
            ],
            [
              -41.5823,
              -4.3037
            ],
            [
              -41.5786,
              -4.3093
            ],
            [
              -41.5687,
              -4.3062
            ],
            [
              -41.5608,
              -4.3103
            ],
            [
              -41.525,
              -4.2567
            ],
            [
              -41.4973,
              -4.1804
            ],
            [
              -41.5038,
              -4.176
            ],
            [
              -41.5139,
              -4.175
            ],
            [
              -41.5254,
              -4.1636
            ],
            [
              -41.5397,
              -4.1603
            ],
            [
              -41.5456,
              -4.1639
            ],
            [
              -41.5617,
              -4.1586
            ],
            [
              -41.5747,
              -4.1594
            ],
            [
              -41.5776,
              -4.1457
            ],
            [
              -41.6568,
              -4.2198
            ],
            [
              -41.7612,
              -4.2088
            ],
            [
              -41.7999,
              -4.1735
            ],
            [
              -41.799,
              -4.1906
            ],
            [
              -41.8045,
              -4.2022
            ],
            [
              -41.9214,
              -4.1814
            ],
            [
              -41.9213,
              -4.1841
            ],
            [
              -41.9189,
              -4.2239
            ],
            [
              -41.9332,
              -4.2259
            ],
            [
              -41.9544,
              -4.2207
            ],
            [
              -41.964,
              -4.2341
            ],
            [
              -41.9789,
              -4.2462
            ],
            [
              -41.9966,
              -4.2452
            ],
            [
              -42.0005,
              -4.2722
            ],
            [
              -42.0005,
              -4.3441
            ],
            [
              -42.0269,
              -4.3542
            ],
            [
              -42.0164,
              -4.367
            ],
            [
              -42.0216,
              -4.3721
            ],
            [
              -42.0193,
              -4.3811
            ],
            [
              -42.0125,
              -4.3844
            ],
            [
              -42.0079,
              -4.3808
            ],
            [
              -41.9905,
              -4.3889
            ],
            [
              -41.9875,
              -4.3948
            ],
            [
              -41.9679,
              -4.4047
            ],
            [
              -41.9669,
              -4.4155
            ],
            [
              -41.9587,
              -4.4246
            ],
            [
              -41.9412,
              -4.4235
            ],
            [
              -41.9291,
              -4.432
            ],
            [
              -41.9189,
              -4.4317
            ],
            [
              -41.9026,
              -4.4278
            ],
            [
              -41.8983,
              -4.4335
            ],
            [
              -41.8903,
              -4.4356
            ],
            [
              -41.8886,
              -4.4473
            ],
            [
              -41.8801,
              -4.4498
            ],
            [
              -41.8739,
              -4.4576
            ],
            [
              -41.8604,
              -4.4626
            ],
            [
              -41.8497,
              -4.4599
            ],
            [
              -41.8367,
              -4.4711
            ],
            [
              -41.8345,
              -4.4815
            ],
            [
              -41.8204,
              -4.497
            ],
            [
              -41.8198,
              -4.5025
            ],
            [
              -41.8113,
              -4.5049
            ],
            [
              -41.8073,
              -4.51
            ],
            [
              -41.7932,
              -4.5113
            ],
            [
              -41.7812,
              -4.5221
            ],
            [
              -41.7799,
              -4.5321
            ],
            [
              -41.7666,
              -4.5364
            ],
            [
              -41.7556,
              -4.545
            ],
            [
              -41.7393,
              -4.5699
            ],
            [
              -41.7303,
              -4.5473
            ],
            [
              -41.6387,
              -4.4632
            ],
            [
              -41.6211,
              -4.4389
            ],
            [
              -41.6053,
              -4.4095
            ]
          ],
          [
            [
              -41.6548,
              -4.7763
            ],
            [
              -41.6187,
              -4.7601
            ],
            [
              -41.5962,
              -4.7557
            ],
            [
              -41.5601,
              -4.745
            ],
            [
              -41.5566,
              -4.7505
            ],
            [
              -41.5572,
              -4.7518
            ],
            [
              -41.5558,
              -4.7527
            ],
            [
              -41.5554,
              -4.7539
            ],
            [
              -41.5559,
              -4.7565
            ],
            [
              -41.5537,
              -4.7572
            ],
            [
              -41.5528,
              -4.7558
            ],
            [
              -41.5514,
              -4.7556
            ],
            [
              -41.5496,
              -4.7559
            ],
            [
              -41.5472,
              -4.7571
            ],
            [
              -41.5449,
              -4.7578
            ],
            [
              -41.5433,
              -4.7593
            ],
            [
              -41.5427,
              -4.762
            ],
            [
              -41.5428,
              -4.7638
            ],
            [
              -41.544,
              -4.7658
            ],
            [
              -41.5395,
              -4.7848
            ],
            [
              -41.5253,
              -4.8283
            ],
            [
              -41.4937,
              -4.8284
            ],
            [
              -41.4729,
              -4.8335
            ],
            [
              -41.451,
              -4.8255
            ],
            [
              -41.4442,
              -4.8412
            ],
            [
              -41.4348,
              -4.8611
            ],
            [
              -41.4124,
              -4.8751
            ],
            [
              -41.384,
              -4.8839
            ],
            [
              -41.3762,
              -4.8786
            ],
            [
              -41.3706,
              -4.8735
            ],
            [
              -41.3681,
              -4.8724
            ],
            [
              -41.3663,
              -4.8724
            ],
            [
              -41.3626,
              -4.8705
            ],
            [
              -41.3576,
              -4.8671
            ],
            [
              -41.3548,
              -4.8661
            ],
            [
              -41.3522,
              -4.8656
            ],
            [
              -41.3477,
              -4.8652
            ],
            [
              -41.3404,
              -4.8682
            ],
            [
              -41.3373,
              -4.8691
            ],
            [
              -41.3339,
              -4.8688
            ],
            [
              -41.3318,
              -4.8678
            ],
            [
              -41.3303,
              -4.8681
            ],
            [
              -41.3276,
              -4.8698
            ],
            [
              -41.3262,
              -4.8713
            ],
            [
              -41.325,
              -4.8713
            ],
            [
              -41.3211,
              -4.8684
            ],
            [
              -41.3164,
              -4.868
            ],
            [
              -41.3138,
              -4.868
            ],
            [
              -41.3119,
              -4.867
            ],
            [
              -41.3104,
              -4.8631
            ],
            [
              -41.3073,
              -4.8593
            ],
            [
              -41.3064,
              -4.8562
            ],
            [
              -41.305,
              -4.8529
            ],
            [
              -41.3029,
              -4.8494
            ],
            [
              -41.2955,
              -4.8527
            ],
            [
              -41.2924,
              -4.8551
            ],
            [
              -41.2893,
              -4.8606
            ],
            [
              -41.2884,
              -4.8603
            ],
            [
              -41.2865,
              -4.8565
            ],
            [
              -41.2841,
              -4.8547
            ],
            [
              -41.2784,
              -4.8534
            ],
            [
              -41.268,
              -4.8116
            ],
            [
              -41.2952,
              -4.8149
            ],
            [
              -41.294,
              -4.6296
            ],
            [
              -41.2935,
              -4.5561
            ],
            [
              -41.3409,
              -4.5615
            ],
            [
              -41.4334,
              -4.5718
            ],
            [
              -41.4858,
              -4.5777
            ],
            [
              -41.5122,
              -4.5807
            ],
            [
              -41.5867,
              -4.5838
            ],
            [
              -41.7294,
              -4.5898
            ],
            [
              -41.7453,
              -4.5904
            ],
            [
              -41.7768,
              -4.6888
            ],
            [
              -41.7469,
              -4.7029
            ],
            [
              -41.7466,
              -4.7033
            ],
            [
              -41.6992,
              -4.7614
            ],
            [
              -41.6954,
              -4.7659
            ],
            [
              -41.6896,
              -4.7642
            ],
            [
              -41.6548,
              -4.7763
            ]
          ],
          [
            [
              -41.313,
              -4.1472
            ],
            [
              -41.3096,
              -4.1441
            ],
            [
              -41.3071,
              -4.147
            ],
            [
              -41.305,
              -4.148
            ],
            [
              -41.3024,
              -4.147
            ],
            [
              -41.3019,
              -4.1483
            ],
            [
              -41.3022,
              -4.1517
            ],
            [
              -41.3031,
              -4.1548
            ],
            [
              -41.3021,
              -4.1569
            ],
            [
              -41.3011,
              -4.1567
            ],
            [
              -41.2994,
              -4.1554
            ],
            [
              -41.297,
              -4.1565
            ],
            [
              -41.2966,
              -4.1598
            ],
            [
              -41.2958,
              -4.1633
            ],
            [
              -41.2946,
              -4.1658
            ],
            [
              -41.295,
              -4.1675
            ],
            [
              -41.2941,
              -4.1682
            ],
            [
              -41.2929,
              -4.1676
            ],
            [
              -41.2909,
              -4.1689
            ],
            [
              -41.285,
              -4.1694
            ],
            [
              -41.2809,
              -4.17
            ],
            [
              -41.2792,
              -4.169
            ],
            [
              -41.277,
              -4.1686
            ],
            [
              -41.2766,
              -4.1667
            ],
            [
              -41.2713,
              -4.1654
            ],
            [
              -41.2674,
              -4.1631
            ],
            [
              -41.2657,
              -4.161
            ],
            [
              -41.2631,
              -4.1618
            ],
            [
              -41.2624,
              -4.1595
            ],
            [
              -41.2624,
              -4.157
            ],
            [
              -41.2619,
              -4.1554
            ],
            [
              -41.2622,
              -4.1541
            ],
            [
              -41.2611,
              -4.152
            ],
            [
              -41.2604,
              -4.1493
            ],
            [
              -41.2596,
              -4.1486
            ],
            [
              -41.259,
              -4.1468
            ],
            [
              -41.2597,
              -4.1457
            ],
            [
              -41.2594,
              -4.1445
            ],
            [
              -41.2581,
              -4.1439
            ],
            [
              -41.2567,
              -4.1424
            ],
            [
              -41.255,
              -4.1431
            ],
            [
              -41.2535,
              -4.1415
            ],
            [
              -41.2523,
              -4.1411
            ],
            [
              -41.2496,
              -4.1385
            ],
            [
              -41.2477,
              -4.1387
            ],
            [
              -41.2451,
              -4.1407
            ],
            [
              -41.2451,
              -4.1417
            ],
            [
              -41.2413,
              -4.1452
            ],
            [
              -41.2408,
              -4.1472
            ],
            [
              -41.2392,
              -4.1497
            ],
            [
              -41.2393,
              -4.1511
            ],
            [
              -41.2375,
              -4.1525
            ],
            [
              -41.2366,
              -4.1539
            ],
            [
              -41.2333,
              -4.1563
            ],
            [
              -41.2316,
              -4.1569
            ],
            [
              -41.2303,
              -4.1567
            ],
            [
              -41.229,
              -4.1553
            ],
            [
              -41.2276,
              -4.1554
            ],
            [
              -41.2263,
              -4.1563
            ],
            [
              -41.2249,
              -4.1582
            ],
            [
              -41.2237,
              -4.1582
            ],
            [
              -41.2222,
              -4.1558
            ],
            [
              -41.2184,
              -4.1567
            ],
            [
              -41.2173,
              -4.1574
            ],
            [
              -41.2153,
              -4.157
            ],
            [
              -41.2135,
              -4.156
            ],
            [
              -41.211,
              -4.1536
            ],
            [
              -41.2095,
              -4.1513
            ],
            [
              -41.209,
              -4.1497
            ],
            [
              -41.2093,
              -4.1469
            ],
            [
              -41.207,
              -4.1469
            ],
            [
              -41.2044,
              -4.1461
            ],
            [
              -41.2036,
              -4.1472
            ],
            [
              -41.2023,
              -4.1469
            ],
            [
              -41.2012,
              -4.1484
            ],
            [
              -41.1999,
              -4.1487
            ],
            [
              -41.1977,
              -4.1475
            ],
            [
              -41.1962,
              -4.1476
            ],
            [
              -41.1959,
              -4.1497
            ],
            [
              -41.1937,
              -4.1523
            ],
            [
              -41.1933,
              -4.1538
            ],
            [
              -41.1918,
              -4.1548
            ],
            [
              -41.1901,
              -4.1551
            ],
            [
              -41.1908,
              -4.1571
            ],
            [
              -41.1903,
              -4.1593
            ],
            [
              -41.1873,
              -4.1606
            ],
            [
              -41.1853,
              -4.1599
            ],
            [
              -41.1833,
              -4.1584
            ],
            [
              -41.181,
              -4.1607
            ],
            [
              -41.1814,
              -4.1621
            ],
            [
              -41.1808,
              -4.1637
            ],
            [
              -41.1798,
              -4.1645
            ],
            [
              -41.179,
              -4.1663
            ],
            [
              -41.1768,
              -4.1691
            ],
            [
              -41.1759,
              -4.1726
            ],
            [
              -41.1762,
              -4.1737
            ],
            [
              -41.1775,
              -4.1751
            ],
            [
              -41.1769,
              -4.1766
            ],
            [
              -41.1744,
              -4.1784
            ],
            [
              -41.1703,
              -4.1803
            ],
            [
              -41.1687,
              -4.1828
            ],
            [
              -41.1651,
              -4.1876
            ],
            [
              -41.1639,
              -4.1883
            ],
            [
              -41.1615,
              -4.1882
            ],
            [
              -41.1594,
              -4.1866
            ],
            [
              -41.1579,
              -4.1864
            ],
            [
              -41.1556,
              -4.1889
            ],
            [
              -41.1546,
              -4.1887
            ],
            [
              -41.1526,
              -4.1874
            ],
            [
              -41.1511,
              -4.1872
            ],
            [
              -41.1497,
              -4.1856
            ],
            [
              -41.147,
              -4.1858
            ],
            [
              -41.145,
              -4.1854
            ],
            [
              -41.1438,
              -4.186
            ],
            [
              -41.1426,
              -4.1857
            ],
            [
              -41.1402,
              -4.1828
            ],
            [
              -41.139,
              -4.1817
            ],
            [
              -41.1359,
              -4.1774
            ],
            [
              -41.135,
              -4.1768
            ],
            [
              -41.131,
              -4.1767
            ],
            [
              -41.1295,
              -4.1772
            ],
            [
              -41.128,
              -4.1764
            ],
            [
              -41.1258,
              -4.176
            ],
            [
              -41.1241,
              -4.1762
            ],
            [
              -41.1224,
              -4.1759
            ],
            [
              -41.1206,
              -4.1775
            ],
            [
              -41.1185,
              -4.1773
            ],
            [
              -41.1159,
              -4.1765
            ],
            [
              -41.1137,
              -4.178
            ],
            [
              -41.1114,
              -4.1791
            ],
            [
              -41.1095,
              -4.1795
            ],
            [
              -41.1069,
              -4.1791
            ],
            [
              -41.1058,
              -4.1797
            ],
            [
              -41.1036,
              -4.1798
            ],
            [
              -41.1017,
              -4.1804
            ],
            [
              -41.0981,
              -4.1805
            ],
            [
              -41.0909,
              -4.1703
            ],
            [
              -41.0939,
              -4.1699
            ],
            [
              -41.097,
              -4.1707
            ],
            [
              -41.1058,
              -4.1696
            ],
            [
              -41.1113,
              -4.1669
            ],
            [
              -41.1176,
              -4.1657
            ],
            [
              -41.1183,
              -4.1652
            ],
            [
              -41.121,
              -4.1605
            ],
            [
              -41.1231,
              -4.1582
            ],
            [
              -41.1237,
              -4.1562
            ],
            [
              -41.1254,
              -4.1545
            ],
            [
              -41.1268,
              -4.1507
            ],
            [
              -41.1258,
              -4.1485
            ],
            [
              -41.1253,
              -4.1449
            ],
            [
              -41.1281,
              -4.1393
            ],
            [
              -41.1343,
              -4.1317
            ],
            [
              -41.1421,
              -4.1256
            ],
            [
              -41.1431,
              -4.1242
            ],
            [
              -41.1408,
              -4.1236
            ],
            [
              -41.1394,
              -4.121
            ],
            [
              -41.1371,
              -4.1169
            ],
            [
              -41.1344,
              -4.1049
            ],
            [
              -41.1289,
              -4.0973
            ],
            [
              -41.1281,
              -4.0942
            ],
            [
              -41.1276,
              -4.0887
            ],
            [
              -41.1222,
              -4.0772
            ],
            [
              -41.1216,
              -4.0742
            ],
            [
              -41.122,
              -4.0722
            ],
            [
              -41.1275,
              -4.0661
            ],
            [
              -41.1279,
              -4.0639
            ],
            [
              -41.1272,
              -4.0614
            ],
            [
              -41.1258,
              -4.0603
            ],
            [
              -41.1164,
              -4.0541
            ],
            [
              -41.1141,
              -4.0518
            ],
            [
              -41.1132,
              -4.0498
            ],
            [
              -41.1132,
              -4.047
            ],
            [
              -41.1125,
              -4.0442
            ],
            [
              -41.1129,
              -4.0417
            ],
            [
              -41.1143,
              -4.0406
            ],
            [
              -41.1203,
              -4.0363
            ],
            [
              -41.1222,
              -4.037
            ],
            [
              -41.1239,
              -4.0371
            ],
            [
              -41.1302,
              -4.0354
            ],
            [
              -41.1337,
              -4.0352
            ],
            [
              -41.1431,
              -4.0368
            ],
            [
              -41.1533,
              -4.0349
            ],
            [
              -41.16,
              -4.0317
            ],
            [
              -41.1635,
              -4.0318
            ],
            [
              -41.1688,
              -4.0331
            ],
            [
              -41.1718,
              -4.0325
            ],
            [
              -41.176,
              -4.0288
            ],
            [
              -41.1807,
              -4.0277
            ],
            [
              -41.182,
              -4.0267
            ],
            [
              -41.1838,
              -4.0244
            ],
            [
              -41.1822,
              -4.0192
            ],
            [
              -41.1829,
              -4.018
            ],
            [
              -41.1855,
              -4.0172
            ],
            [
              -41.1886,
              -4.0176
            ],
            [
              -41.1916,
              -4.019
            ],
            [
              -41.1926,
              -4.0207
            ],
            [
              -41.1958,
              -4.0203
            ],
            [
              -41.1978,
              -4.0184
            ],
            [
              -41.1995,
              -4.0184
            ],
            [
              -41.2033,
              -4.0225
            ],
            [
              -41.206,
              -4.0243
            ],
            [
              -41.2089,
              -4.0256
            ],
            [
              -41.2107,
              -4.0258
            ],
            [
              -41.2141,
              -4.0242
            ],
            [
              -41.2221,
              -4.0271
            ],
            [
              -41.2229,
              -4.0284
            ],
            [
              -41.2244,
              -4.0286
            ],
            [
              -41.2268,
              -4.0272
            ],
            [
              -41.2309,
              -4.0289
            ],
            [
              -41.2403,
              -4.0308
            ],
            [
              -41.2502,
              -4.0378
            ],
            [
              -41.2521,
              -4.0378
            ],
            [
              -41.2547,
              -4.0371
            ],
            [
              -41.2567,
              -4.0348
            ],
            [
              -41.2556,
              -4.0326
            ],
            [
              -41.2555,
              -4.0297
            ],
            [
              -41.2544,
              -4.0277
            ],
            [
              -41.2529,
              -4.0265
            ],
            [
              -41.2507,
              -4.0268
            ],
            [
              -41.2495,
              -4.0264
            ],
            [
              -41.2446,
              -4.022
            ],
            [
              -41.2438,
              -4.0197
            ],
            [
              -41.2395,
              -4.0169
            ],
            [
              -41.2388,
              -4.0154
            ],
            [
              -41.2392,
              -4.0131
            ],
            [
              -41.2426,
              -4.0099
            ],
            [
              -41.2443,
              -4.0068
            ],
            [
              -41.2457,
              -4.0066
            ],
            [
              -41.2458,
              -4.0039
            ],
            [
              -41.2464,
              -4.0013
            ],
            [
              -41.2479,
              -3.9994
            ],
            [
              -41.2473,
              -3.997
            ],
            [
              -41.2474,
              -3.9932
            ],
            [
              -41.2492,
              -3.9899
            ],
            [
              -41.2477,
              -3.9891
            ],
            [
              -41.2468,
              -3.9879
            ],
            [
              -41.2442,
              -3.9864
            ],
            [
              -41.2441,
              -3.9842
            ],
            [
              -41.2447,
              -3.983
            ],
            [
              -41.2444,
              -3.9798
            ],
            [
              -41.2438,
              -3.9793
            ],
            [
              -41.2416,
              -3.9799
            ],
            [
              -41.2401,
              -3.9792
            ],
            [
              -41.2396,
              -3.9771
            ],
            [
              -41.2386,
              -3.9757
            ],
            [
              -41.2388,
              -3.9739
            ],
            [
              -41.2382,
              -3.9728
            ],
            [
              -41.2338,
              -3.9706
            ],
            [
              -41.2343,
              -3.9678
            ],
            [
              -41.2313,
              -3.9665
            ],
            [
              -41.2289,
              -3.9681
            ],
            [
              -41.2202,
              -3.9415
            ],
            [
              -41.2289,
              -3.9117
            ],
            [
              -41.23,
              -3.9109
            ],
            [
              -41.2326,
              -3.9108
            ],
            [
              -41.2333,
              -3.9103
            ],
            [
              -41.2356,
              -3.906
            ],
            [
              -41.239,
              -3.9035
            ],
            [
              -41.2417,
              -3.9005
            ],
            [
              -41.2453,
              -3.8983
            ],
            [
              -41.2457,
              -3.8964
            ],
            [
              -41.2447,
              -3.8933
            ],
            [
              -41.2466,
              -3.8845
            ],
            [
              -41.2476,
              -3.8823
            ],
            [
              -41.2535,
              -3.8759
            ],
            [
              -41.2554,
              -3.8729
            ],
            [
              -41.2589,
              -3.8703
            ],
            [
              -41.2597,
              -3.8687
            ],
            [
              -41.26,
              -3.8648
            ],
            [
              -41.2613,
              -3.864
            ],
            [
              -41.2669,
              -3.8627
            ],
            [
              -41.2678,
              -3.8612
            ],
            [
              -41.2669,
              -3.8605
            ],
            [
              -41.2668,
              -3.8589
            ],
            [
              -41.2701,
              -3.8544
            ],
            [
              -41.2704,
              -3.8523
            ],
            [
              -41.2681,
              -3.8483
            ],
            [
              -41.269,
              -3.8459
            ],
            [
              -41.2686,
              -3.8445
            ],
            [
              -41.2713,
              -3.8419
            ],
            [
              -41.2707,
              -3.8378
            ],
            [
              -41.272,
              -3.8365
            ],
            [
              -41.2737,
              -3.8357
            ],
            [
              -41.2751,
              -3.8339
            ],
            [
              -41.2752,
              -3.8302
            ],
            [
              -41.2769,
              -3.8256
            ],
            [
              -41.278,
              -3.8245
            ],
            [
              -41.279,
              -3.8246
            ],
            [
              -41.2814,
              -3.8268
            ],
            [
              -41.2827,
              -3.8268
            ],
            [
              -41.2847,
              -3.8255
            ],
            [
              -41.2867,
              -3.8227
            ],
            [
              -41.2879,
              -3.8225
            ],
            [
              -41.2894,
              -3.8255
            ],
            [
              -41.2925,
              -3.8258
            ],
            [
              -41.2942,
              -3.8295
            ],
            [
              -41.2952,
              -3.8302
            ],
            [
              -41.2967,
              -3.8294
            ],
            [
              -41.299,
              -3.8261
            ],
            [
              -41.3008,
              -3.8263
            ],
            [
              -41.2987,
              -3.8232
            ],
            [
              -41.2944,
              -3.8186
            ],
            [
              -41.2898,
              -3.8148
            ],
            [
              -41.2805,
              -3.8055
            ],
            [
              -41.2756,
              -3.8023
            ],
            [
              -41.2708,
              -3.7968
            ],
            [
              -41.2648,
              -3.7916
            ],
            [
              -41.2626,
              -3.7888
            ],
            [
              -41.2541,
              -3.775
            ],
            [
              -41.2538,
              -3.7734
            ],
            [
              -41.2548,
              -3.7703
            ],
            [
              -41.2605,
              -3.7625
            ],
            [
              -41.2612,
              -3.7575
            ],
            [
              -41.2615,
              -3.7519
            ],
            [
              -41.2613,
              -3.7462
            ],
            [
              -41.26,
              -3.7393
            ],
            [
              -41.2585,
              -3.7328
            ],
            [
              -41.2574,
              -3.7299
            ],
            [
              -41.2531,
              -3.7242
            ],
            [
              -41.2519,
              -3.7233
            ],
            [
              -41.2472,
              -3.7221
            ],
            [
              -41.2394,
              -3.7207
            ],
            [
              -41.2385,
              -3.7199
            ],
            [
              -41.2381,
              -3.7178
            ],
            [
              -41.2383,
              -3.7158
            ],
            [
              -41.2393,
              -3.7128
            ],
            [
              -41.2418,
              -3.711
            ],
            [
              -41.2454,
              -3.7109
            ],
            [
              -41.2474,
              -3.7099
            ],
            [
              -41.2502,
              -3.7066
            ],
            [
              -41.2554,
              -3.7033
            ],
            [
              -41.2583,
              -3.7036
            ],
            [
              -41.2717,
              -3.7034
            ],
            [
              -41.2793,
              -3.7007
            ],
            [
              -41.283,
              -3.697
            ],
            [
              -41.2861,
              -3.6922
            ],
            [
              -41.2877,
              -3.6909
            ],
            [
              -41.2908,
              -3.6897
            ],
            [
              -41.2999,
              -3.6875
            ],
            [
              -41.3077,
              -3.6848
            ],
            [
              -41.3169,
              -3.6866
            ],
            [
              -41.3208,
              -3.6868
            ],
            [
              -41.3225,
              -3.6878
            ],
            [
              -41.3265,
              -3.6873
            ],
            [
              -41.3289,
              -3.6863
            ],
            [
              -41.3318,
              -3.6858
            ],
            [
              -41.3342,
              -3.684
            ],
            [
              -41.3347,
              -3.6915
            ],
            [
              -41.3133,
              -3.7394
            ],
            [
              -41.2786,
              -3.77
            ],
            [
              -41.3659,
              -3.8848
            ],
            [
              -41.4504,
              -3.9961
            ],
            [
              -41.4849,
              -4.0415
            ],
            [
              -41.336,
              -4.0515
            ],
            [
              -41.313,
              -4.1472
            ]
          ],
          [
            [
              -41.9621,
              -3.6793
            ],
            [
              -41.9694,
              -3.685
            ],
            [
              -41.9724,
              -3.6882
            ],
            [
              -41.9733,
              -3.6898
            ],
            [
              -41.9754,
              -3.6969
            ],
            [
              -41.9759,
              -3.7023
            ],
            [
              -41.9753,
              -3.7059
            ],
            [
              -41.9754,
              -3.7111
            ],
            [
              -41.9768,
              -3.7161
            ],
            [
              -41.9758,
              -3.7228
            ],
            [
              -41.9768,
              -3.7262
            ],
            [
              -41.9781,
              -3.7288
            ],
            [
              -41.9785,
              -3.7309
            ],
            [
              -41.9777,
              -3.7369
            ],
            [
              -41.9782,
              -3.7401
            ],
            [
              -41.9775,
              -3.7429
            ],
            [
              -41.9766,
              -3.7483
            ],
            [
              -41.9757,
              -3.7517
            ],
            [
              -41.9754,
              -3.7541
            ],
            [
              -41.9768,
              -3.7573
            ],
            [
              -41.9766,
              -3.7604
            ],
            [
              -41.9755,
              -3.7631
            ],
            [
              -41.9753,
              -3.7649
            ],
            [
              -41.9759,
              -3.7663
            ],
            [
              -41.9791,
              -3.7695
            ],
            [
              -41.9809,
              -3.7719
            ],
            [
              -41.9816,
              -3.7738
            ],
            [
              -41.9813,
              -3.777
            ],
            [
              -41.9806,
              -3.7797
            ],
            [
              -41.9811,
              -3.784
            ],
            [
              -41.8984,
              -3.7967
            ],
            [
              -41.9019,
              -3.8641
            ],
            [
              -41.9031,
              -3.8869
            ],
            [
              -41.8656,
              -3.8483
            ],
            [
              -41.8355,
              -3.8484
            ],
            [
              -41.6864,
              -3.797
            ],
            [
              -41.6866,
              -3.7926
            ],
            [
              -41.6866,
              -3.7815
            ],
            [
              -41.7131,
              -3.771
            ],
            [
              -41.7418,
              -3.7662
            ],
            [
              -41.8183,
              -3.7534
            ],
            [
              -41.8239,
              -3.7533
            ],
            [
              -41.8252,
              -3.7548
            ],
            [
              -41.8259,
              -3.7548
            ],
            [
              -41.8278,
              -3.7533
            ],
            [
              -41.8298,
              -3.7534
            ],
            [
              -41.8666,
              -3.7209
            ],
            [
              -41.8976,
              -3.6981
            ],
            [
              -41.9041,
              -3.693
            ],
            [
              -41.9245,
              -3.6771
            ],
            [
              -41.9262,
              -3.6788
            ],
            [
              -41.9274,
              -3.6794
            ],
            [
              -41.9345,
              -3.6802
            ],
            [
              -41.9447,
              -3.6806
            ],
            [
              -41.948,
              -3.6795
            ],
            [
              -41.9504,
              -3.6767
            ],
            [
              -41.954,
              -3.6758
            ],
            [
              -41.9571,
              -3.6762
            ],
            [
              -41.9621,
              -3.6793
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              -42.548,
              -4.345
            ],
            [
              -42.4826,
              -4.344
            ],
            [
              -42.4479,
              -4.3344
            ],
            [
              -42.4196,
              -4.3435
            ],
            [
              -42.4173,
              -4.3399
            ],
            [
              -42.1959,
              -4.3809
            ],
            [
              -42.1817,
              -4.3819
            ],
            [
              -42.1741,
              -4.3726
            ],
            [
              -42.1775,
              -4.3673
            ],
            [
              -42.1775,
              -4.3577
            ],
            [
              -42.1821,
              -4.3494
            ],
            [
              -42.1818,
              -4.3402
            ],
            [
              -42.178,
              -4.3263
            ],
            [
              -42.1841,
              -4.3075
            ],
            [
              -42.1935,
              -4.2974
            ],
            [
              -42.1852,
              -4.2867
            ],
            [
              -42.1868,
              -4.2777
            ],
            [
              -42.1946,
              -4.2709
            ],
            [
              -42.1786,
              -4.2696
            ],
            [
              -42.1606,
              -4.2709
            ],
            [
              -42.1548,
              -4.2742
            ],
            [
              -42.1333,
              -4.2721
            ],
            [
              -42.1252,
              -4.2735
            ],
            [
              -42.1221,
              -4.2667
            ],
            [
              -42.1112,
              -4.2661
            ],
            [
              -42.1002,
              -4.2706
            ],
            [
              -42.0635,
              -4.2739
            ],
            [
              -42.0415,
              -4.2714
            ],
            [
              -42.0306,
              -4.2667
            ],
            [
              -42.0113,
              -4.2674
            ],
            [
              -42.0005,
              -4.2722
            ],
            [
              -41.9966,
              -4.2452
            ],
            [
              -41.9969,
              -4.2078
            ],
            [
              -42.0154,
              -4.2
            ],
            [
              -42.0511,
              -4.1811
            ],
            [
              -42.0563,
              -4.191
            ],
            [
              -42.0632,
              -4.1917
            ],
            [
              -42.0768,
              -4.2053
            ],
            [
              -42.0938,
              -4.2031
            ],
            [
              -42.11,
              -4.2107
            ],
            [
              -42.1164,
              -4.207
            ],
            [
              -42.13,
              -4.2123
            ],
            [
              -42.1337,
              -4.2171
            ],
            [
              -42.1425,
              -4.2168
            ],
            [
              -42.1563,
              -4.2202
            ],
            [
              -42.1723,
              -4.2174
            ],
            [
              -42.1834,
              -4.2208
            ],
            [
              -42.193,
              -4.2169
            ],
            [
              -42.2078,
              -4.2257
            ],
            [
              -42.213,
              -4.2208
            ],
            [
              -42.2275,
              -4.2273
            ],
            [
              -42.2376,
              -4.2241
            ],
            [
              -42.2354,
              -4.2177
            ],
            [
              -42.2397,
              -4.2121
            ],
            [
              -42.2388,
              -4.2015
            ],
            [
              -42.234,
              -4.1949
            ],
            [
              -42.242,
              -4.1673
            ],
            [
              -42.2489,
              -4.1618
            ],
            [
              -42.2634,
              -4.1703
            ],
            [
              -42.2667,
              -4.1609
            ],
            [
              -42.2612,
              -4.1562
            ],
            [
              -42.2625,
              -4.1503
            ],
            [
              -42.2536,
              -4.1414
            ],
            [
              -42.2509,
              -4.1268
            ],
            [
              -42.2598,
              -4.1223
            ],
            [
              -42.2575,
              -4.1157
            ],
            [
              -42.2589,
              -4.1046
            ],
            [
              -42.2638,
              -4.0895
            ],
            [
              -42.2545,
              -4.0778
            ],
            [
              -42.2573,
              -4.0733
            ],
            [
              -42.2564,
              -4.0628
            ],
            [
              -42.2638,
              -4.0547
            ],
            [
              -42.2581,
              -4.0492
            ],
            [
              -42.2619,
              -4.0278
            ],
            [
              -42.2664,
              -4.025
            ],
            [
              -42.2645,
              -4.0108
            ],
            [
              -42.2595,
              -4.0053
            ],
            [
              -42.2471,
              -3.9996
            ],
            [
              -42.2374,
              -3.9976
            ],
            [
              -42.238,
              -3.9823
            ],
            [
              -42.2295,
              -3.9736
            ],
            [
              -42.2358,
              -3.9594
            ],
            [
              -42.2439,
              -3.9267
            ],
            [
              -42.2454,
              -3.9355
            ],
            [
              -42.2669,
              -3.9394
            ],
            [
              -42.2749,
              -3.9546
            ],
            [
              -42.2722,
              -3.9617
            ],
            [
              -42.2771,
              -3.9788
            ],
            [
              -42.288,
              -3.9759
            ],
            [
              -42.3012,
              -3.986
            ],
            [
              -42.3088,
              -3.9985
            ],
            [
              -42.3255,
              -3.9931
            ],
            [
              -42.3318,
              -3.9853
            ],
            [
              -42.3458,
              -3.9811
            ],
            [
              -42.359,
              -3.9743
            ],
            [
              -42.3734,
              -3.9847
            ],
            [
              -42.3887,
              -3.986
            ],
            [
              -42.4393,
              -3.9686
            ],
            [
              -42.4562,
              -3.9968
            ],
            [
              -42.5127,
              -4.0423
            ],
            [
              -42.5046,
              -4.0549
            ],
            [
              -42.5205,
              -4.0637
            ],
            [
              -42.5305,
              -4.0928
            ],
            [
              -42.5343,
              -4.1003
            ],
            [
              -42.542,
              -4.1045
            ],
            [
              -42.5561,
              -4.1047
            ],
            [
              -42.5901,
              -4.1329
            ],
            [
              -42.6072,
              -4.1303
            ],
            [
              -42.6102,
              -4.1323
            ],
            [
              -42.6231,
              -4.1293
            ],
            [
              -42.6467,
              -4.1309
            ],
            [
              -42.616,
              -4.2379
            ],
            [
              -42.548,
              -4.345
            ]
          ]
        ]
      },
      "properties": {
        "name": "Barras",
        "codarea": "2201200",
        "isPiripiri": false,
        "isMask": false
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              -42.2439,
              -3.9267
            ],
            [
              -42.2358,
              -3.9594
            ],
            [
              -42.2295,
              -3.9736
            ],
            [
              -42.238,
              -3.9823
            ],
            [
              -42.2374,
              -3.9976
            ],
            [
              -42.2471,
              -3.9996
            ],
            [
              -42.2595,
              -4.0053
            ],
            [
              -42.2645,
              -4.0108
            ],
            [
              -42.2664,
              -4.025
            ],
            [
              -42.2619,
              -4.0278
            ],
            [
              -42.2581,
              -4.0492
            ],
            [
              -42.2638,
              -4.0547
            ],
            [
              -42.2564,
              -4.0628
            ],
            [
              -42.2573,
              -4.0733
            ],
            [
              -42.2545,
              -4.0778
            ],
            [
              -42.2638,
              -4.0895
            ],
            [
              -42.2589,
              -4.1046
            ],
            [
              -42.2575,
              -4.1157
            ],
            [
              -42.2598,
              -4.1223
            ],
            [
              -42.2509,
              -4.1268
            ],
            [
              -42.2536,
              -4.1414
            ],
            [
              -42.2625,
              -4.1503
            ],
            [
              -42.2612,
              -4.1562
            ],
            [
              -42.2667,
              -4.1609
            ],
            [
              -42.2634,
              -4.1703
            ],
            [
              -42.2489,
              -4.1618
            ],
            [
              -42.242,
              -4.1673
            ],
            [
              -42.234,
              -4.1949
            ],
            [
              -42.2388,
              -4.2015
            ],
            [
              -42.2397,
              -4.2121
            ],
            [
              -42.2354,
              -4.2177
            ],
            [
              -42.2376,
              -4.2241
            ],
            [
              -42.2275,
              -4.2273
            ],
            [
              -42.213,
              -4.2208
            ],
            [
              -42.2078,
              -4.2257
            ],
            [
              -42.193,
              -4.2169
            ],
            [
              -42.1834,
              -4.2208
            ],
            [
              -42.1723,
              -4.2174
            ],
            [
              -42.1563,
              -4.2202
            ],
            [
              -42.1425,
              -4.2168
            ],
            [
              -42.1337,
              -4.2171
            ],
            [
              -42.13,
              -4.2123
            ],
            [
              -42.1164,
              -4.207
            ],
            [
              -42.11,
              -4.2107
            ],
            [
              -42.0938,
              -4.2031
            ],
            [
              -42.0768,
              -4.2053
            ],
            [
              -42.0632,
              -4.1917
            ],
            [
              -42.0563,
              -4.191
            ],
            [
              -42.0511,
              -4.1811
            ],
            [
              -42.0154,
              -4.2
            ],
            [
              -41.9969,
              -4.2078
            ],
            [
              -41.9966,
              -4.2452
            ],
            [
              -41.9789,
              -4.2462
            ],
            [
              -41.964,
              -4.2341
            ],
            [
              -41.9544,
              -4.2207
            ],
            [
              -41.9332,
              -4.2259
            ],
            [
              -41.9189,
              -4.2239
            ],
            [
              -41.9213,
              -4.1841
            ],
            [
              -41.9328,
              -4.197
            ],
            [
              -41.8971,
              -4.0857
            ],
            [
              -41.9348,
              -4.0693
            ],
            [
              -41.92,
              -4.062
            ],
            [
              -41.9145,
              -4.0516
            ],
            [
              -41.9134,
              -4.0348
            ],
            [
              -41.9062,
              -4.0421
            ],
            [
              -41.8942,
              -4.0461
            ],
            [
              -41.8868,
              -4.0403
            ],
            [
              -41.8779,
              -4.0405
            ],
            [
              -41.8708,
              -4.0447
            ],
            [
              -41.8559,
              -4.0406
            ],
            [
              -41.8476,
              -3.9738
            ],
            [
              -41.9108,
              -3.9408
            ],
            [
              -41.9031,
              -3.8869
            ],
            [
              -41.8984,
              -3.7967
            ],
            [
              -41.9811,
              -3.784
            ],
            [
              -41.9816,
              -3.7738
            ],
            [
              -41.9753,
              -3.7649
            ],
            [
              -41.9754,
              -3.7541
            ],
            [
              -41.9785,
              -3.7309
            ],
            [
              -41.9758,
              -3.7228
            ],
            [
              -41.9754,
              -3.6969
            ],
            [
              -41.9733,
              -3.6898
            ],
            [
              -41.9621,
              -3.6793
            ],
            [
              -42.0503,
              -3.6803
            ],
            [
              -42.0503,
              -3.7913
            ],
            [
              -42.0351,
              -3.7913
            ],
            [
              -42.0246,
              -3.808
            ],
            [
              -42.0203,
              -3.8098
            ],
            [
              -42.0024,
              -3.8012
            ],
            [
              -41.995,
              -3.7995
            ],
            [
              -41.9868,
              -3.8059
            ],
            [
              -41.9798,
              -3.803
            ],
            [
              -41.974,
              -3.8095
            ],
            [
              -41.9878,
              -3.8232
            ],
            [
              -41.9891,
              -3.8314
            ],
            [
              -41.9839,
              -3.8395
            ],
            [
              -41.9772,
              -3.8433
            ],
            [
              -41.9798,
              -3.8511
            ],
            [
              -41.9785,
              -3.8603
            ],
            [
              -41.9911,
              -3.8705
            ],
            [
              -42.0091,
              -3.8749
            ],
            [
              -42.0272,
              -3.8744
            ],
            [
              -42.0441,
              -3.8767
            ],
            [
              -42.0519,
              -3.8859
            ],
            [
              -42.0677,
              -3.8861
            ],
            [
              -42.0625,
              -3.8951
            ],
            [
              -42.065,
              -3.905
            ],
            [
              -42.0724,
              -3.9181
            ],
            [
              -42.0923,
              -3.9158
            ],
            [
              -42.0982,
              -3.9108
            ],
            [
              -42.105,
              -3.9167
            ],
            [
              -42.1175,
              -3.9107
            ],
            [
              -42.1193,
              -3.8987
            ],
            [
              -42.1379,
              -3.9005
            ],
            [
              -42.1487,
              -3.9041
            ],
            [
              -42.1694,
              -3.8897
            ],
            [
              -42.1742,
              -3.8964
            ],
            [
              -42.1733,
              -3.9096
            ],
            [
              -42.1821,
              -3.913
            ],
            [
              -42.1871,
              -3.9058
            ],
            [
              -42.1946,
              -3.9095
            ],
            [
              -42.2044,
              -3.9189
            ],
            [
              -42.2119,
              -3.9156
            ],
            [
              -42.209,
              -3.9055
            ],
            [
              -42.2188,
              -3.8986
            ],
            [
              -42.2335,
              -3.9056
            ],
            [
              -42.2444,
              -3.9143
            ],
            [
              -42.2439,
              -3.9267
            ]
          ]
        ]
      },
      "properties": {
        "name": "Batalha",
        "codarea": "2201507",
        "isPiripiri": false,
        "isMask": false
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              -42.061,
              -4.434
            ],
            [
              -42.0584,
              -4.4035
            ],
            [
              -42.0793,
              -4.3742
            ],
            [
              -42.0269,
              -4.3542
            ],
            [
              -42.0005,
              -4.3441
            ],
            [
              -42.0005,
              -4.2722
            ],
            [
              -42.0113,
              -4.2674
            ],
            [
              -42.0306,
              -4.2667
            ],
            [
              -42.0415,
              -4.2714
            ],
            [
              -42.0635,
              -4.2739
            ],
            [
              -42.1002,
              -4.2706
            ],
            [
              -42.1112,
              -4.2661
            ],
            [
              -42.1221,
              -4.2667
            ],
            [
              -42.1252,
              -4.2735
            ],
            [
              -42.1333,
              -4.2721
            ],
            [
              -42.1548,
              -4.2742
            ],
            [
              -42.1606,
              -4.2709
            ],
            [
              -42.1786,
              -4.2696
            ],
            [
              -42.1946,
              -4.2709
            ],
            [
              -42.1868,
              -4.2777
            ],
            [
              -42.1852,
              -4.2867
            ],
            [
              -42.1935,
              -4.2974
            ],
            [
              -42.1841,
              -4.3075
            ],
            [
              -42.178,
              -4.3263
            ],
            [
              -42.1818,
              -4.3402
            ],
            [
              -42.1821,
              -4.3494
            ],
            [
              -42.1775,
              -4.3577
            ],
            [
              -42.1775,
              -4.3673
            ],
            [
              -42.1741,
              -4.3726
            ],
            [
              -42.1817,
              -4.3819
            ],
            [
              -42.1959,
              -4.3809
            ],
            [
              -42.1846,
              -4.391
            ],
            [
              -42.1768,
              -4.4012
            ],
            [
              -42.1816,
              -4.4112
            ],
            [
              -42.1792,
              -4.4163
            ],
            [
              -42.1674,
              -4.4235
            ],
            [
              -42.1658,
              -4.4374
            ],
            [
              -42.1668,
              -4.4516
            ],
            [
              -42.178,
              -4.4626
            ],
            [
              -42.1684,
              -4.464
            ],
            [
              -42.169,
              -4.4708
            ],
            [
              -42.1617,
              -4.4767
            ],
            [
              -42.1532,
              -4.4739
            ],
            [
              -42.1505,
              -4.4822
            ],
            [
              -42.061,
              -4.434
            ]
          ]
        ]
      },
      "properties": {
        "name": "Boa Hora",
        "codarea": "2201770",
        "isPiripiri": false,
        "isMask": false
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              -41.9213,
              -4.1841
            ],
            [
              -41.9214,
              -4.1814
            ],
            [
              -41.8045,
              -4.2022
            ],
            [
              -41.799,
              -4.1906
            ],
            [
              -41.7999,
              -4.1735
            ],
            [
              -41.7612,
              -4.2088
            ],
            [
              -41.6568,
              -4.2198
            ],
            [
              -41.5776,
              -4.1457
            ],
            [
              -41.5747,
              -4.1594
            ],
            [
              -41.5617,
              -4.1586
            ],
            [
              -41.5456,
              -4.1639
            ],
            [
              -41.5397,
              -4.1603
            ],
            [
              -41.5254,
              -4.1636
            ],
            [
              -41.5139,
              -4.175
            ],
            [
              -41.5038,
              -4.176
            ],
            [
              -41.4973,
              -4.1804
            ],
            [
              -41.4946,
              -4.1832
            ],
            [
              -41.4792,
              -4.1836
            ],
            [
              -41.4736,
              -4.1871
            ],
            [
              -41.4563,
              -4.1863
            ],
            [
              -41.4521,
              -4.192
            ],
            [
              -41.4396,
              -4.1817
            ],
            [
              -41.432,
              -4.1813
            ],
            [
              -41.4278,
              -4.174
            ],
            [
              -41.426,
              -4.1601
            ],
            [
              -41.4151,
              -4.1556
            ],
            [
              -41.41,
              -4.1485
            ],
            [
              -41.4002,
              -4.158
            ],
            [
              -41.3939,
              -4.1611
            ],
            [
              -41.3765,
              -4.1581
            ],
            [
              -41.3713,
              -4.1472
            ],
            [
              -41.3514,
              -4.1402
            ],
            [
              -41.3426,
              -4.1399
            ],
            [
              -41.3326,
              -4.1452
            ],
            [
              -41.3318,
              -4.1513
            ],
            [
              -41.313,
              -4.1472
            ],
            [
              -41.336,
              -4.0515
            ],
            [
              -41.4849,
              -4.0415
            ],
            [
              -41.5006,
              -4.0426
            ],
            [
              -41.5553,
              -4.0574
            ],
            [
              -41.6221,
              -4.0604
            ],
            [
              -41.6319,
              -4.1356
            ],
            [
              -41.7745,
              -4.1005
            ],
            [
              -41.7607,
              -4.0975
            ],
            [
              -41.7502,
              -4.0791
            ],
            [
              -41.738,
              -4.0719
            ],
            [
              -41.7364,
              -4.0635
            ],
            [
              -41.7379,
              -4.0453
            ],
            [
              -41.7718,
              -4.034
            ],
            [
              -41.8558,
              -4.0423
            ],
            [
              -41.8559,
              -4.0406
            ],
            [
              -41.8708,
              -4.0447
            ],
            [
              -41.8779,
              -4.0405
            ],
            [
              -41.8868,
              -4.0403
            ],
            [
              -41.8942,
              -4.0461
            ],
            [
              -41.9062,
              -4.0421
            ],
            [
              -41.9134,
              -4.0348
            ],
            [
              -41.9145,
              -4.0516
            ],
            [
              -41.92,
              -4.062
            ],
            [
              -41.9348,
              -4.0693
            ],
            [
              -41.8971,
              -4.0857
            ],
            [
              -41.9328,
              -4.197
            ],
            [
              -41.9213,
              -4.1841
            ]
          ]
        ]
      },
      "properties": {
        "name": "Brasileira",
        "codarea": "2201960",
        "isPiripiri": false,
        "isMask": false
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              -42.0346,
              -4.5292
            ],
            [
              -42.0131,
              -4.5295
            ],
            [
              -41.9875,
              -4.5282
            ],
            [
              -41.964,
              -4.5293
            ],
            [
              -41.9218,
              -4.5439
            ],
            [
              -41.8954,
              -4.5693
            ],
            [
              -41.8792,
              -4.5901
            ],
            [
              -41.8603,
              -4.6046
            ],
            [
              -41.8402,
              -4.6246
            ],
            [
              -41.8501,
              -4.6313
            ],
            [
              -41.8569,
              -4.6431
            ],
            [
              -41.857,
              -4.6634
            ],
            [
              -41.8643,
              -4.6805
            ],
            [
              -41.8799,
              -4.6805
            ],
            [
              -41.8188,
              -4.6971
            ],
            [
              -41.778,
              -4.6921
            ],
            [
              -41.7768,
              -4.6888
            ],
            [
              -41.7453,
              -4.5904
            ],
            [
              -41.7393,
              -4.5699
            ],
            [
              -41.7556,
              -4.545
            ],
            [
              -41.7666,
              -4.5364
            ],
            [
              -41.7799,
              -4.5321
            ],
            [
              -41.7812,
              -4.5221
            ],
            [
              -41.7932,
              -4.5113
            ],
            [
              -41.8073,
              -4.51
            ],
            [
              -41.8113,
              -4.5049
            ],
            [
              -41.8198,
              -4.5025
            ],
            [
              -41.8204,
              -4.497
            ],
            [
              -41.8345,
              -4.4815
            ],
            [
              -41.8367,
              -4.4711
            ],
            [
              -41.8497,
              -4.4599
            ],
            [
              -41.8604,
              -4.4626
            ],
            [
              -41.8739,
              -4.4576
            ],
            [
              -41.8801,
              -4.4498
            ],
            [
              -41.8886,
              -4.4473
            ],
            [
              -41.8903,
              -4.4356
            ],
            [
              -41.8983,
              -4.4335
            ],
            [
              -41.9026,
              -4.4278
            ],
            [
              -41.9189,
              -4.4317
            ],
            [
              -41.9291,
              -4.432
            ],
            [
              -41.9412,
              -4.4235
            ],
            [
              -41.9587,
              -4.4246
            ],
            [
              -41.9669,
              -4.4155
            ],
            [
              -41.9679,
              -4.4047
            ],
            [
              -41.9875,
              -4.3948
            ],
            [
              -41.9905,
              -4.3889
            ],
            [
              -42.0079,
              -4.3808
            ],
            [
              -42.0125,
              -4.3844
            ],
            [
              -42.0193,
              -4.3811
            ],
            [
              -42.0216,
              -4.3721
            ],
            [
              -42.0164,
              -4.367
            ],
            [
              -42.0269,
              -4.3542
            ],
            [
              -42.0793,
              -4.3742
            ],
            [
              -42.0584,
              -4.4035
            ],
            [
              -42.061,
              -4.434
            ],
            [
              -42.0497,
              -4.4528
            ],
            [
              -42.0574,
              -4.464
            ],
            [
              -42.0557,
              -4.5278
            ],
            [
              -42.0346,
              -4.5292
            ]
          ]
        ]
      },
      "properties": {
        "name": "Capitão de Campos",
        "codarea": "2202406",
        "isPiripiri": false,
        "isMask": false
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              -41.313,
              -4.1472
            ],
            [
              -41.3318,
              -4.1513
            ],
            [
              -41.3326,
              -4.1452
            ],
            [
              -41.3426,
              -4.1399
            ],
            [
              -41.3514,
              -4.1402
            ],
            [
              -41.3713,
              -4.1472
            ],
            [
              -41.3765,
              -4.1581
            ],
            [
              -41.3939,
              -4.1611
            ],
            [
              -41.4002,
              -4.158
            ],
            [
              -41.41,
              -4.1485
            ],
            [
              -41.4151,
              -4.1556
            ],
            [
              -41.426,
              -4.1601
            ],
            [
              -41.4278,
              -4.174
            ],
            [
              -41.432,
              -4.1813
            ],
            [
              -41.4396,
              -4.1817
            ],
            [
              -41.4521,
              -4.192
            ],
            [
              -41.4563,
              -4.1863
            ],
            [
              -41.4736,
              -4.1871
            ],
            [
              -41.4792,
              -4.1836
            ],
            [
              -41.4946,
              -4.1832
            ],
            [
              -41.4973,
              -4.1804
            ],
            [
              -41.525,
              -4.2567
            ],
            [
              -41.495,
              -4.2745
            ],
            [
              -41.4876,
              -4.3037
            ],
            [
              -41.4532,
              -4.3013
            ],
            [
              -41.4153,
              -4.311
            ],
            [
              -41.414,
              -4.3147
            ],
            [
              -41.4275,
              -4.3211
            ],
            [
              -41.4184,
              -4.3482
            ],
            [
              -41.399,
              -4.3885
            ],
            [
              -41.3877,
              -4.4325
            ],
            [
              -41.3807,
              -4.4335
            ],
            [
              -41.363,
              -4.3384
            ],
            [
              -41.3568,
              -4.3429
            ],
            [
              -41.2405,
              -4.3757
            ],
            [
              -41.229,
              -4.3404
            ],
            [
              -41.1194,
              -4.3243
            ],
            [
              -41.1191,
              -4.3065
            ],
            [
              -41.1359,
              -4.2335
            ],
            [
              -41.0991,
              -4.1818
            ],
            [
              -41.0981,
              -4.1805
            ],
            [
              -41.1224,
              -4.1759
            ],
            [
              -41.135,
              -4.1768
            ],
            [
              -41.1426,
              -4.1857
            ],
            [
              -41.1651,
              -4.1876
            ],
            [
              -41.1769,
              -4.1766
            ],
            [
              -41.1768,
              -4.1691
            ],
            [
              -41.1833,
              -4.1584
            ],
            [
              -41.1873,
              -4.1606
            ],
            [
              -41.1962,
              -4.1476
            ],
            [
              -41.2044,
              -4.1461
            ],
            [
              -41.2135,
              -4.156
            ],
            [
              -41.2237,
              -4.1582
            ],
            [
              -41.2333,
              -4.1563
            ],
            [
              -41.2413,
              -4.1452
            ],
            [
              -41.2496,
              -4.1385
            ],
            [
              -41.259,
              -4.1468
            ],
            [
              -41.2657,
              -4.161
            ],
            [
              -41.2809,
              -4.17
            ],
            [
              -41.2946,
              -4.1658
            ],
            [
              -41.297,
              -4.1565
            ],
            [
              -41.3031,
              -4.1548
            ],
            [
              -41.305,
              -4.148
            ],
            [
              -41.313,
              -4.1472
            ]
          ]
        ]
      },
      "properties": {
        "name": "Domingos Mourão",
        "codarea": "2203420",
        "isPiripiri": false,
        "isMask": false
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              -41.6053,
              -4.4095
            ],
            [
              -41.5972,
              -4.4054
            ],
            [
              -41.5887,
              -4.4156
            ],
            [
              -41.5801,
              -4.4132
            ],
            [
              -41.568,
              -4.4148
            ],
            [
              -41.5647,
              -4.4097
            ],
            [
              -41.5496,
              -4.4047
            ],
            [
              -41.5442,
              -4.4075
            ],
            [
              -41.5349,
              -4.4044
            ],
            [
              -41.529,
              -4.4106
            ],
            [
              -41.5204,
              -4.406
            ],
            [
              -41.5187,
              -4.3997
            ],
            [
              -41.5109,
              -4.4003
            ],
            [
              -41.5057,
              -4.3887
            ],
            [
              -41.5061,
              -4.3747
            ],
            [
              -41.5015,
              -4.3573
            ],
            [
              -41.5108,
              -4.3482
            ],
            [
              -41.513,
              -4.3316
            ],
            [
              -41.5302,
              -4.3317
            ],
            [
              -41.5368,
              -4.321
            ],
            [
              -41.5414,
              -4.3288
            ],
            [
              -41.5503,
              -4.3209
            ],
            [
              -41.5594,
              -4.3188
            ],
            [
              -41.5608,
              -4.3103
            ],
            [
              -41.5687,
              -4.3062
            ],
            [
              -41.5786,
              -4.3093
            ],
            [
              -41.5823,
              -4.3037
            ],
            [
              -41.5937,
              -4.3022
            ],
            [
              -41.5966,
              -4.2952
            ],
            [
              -41.6084,
              -4.3018
            ],
            [
              -41.6065,
              -4.3108
            ],
            [
              -41.6165,
              -4.318
            ],
            [
              -41.6128,
              -4.3264
            ],
            [
              -41.6173,
              -4.3389
            ],
            [
              -41.6274,
              -4.34
            ],
            [
              -41.6365,
              -4.35
            ],
            [
              -41.6418,
              -4.3462
            ],
            [
              -41.6482,
              -4.3484
            ],
            [
              -41.6547,
              -4.3446
            ],
            [
              -41.6646,
              -4.3458
            ],
            [
              -41.6674,
              -4.3538
            ],
            [
              -41.6577,
              -4.3839
            ],
            [
              -41.6585,
              -4.3953
            ],
            [
              -41.6414,
              -4.4092
            ],
            [
              -41.6337,
              -4.4065
            ],
            [
              -41.6268,
              -4.4091
            ],
            [
              -41.6117,
              -4.4055
            ],
            [
              -41.6053,
              -4.4095
            ]
          ]
        ]
      },
      "properties": {
        "name": "Lagoa de São Francisco",
        "codarea": "2205573",
        "isPiripiri": false,
        "isMask": false
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              -41.6548,
              -4.7763
            ],
            [
              -41.6187,
              -4.7601
            ],
            [
              -41.5962,
              -4.7557
            ],
            [
              -41.5601,
              -4.745
            ],
            [
              -41.5566,
              -4.7505
            ],
            [
              -41.5572,
              -4.7518
            ],
            [
              -41.5558,
              -4.7527
            ],
            [
              -41.5554,
              -4.7539
            ],
            [
              -41.5559,
              -4.7565
            ],
            [
              -41.5537,
              -4.7572
            ],
            [
              -41.5528,
              -4.7558
            ],
            [
              -41.5514,
              -4.7556
            ],
            [
              -41.5496,
              -4.7559
            ],
            [
              -41.5472,
              -4.7571
            ],
            [
              -41.5449,
              -4.7578
            ],
            [
              -41.5433,
              -4.7593
            ],
            [
              -41.5427,
              -4.762
            ],
            [
              -41.5428,
              -4.7638
            ],
            [
              -41.544,
              -4.7658
            ],
            [
              -41.5395,
              -4.7848
            ],
            [
              -41.5253,
              -4.8283
            ],
            [
              -41.4937,
              -4.8284
            ],
            [
              -41.4729,
              -4.8335
            ],
            [
              -41.451,
              -4.8255
            ],
            [
              -41.4442,
              -4.8412
            ],
            [
              -41.4348,
              -4.8611
            ],
            [
              -41.4124,
              -4.8751
            ],
            [
              -41.384,
              -4.8839
            ],
            [
              -41.3762,
              -4.8786
            ],
            [
              -41.3706,
              -4.8735
            ],
            [
              -41.3681,
              -4.8724
            ],
            [
              -41.3663,
              -4.8724
            ],
            [
              -41.3626,
              -4.8705
            ],
            [
              -41.3576,
              -4.8671
            ],
            [
              -41.3548,
              -4.8661
            ],
            [
              -41.3522,
              -4.8656
            ],
            [
              -41.3477,
              -4.8652
            ],
            [
              -41.3404,
              -4.8682
            ],
            [
              -41.3373,
              -4.8691
            ],
            [
              -41.3339,
              -4.8688
            ],
            [
              -41.3318,
              -4.8678
            ],
            [
              -41.3303,
              -4.8681
            ],
            [
              -41.3276,
              -4.8698
            ],
            [
              -41.3262,
              -4.8713
            ],
            [
              -41.325,
              -4.8713
            ],
            [
              -41.3211,
              -4.8684
            ],
            [
              -41.3164,
              -4.868
            ],
            [
              -41.3138,
              -4.868
            ],
            [
              -41.3119,
              -4.867
            ],
            [
              -41.3104,
              -4.8631
            ],
            [
              -41.3073,
              -4.8593
            ],
            [
              -41.3064,
              -4.8562
            ],
            [
              -41.305,
              -4.8529
            ],
            [
              -41.3029,
              -4.8494
            ],
            [
              -41.2955,
              -4.8527
            ],
            [
              -41.2924,
              -4.8551
            ],
            [
              -41.2893,
              -4.8606
            ],
            [
              -41.2884,
              -4.8603
            ],
            [
              -41.2865,
              -4.8565
            ],
            [
              -41.2841,
              -4.8547
            ],
            [
              -41.2784,
              -4.8534
            ],
            [
              -41.268,
              -4.8116
            ],
            [
              -41.2952,
              -4.8149
            ],
            [
              -41.294,
              -4.6296
            ],
            [
              -41.2935,
              -4.5561
            ],
            [
              -41.3409,
              -4.5615
            ],
            [
              -41.4334,
              -4.5718
            ],
            [
              -41.4858,
              -4.5777
            ],
            [
              -41.5122,
              -4.5807
            ],
            [
              -41.5867,
              -4.5838
            ],
            [
              -41.7294,
              -4.5898
            ],
            [
              -41.7453,
              -4.5904
            ],
            [
              -41.7768,
              -4.6888
            ],
            [
              -41.7469,
              -4.7029
            ],
            [
              -41.7466,
              -4.7033
            ],
            [
              -41.6992,
              -4.7614
            ],
            [
              -41.6954,
              -4.7659
            ],
            [
              -41.6896,
              -4.7642
            ],
            [
              -41.6548,
              -4.7763
            ]
          ]
        ]
      },
      "properties": {
        "name": "Milton Brandão",
        "codarea": "2206357",
        "isPiripiri": false,
        "isMask": false
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              -41.7453,
              -4.5904
            ],
            [
              -41.5122,
              -4.5807
            ],
            [
              -41.2935,
              -4.5561
            ],
            [
              -41.294,
              -4.6296
            ],
            [
              -41.2952,
              -4.8149
            ],
            [
              -41.268,
              -4.8116
            ],
            [
              -41.2597,
              -4.8086
            ],
            [
              -41.2559,
              -4.8006
            ],
            [
              -41.2332,
              -4.8101
            ],
            [
              -41.2325,
              -4.8045
            ],
            [
              -41.2254,
              -4.7978
            ],
            [
              -41.224,
              -4.7907
            ],
            [
              -41.2081,
              -4.7803
            ],
            [
              -41.2128,
              -4.772
            ],
            [
              -41.2339,
              -4.7688
            ],
            [
              -41.2478,
              -4.7618
            ],
            [
              -41.2503,
              -4.7566
            ],
            [
              -41.2352,
              -4.7465
            ],
            [
              -41.2367,
              -4.7388
            ],
            [
              -41.226,
              -4.7265
            ],
            [
              -41.2238,
              -4.7209
            ],
            [
              -41.2025,
              -4.7019
            ],
            [
              -41.1811,
              -4.6732
            ],
            [
              -41.1754,
              -4.6708
            ],
            [
              -41.1856,
              -4.662
            ],
            [
              -41.2028,
              -4.6382
            ],
            [
              -41.2293,
              -4.6201
            ],
            [
              -41.2334,
              -4.6102
            ],
            [
              -41.223,
              -4.5898
            ],
            [
              -41.222,
              -4.5778
            ],
            [
              -41.2398,
              -4.5736
            ],
            [
              -41.2354,
              -4.5702
            ],
            [
              -41.2215,
              -4.5675
            ],
            [
              -41.2141,
              -4.5527
            ],
            [
              -41.2084,
              -4.5488
            ],
            [
              -41.2038,
              -4.5284
            ],
            [
              -41.1908,
              -4.5155
            ],
            [
              -41.1879,
              -4.4861
            ],
            [
              -41.1776,
              -4.4677
            ],
            [
              -41.1785,
              -4.4594
            ],
            [
              -41.1752,
              -4.4495
            ],
            [
              -41.1774,
              -4.4433
            ],
            [
              -41.1651,
              -4.4226
            ],
            [
              -41.1597,
              -4.4106
            ],
            [
              -41.159,
              -4.3921
            ],
            [
              -41.1618,
              -4.3873
            ],
            [
              -41.158,
              -4.3787
            ],
            [
              -41.1491,
              -4.3672
            ],
            [
              -41.1421,
              -4.359
            ],
            [
              -41.1334,
              -4.3401
            ],
            [
              -41.1202,
              -4.3306
            ],
            [
              -41.1194,
              -4.3243
            ],
            [
              -41.229,
              -4.3404
            ],
            [
              -41.2405,
              -4.3757
            ],
            [
              -41.3568,
              -4.3429
            ],
            [
              -41.363,
              -4.3384
            ],
            [
              -41.3807,
              -4.4335
            ],
            [
              -41.3877,
              -4.4325
            ],
            [
              -41.399,
              -4.3885
            ],
            [
              -41.4184,
              -4.3482
            ],
            [
              -41.4275,
              -4.3211
            ],
            [
              -41.414,
              -4.3147
            ],
            [
              -41.4153,
              -4.311
            ],
            [
              -41.4532,
              -4.3013
            ],
            [
              -41.4876,
              -4.3037
            ],
            [
              -41.495,
              -4.2745
            ],
            [
              -41.525,
              -4.2567
            ],
            [
              -41.5608,
              -4.3103
            ],
            [
              -41.5594,
              -4.3188
            ],
            [
              -41.5503,
              -4.3209
            ],
            [
              -41.5414,
              -4.3288
            ],
            [
              -41.5368,
              -4.321
            ],
            [
              -41.5302,
              -4.3317
            ],
            [
              -41.513,
              -4.3316
            ],
            [
              -41.5108,
              -4.3482
            ],
            [
              -41.5015,
              -4.3573
            ],
            [
              -41.5061,
              -4.3747
            ],
            [
              -41.5057,
              -4.3887
            ],
            [
              -41.5109,
              -4.4003
            ],
            [
              -41.5187,
              -4.3997
            ],
            [
              -41.5204,
              -4.406
            ],
            [
              -41.529,
              -4.4106
            ],
            [
              -41.5349,
              -4.4044
            ],
            [
              -41.5442,
              -4.4075
            ],
            [
              -41.5496,
              -4.4047
            ],
            [
              -41.5647,
              -4.4097
            ],
            [
              -41.568,
              -4.4148
            ],
            [
              -41.5801,
              -4.4132
            ],
            [
              -41.5887,
              -4.4156
            ],
            [
              -41.5972,
              -4.4054
            ],
            [
              -41.6053,
              -4.4095
            ],
            [
              -41.6211,
              -4.4389
            ],
            [
              -41.6387,
              -4.4632
            ],
            [
              -41.7303,
              -4.5473
            ],
            [
              -41.7393,
              -4.5699
            ],
            [
              -41.7453,
              -4.5904
            ]
          ]
        ]
      },
      "properties": {
        "name": "Pedro II",
        "codarea": "2207900",
        "isPiripiri": false,
        "isMask": false
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              -41.8559,
              -4.0406
            ],
            [
              -41.8558,
              -4.0423
            ],
            [
              -41.7718,
              -4.034
            ],
            [
              -41.7379,
              -4.0453
            ],
            [
              -41.7364,
              -4.0635
            ],
            [
              -41.738,
              -4.0719
            ],
            [
              -41.7502,
              -4.0791
            ],
            [
              -41.7607,
              -4.0975
            ],
            [
              -41.7745,
              -4.1005
            ],
            [
              -41.6319,
              -4.1356
            ],
            [
              -41.6221,
              -4.0604
            ],
            [
              -41.5553,
              -4.0574
            ],
            [
              -41.5006,
              -4.0426
            ],
            [
              -41.4849,
              -4.0415
            ],
            [
              -41.3659,
              -3.8848
            ],
            [
              -41.2786,
              -3.77
            ],
            [
              -41.3133,
              -3.7394
            ],
            [
              -41.3347,
              -3.6915
            ],
            [
              -41.3358,
              -3.7013
            ],
            [
              -41.3524,
              -3.6999
            ],
            [
              -41.3602,
              -3.7094
            ],
            [
              -41.371,
              -3.7147
            ],
            [
              -41.3759,
              -3.712
            ],
            [
              -41.4007,
              -3.7305
            ],
            [
              -41.4181,
              -3.7535
            ],
            [
              -41.4498,
              -3.7424
            ],
            [
              -41.4487,
              -3.7024
            ],
            [
              -41.4576,
              -3.6698
            ],
            [
              -41.4873,
              -3.6539
            ],
            [
              -41.5066,
              -3.6308
            ],
            [
              -41.5242,
              -3.6058
            ],
            [
              -41.6491,
              -3.64
            ],
            [
              -41.678,
              -3.6647
            ],
            [
              -41.7455,
              -3.6726
            ],
            [
              -41.7466,
              -3.5865
            ],
            [
              -41.7729,
              -3.5727
            ],
            [
              -41.7943,
              -3.6241
            ],
            [
              -41.8666,
              -3.7209
            ],
            [
              -41.8298,
              -3.7534
            ],
            [
              -41.8183,
              -3.7534
            ],
            [
              -41.7131,
              -3.771
            ],
            [
              -41.6866,
              -3.7815
            ],
            [
              -41.6864,
              -3.797
            ],
            [
              -41.8355,
              -3.8484
            ],
            [
              -41.8656,
              -3.8483
            ],
            [
              -41.9031,
              -3.8869
            ],
            [
              -41.9108,
              -3.9408
            ],
            [
              -41.8476,
              -3.9738
            ],
            [
              -41.8559,
              -4.0406
            ]
          ]
        ]
      },
      "properties": {
        "name": "Piracuruca",
        "codarea": "2208304",
        "isPiripiri": false,
        "isMask": false
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              -41.6053,
              -4.4095
            ],
            [
              -41.6117,
              -4.4055
            ],
            [
              -41.6268,
              -4.4091
            ],
            [
              -41.6337,
              -4.4065
            ],
            [
              -41.6414,
              -4.4092
            ],
            [
              -41.6585,
              -4.3953
            ],
            [
              -41.6577,
              -4.3839
            ],
            [
              -41.6674,
              -4.3538
            ],
            [
              -41.6646,
              -4.3458
            ],
            [
              -41.6547,
              -4.3446
            ],
            [
              -41.6482,
              -4.3484
            ],
            [
              -41.6418,
              -4.3462
            ],
            [
              -41.6365,
              -4.35
            ],
            [
              -41.6274,
              -4.34
            ],
            [
              -41.6173,
              -4.3389
            ],
            [
              -41.6128,
              -4.3264
            ],
            [
              -41.6165,
              -4.318
            ],
            [
              -41.6065,
              -4.3108
            ],
            [
              -41.6084,
              -4.3018
            ],
            [
              -41.5966,
              -4.2952
            ],
            [
              -41.5937,
              -4.3022
            ],
            [
              -41.5823,
              -4.3037
            ],
            [
              -41.5786,
              -4.3093
            ],
            [
              -41.5687,
              -4.3062
            ],
            [
              -41.5608,
              -4.3103
            ],
            [
              -41.525,
              -4.2567
            ],
            [
              -41.4973,
              -4.1804
            ],
            [
              -41.5038,
              -4.176
            ],
            [
              -41.5139,
              -4.175
            ],
            [
              -41.5254,
              -4.1636
            ],
            [
              -41.5397,
              -4.1603
            ],
            [
              -41.5456,
              -4.1639
            ],
            [
              -41.5617,
              -4.1586
            ],
            [
              -41.5747,
              -4.1594
            ],
            [
              -41.5776,
              -4.1457
            ],
            [
              -41.6568,
              -4.2198
            ],
            [
              -41.7612,
              -4.2088
            ],
            [
              -41.7999,
              -4.1735
            ],
            [
              -41.799,
              -4.1906
            ],
            [
              -41.8045,
              -4.2022
            ],
            [
              -41.9214,
              -4.1814
            ],
            [
              -41.9213,
              -4.1841
            ],
            [
              -41.9189,
              -4.2239
            ],
            [
              -41.9332,
              -4.2259
            ],
            [
              -41.9544,
              -4.2207
            ],
            [
              -41.964,
              -4.2341
            ],
            [
              -41.9789,
              -4.2462
            ],
            [
              -41.9966,
              -4.2452
            ],
            [
              -42.0005,
              -4.2722
            ],
            [
              -42.0005,
              -4.3441
            ],
            [
              -42.0269,
              -4.3542
            ],
            [
              -42.0164,
              -4.367
            ],
            [
              -42.0216,
              -4.3721
            ],
            [
              -42.0193,
              -4.3811
            ],
            [
              -42.0125,
              -4.3844
            ],
            [
              -42.0079,
              -4.3808
            ],
            [
              -41.9905,
              -4.3889
            ],
            [
              -41.9875,
              -4.3948
            ],
            [
              -41.9679,
              -4.4047
            ],
            [
              -41.9669,
              -4.4155
            ],
            [
              -41.9587,
              -4.4246
            ],
            [
              -41.9412,
              -4.4235
            ],
            [
              -41.9291,
              -4.432
            ],
            [
              -41.9189,
              -4.4317
            ],
            [
              -41.9026,
              -4.4278
            ],
            [
              -41.8983,
              -4.4335
            ],
            [
              -41.8903,
              -4.4356
            ],
            [
              -41.8886,
              -4.4473
            ],
            [
              -41.8801,
              -4.4498
            ],
            [
              -41.8739,
              -4.4576
            ],
            [
              -41.8604,
              -4.4626
            ],
            [
              -41.8497,
              -4.4599
            ],
            [
              -41.8367,
              -4.4711
            ],
            [
              -41.8345,
              -4.4815
            ],
            [
              -41.8204,
              -4.497
            ],
            [
              -41.8198,
              -4.5025
            ],
            [
              -41.8113,
              -4.5049
            ],
            [
              -41.8073,
              -4.51
            ],
            [
              -41.7932,
              -4.5113
            ],
            [
              -41.7812,
              -4.5221
            ],
            [
              -41.7799,
              -4.5321
            ],
            [
              -41.7666,
              -4.5364
            ],
            [
              -41.7556,
              -4.545
            ],
            [
              -41.7393,
              -4.5699
            ],
            [
              -41.7303,
              -4.5473
            ],
            [
              -41.6387,
              -4.4632
            ],
            [
              -41.6211,
              -4.4389
            ],
            [
              -41.6053,
              -4.4095
            ]
          ]
        ]
      },
      "properties": {
        "name": "Piripiri",
        "codarea": "2208403",
        "isPiripiri": true,
        "isMask": false
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              -41.313,
              -4.1472
            ],
            [
              -41.3096,
              -4.1441
            ],
            [
              -41.3071,
              -4.147
            ],
            [
              -41.305,
              -4.148
            ],
            [
              -41.3024,
              -4.147
            ],
            [
              -41.3019,
              -4.1483
            ],
            [
              -41.3022,
              -4.1517
            ],
            [
              -41.3031,
              -4.1548
            ],
            [
              -41.3021,
              -4.1569
            ],
            [
              -41.3011,
              -4.1567
            ],
            [
              -41.2994,
              -4.1554
            ],
            [
              -41.297,
              -4.1565
            ],
            [
              -41.2966,
              -4.1598
            ],
            [
              -41.2958,
              -4.1633
            ],
            [
              -41.2946,
              -4.1658
            ],
            [
              -41.295,
              -4.1675
            ],
            [
              -41.2941,
              -4.1682
            ],
            [
              -41.2929,
              -4.1676
            ],
            [
              -41.2909,
              -4.1689
            ],
            [
              -41.285,
              -4.1694
            ],
            [
              -41.2809,
              -4.17
            ],
            [
              -41.2792,
              -4.169
            ],
            [
              -41.277,
              -4.1686
            ],
            [
              -41.2766,
              -4.1667
            ],
            [
              -41.2713,
              -4.1654
            ],
            [
              -41.2674,
              -4.1631
            ],
            [
              -41.2657,
              -4.161
            ],
            [
              -41.2631,
              -4.1618
            ],
            [
              -41.2624,
              -4.1595
            ],
            [
              -41.2624,
              -4.157
            ],
            [
              -41.2619,
              -4.1554
            ],
            [
              -41.2622,
              -4.1541
            ],
            [
              -41.2611,
              -4.152
            ],
            [
              -41.2604,
              -4.1493
            ],
            [
              -41.2596,
              -4.1486
            ],
            [
              -41.259,
              -4.1468
            ],
            [
              -41.2597,
              -4.1457
            ],
            [
              -41.2594,
              -4.1445
            ],
            [
              -41.2581,
              -4.1439
            ],
            [
              -41.2567,
              -4.1424
            ],
            [
              -41.255,
              -4.1431
            ],
            [
              -41.2535,
              -4.1415
            ],
            [
              -41.2523,
              -4.1411
            ],
            [
              -41.2496,
              -4.1385
            ],
            [
              -41.2477,
              -4.1387
            ],
            [
              -41.2451,
              -4.1407
            ],
            [
              -41.2451,
              -4.1417
            ],
            [
              -41.2413,
              -4.1452
            ],
            [
              -41.2408,
              -4.1472
            ],
            [
              -41.2392,
              -4.1497
            ],
            [
              -41.2393,
              -4.1511
            ],
            [
              -41.2375,
              -4.1525
            ],
            [
              -41.2366,
              -4.1539
            ],
            [
              -41.2333,
              -4.1563
            ],
            [
              -41.2316,
              -4.1569
            ],
            [
              -41.2303,
              -4.1567
            ],
            [
              -41.229,
              -4.1553
            ],
            [
              -41.2276,
              -4.1554
            ],
            [
              -41.2263,
              -4.1563
            ],
            [
              -41.2249,
              -4.1582
            ],
            [
              -41.2237,
              -4.1582
            ],
            [
              -41.2222,
              -4.1558
            ],
            [
              -41.2184,
              -4.1567
            ],
            [
              -41.2173,
              -4.1574
            ],
            [
              -41.2153,
              -4.157
            ],
            [
              -41.2135,
              -4.156
            ],
            [
              -41.211,
              -4.1536
            ],
            [
              -41.2095,
              -4.1513
            ],
            [
              -41.209,
              -4.1497
            ],
            [
              -41.2093,
              -4.1469
            ],
            [
              -41.207,
              -4.1469
            ],
            [
              -41.2044,
              -4.1461
            ],
            [
              -41.2036,
              -4.1472
            ],
            [
              -41.2023,
              -4.1469
            ],
            [
              -41.2012,
              -4.1484
            ],
            [
              -41.1999,
              -4.1487
            ],
            [
              -41.1977,
              -4.1475
            ],
            [
              -41.1962,
              -4.1476
            ],
            [
              -41.1959,
              -4.1497
            ],
            [
              -41.1937,
              -4.1523
            ],
            [
              -41.1933,
              -4.1538
            ],
            [
              -41.1918,
              -4.1548
            ],
            [
              -41.1901,
              -4.1551
            ],
            [
              -41.1908,
              -4.1571
            ],
            [
              -41.1903,
              -4.1593
            ],
            [
              -41.1873,
              -4.1606
            ],
            [
              -41.1853,
              -4.1599
            ],
            [
              -41.1833,
              -4.1584
            ],
            [
              -41.181,
              -4.1607
            ],
            [
              -41.1814,
              -4.1621
            ],
            [
              -41.1808,
              -4.1637
            ],
            [
              -41.1798,
              -4.1645
            ],
            [
              -41.179,
              -4.1663
            ],
            [
              -41.1768,
              -4.1691
            ],
            [
              -41.1759,
              -4.1726
            ],
            [
              -41.1762,
              -4.1737
            ],
            [
              -41.1775,
              -4.1751
            ],
            [
              -41.1769,
              -4.1766
            ],
            [
              -41.1744,
              -4.1784
            ],
            [
              -41.1703,
              -4.1803
            ],
            [
              -41.1687,
              -4.1828
            ],
            [
              -41.1651,
              -4.1876
            ],
            [
              -41.1639,
              -4.1883
            ],
            [
              -41.1615,
              -4.1882
            ],
            [
              -41.1594,
              -4.1866
            ],
            [
              -41.1579,
              -4.1864
            ],
            [
              -41.1556,
              -4.1889
            ],
            [
              -41.1546,
              -4.1887
            ],
            [
              -41.1526,
              -4.1874
            ],
            [
              -41.1511,
              -4.1872
            ],
            [
              -41.1497,
              -4.1856
            ],
            [
              -41.147,
              -4.1858
            ],
            [
              -41.145,
              -4.1854
            ],
            [
              -41.1438,
              -4.186
            ],
            [
              -41.1426,
              -4.1857
            ],
            [
              -41.1402,
              -4.1828
            ],
            [
              -41.139,
              -4.1817
            ],
            [
              -41.1359,
              -4.1774
            ],
            [
              -41.135,
              -4.1768
            ],
            [
              -41.131,
              -4.1767
            ],
            [
              -41.1295,
              -4.1772
            ],
            [
              -41.128,
              -4.1764
            ],
            [
              -41.1258,
              -4.176
            ],
            [
              -41.1241,
              -4.1762
            ],
            [
              -41.1224,
              -4.1759
            ],
            [
              -41.1206,
              -4.1775
            ],
            [
              -41.1185,
              -4.1773
            ],
            [
              -41.1159,
              -4.1765
            ],
            [
              -41.1137,
              -4.178
            ],
            [
              -41.1114,
              -4.1791
            ],
            [
              -41.1095,
              -4.1795
            ],
            [
              -41.1069,
              -4.1791
            ],
            [
              -41.1058,
              -4.1797
            ],
            [
              -41.1036,
              -4.1798
            ],
            [
              -41.1017,
              -4.1804
            ],
            [
              -41.0981,
              -4.1805
            ],
            [
              -41.0909,
              -4.1703
            ],
            [
              -41.0939,
              -4.1699
            ],
            [
              -41.097,
              -4.1707
            ],
            [
              -41.1058,
              -4.1696
            ],
            [
              -41.1113,
              -4.1669
            ],
            [
              -41.1176,
              -4.1657
            ],
            [
              -41.1183,
              -4.1652
            ],
            [
              -41.121,
              -4.1605
            ],
            [
              -41.1231,
              -4.1582
            ],
            [
              -41.1237,
              -4.1562
            ],
            [
              -41.1254,
              -4.1545
            ],
            [
              -41.1268,
              -4.1507
            ],
            [
              -41.1258,
              -4.1485
            ],
            [
              -41.1253,
              -4.1449
            ],
            [
              -41.1281,
              -4.1393
            ],
            [
              -41.1343,
              -4.1317
            ],
            [
              -41.1421,
              -4.1256
            ],
            [
              -41.1431,
              -4.1242
            ],
            [
              -41.1408,
              -4.1236
            ],
            [
              -41.1394,
              -4.121
            ],
            [
              -41.1371,
              -4.1169
            ],
            [
              -41.1344,
              -4.1049
            ],
            [
              -41.1289,
              -4.0973
            ],
            [
              -41.1281,
              -4.0942
            ],
            [
              -41.1276,
              -4.0887
            ],
            [
              -41.1222,
              -4.0772
            ],
            [
              -41.1216,
              -4.0742
            ],
            [
              -41.122,
              -4.0722
            ],
            [
              -41.1275,
              -4.0661
            ],
            [
              -41.1279,
              -4.0639
            ],
            [
              -41.1272,
              -4.0614
            ],
            [
              -41.1258,
              -4.0603
            ],
            [
              -41.1164,
              -4.0541
            ],
            [
              -41.1141,
              -4.0518
            ],
            [
              -41.1132,
              -4.0498
            ],
            [
              -41.1132,
              -4.047
            ],
            [
              -41.1125,
              -4.0442
            ],
            [
              -41.1129,
              -4.0417
            ],
            [
              -41.1143,
              -4.0406
            ],
            [
              -41.1203,
              -4.0363
            ],
            [
              -41.1222,
              -4.037
            ],
            [
              -41.1239,
              -4.0371
            ],
            [
              -41.1302,
              -4.0354
            ],
            [
              -41.1337,
              -4.0352
            ],
            [
              -41.1431,
              -4.0368
            ],
            [
              -41.1533,
              -4.0349
            ],
            [
              -41.16,
              -4.0317
            ],
            [
              -41.1635,
              -4.0318
            ],
            [
              -41.1688,
              -4.0331
            ],
            [
              -41.1718,
              -4.0325
            ],
            [
              -41.176,
              -4.0288
            ],
            [
              -41.1807,
              -4.0277
            ],
            [
              -41.182,
              -4.0267
            ],
            [
              -41.1838,
              -4.0244
            ],
            [
              -41.1822,
              -4.0192
            ],
            [
              -41.1829,
              -4.018
            ],
            [
              -41.1855,
              -4.0172
            ],
            [
              -41.1886,
              -4.0176
            ],
            [
              -41.1916,
              -4.019
            ],
            [
              -41.1926,
              -4.0207
            ],
            [
              -41.1958,
              -4.0203
            ],
            [
              -41.1978,
              -4.0184
            ],
            [
              -41.1995,
              -4.0184
            ],
            [
              -41.2033,
              -4.0225
            ],
            [
              -41.206,
              -4.0243
            ],
            [
              -41.2089,
              -4.0256
            ],
            [
              -41.2107,
              -4.0258
            ],
            [
              -41.2141,
              -4.0242
            ],
            [
              -41.2221,
              -4.0271
            ],
            [
              -41.2229,
              -4.0284
            ],
            [
              -41.2244,
              -4.0286
            ],
            [
              -41.2268,
              -4.0272
            ],
            [
              -41.2309,
              -4.0289
            ],
            [
              -41.2403,
              -4.0308
            ],
            [
              -41.2502,
              -4.0378
            ],
            [
              -41.2521,
              -4.0378
            ],
            [
              -41.2547,
              -4.0371
            ],
            [
              -41.2567,
              -4.0348
            ],
            [
              -41.2556,
              -4.0326
            ],
            [
              -41.2555,
              -4.0297
            ],
            [
              -41.2544,
              -4.0277
            ],
            [
              -41.2529,
              -4.0265
            ],
            [
              -41.2507,
              -4.0268
            ],
            [
              -41.2495,
              -4.0264
            ],
            [
              -41.2446,
              -4.022
            ],
            [
              -41.2438,
              -4.0197
            ],
            [
              -41.2395,
              -4.0169
            ],
            [
              -41.2388,
              -4.0154
            ],
            [
              -41.2392,
              -4.0131
            ],
            [
              -41.2426,
              -4.0099
            ],
            [
              -41.2443,
              -4.0068
            ],
            [
              -41.2457,
              -4.0066
            ],
            [
              -41.2458,
              -4.0039
            ],
            [
              -41.2464,
              -4.0013
            ],
            [
              -41.2479,
              -3.9994
            ],
            [
              -41.2473,
              -3.997
            ],
            [
              -41.2474,
              -3.9932
            ],
            [
              -41.2492,
              -3.9899
            ],
            [
              -41.2477,
              -3.9891
            ],
            [
              -41.2468,
              -3.9879
            ],
            [
              -41.2442,
              -3.9864
            ],
            [
              -41.2441,
              -3.9842
            ],
            [
              -41.2447,
              -3.983
            ],
            [
              -41.2444,
              -3.9798
            ],
            [
              -41.2438,
              -3.9793
            ],
            [
              -41.2416,
              -3.9799
            ],
            [
              -41.2401,
              -3.9792
            ],
            [
              -41.2396,
              -3.9771
            ],
            [
              -41.2386,
              -3.9757
            ],
            [
              -41.2388,
              -3.9739
            ],
            [
              -41.2382,
              -3.9728
            ],
            [
              -41.2338,
              -3.9706
            ],
            [
              -41.2343,
              -3.9678
            ],
            [
              -41.2313,
              -3.9665
            ],
            [
              -41.2289,
              -3.9681
            ],
            [
              -41.2202,
              -3.9415
            ],
            [
              -41.2289,
              -3.9117
            ],
            [
              -41.23,
              -3.9109
            ],
            [
              -41.2326,
              -3.9108
            ],
            [
              -41.2333,
              -3.9103
            ],
            [
              -41.2356,
              -3.906
            ],
            [
              -41.239,
              -3.9035
            ],
            [
              -41.2417,
              -3.9005
            ],
            [
              -41.2453,
              -3.8983
            ],
            [
              -41.2457,
              -3.8964
            ],
            [
              -41.2447,
              -3.8933
            ],
            [
              -41.2466,
              -3.8845
            ],
            [
              -41.2476,
              -3.8823
            ],
            [
              -41.2535,
              -3.8759
            ],
            [
              -41.2554,
              -3.8729
            ],
            [
              -41.2589,
              -3.8703
            ],
            [
              -41.2597,
              -3.8687
            ],
            [
              -41.26,
              -3.8648
            ],
            [
              -41.2613,
              -3.864
            ],
            [
              -41.2669,
              -3.8627
            ],
            [
              -41.2678,
              -3.8612
            ],
            [
              -41.2669,
              -3.8605
            ],
            [
              -41.2668,
              -3.8589
            ],
            [
              -41.2701,
              -3.8544
            ],
            [
              -41.2704,
              -3.8523
            ],
            [
              -41.2681,
              -3.8483
            ],
            [
              -41.269,
              -3.8459
            ],
            [
              -41.2686,
              -3.8445
            ],
            [
              -41.2713,
              -3.8419
            ],
            [
              -41.2707,
              -3.8378
            ],
            [
              -41.272,
              -3.8365
            ],
            [
              -41.2737,
              -3.8357
            ],
            [
              -41.2751,
              -3.8339
            ],
            [
              -41.2752,
              -3.8302
            ],
            [
              -41.2769,
              -3.8256
            ],
            [
              -41.278,
              -3.8245
            ],
            [
              -41.279,
              -3.8246
            ],
            [
              -41.2814,
              -3.8268
            ],
            [
              -41.2827,
              -3.8268
            ],
            [
              -41.2847,
              -3.8255
            ],
            [
              -41.2867,
              -3.8227
            ],
            [
              -41.2879,
              -3.8225
            ],
            [
              -41.2894,
              -3.8255
            ],
            [
              -41.2925,
              -3.8258
            ],
            [
              -41.2942,
              -3.8295
            ],
            [
              -41.2952,
              -3.8302
            ],
            [
              -41.2967,
              -3.8294
            ],
            [
              -41.299,
              -3.8261
            ],
            [
              -41.3008,
              -3.8263
            ],
            [
              -41.2987,
              -3.8232
            ],
            [
              -41.2944,
              -3.8186
            ],
            [
              -41.2898,
              -3.8148
            ],
            [
              -41.2805,
              -3.8055
            ],
            [
              -41.2756,
              -3.8023
            ],
            [
              -41.2708,
              -3.7968
            ],
            [
              -41.2648,
              -3.7916
            ],
            [
              -41.2626,
              -3.7888
            ],
            [
              -41.2541,
              -3.775
            ],
            [
              -41.2538,
              -3.7734
            ],
            [
              -41.2548,
              -3.7703
            ],
            [
              -41.2605,
              -3.7625
            ],
            [
              -41.2612,
              -3.7575
            ],
            [
              -41.2615,
              -3.7519
            ],
            [
              -41.2613,
              -3.7462
            ],
            [
              -41.26,
              -3.7393
            ],
            [
              -41.2585,
              -3.7328
            ],
            [
              -41.2574,
              -3.7299
            ],
            [
              -41.2531,
              -3.7242
            ],
            [
              -41.2519,
              -3.7233
            ],
            [
              -41.2472,
              -3.7221
            ],
            [
              -41.2394,
              -3.7207
            ],
            [
              -41.2385,
              -3.7199
            ],
            [
              -41.2381,
              -3.7178
            ],
            [
              -41.2383,
              -3.7158
            ],
            [
              -41.2393,
              -3.7128
            ],
            [
              -41.2418,
              -3.711
            ],
            [
              -41.2454,
              -3.7109
            ],
            [
              -41.2474,
              -3.7099
            ],
            [
              -41.2502,
              -3.7066
            ],
            [
              -41.2554,
              -3.7033
            ],
            [
              -41.2583,
              -3.7036
            ],
            [
              -41.2717,
              -3.7034
            ],
            [
              -41.2793,
              -3.7007
            ],
            [
              -41.283,
              -3.697
            ],
            [
              -41.2861,
              -3.6922
            ],
            [
              -41.2877,
              -3.6909
            ],
            [
              -41.2908,
              -3.6897
            ],
            [
              -41.2999,
              -3.6875
            ],
            [
              -41.3077,
              -3.6848
            ],
            [
              -41.3169,
              -3.6866
            ],
            [
              -41.3208,
              -3.6868
            ],
            [
              -41.3225,
              -3.6878
            ],
            [
              -41.3265,
              -3.6873
            ],
            [
              -41.3289,
              -3.6863
            ],
            [
              -41.3318,
              -3.6858
            ],
            [
              -41.3342,
              -3.684
            ],
            [
              -41.3347,
              -3.6915
            ],
            [
              -41.3133,
              -3.7394
            ],
            [
              -41.2786,
              -3.77
            ],
            [
              -41.3659,
              -3.8848
            ],
            [
              -41.4504,
              -3.9961
            ],
            [
              -41.4849,
              -4.0415
            ],
            [
              -41.336,
              -4.0515
            ],
            [
              -41.313,
              -4.1472
            ]
          ]
        ]
      },
      "properties": {
        "name": "São João da Fronteira",
        "codarea": "2209872",
        "isPiripiri": false,
        "isMask": false
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              -41.9621,
              -3.6793
            ],
            [
              -41.9694,
              -3.685
            ],
            [
              -41.9724,
              -3.6882
            ],
            [
              -41.9733,
              -3.6898
            ],
            [
              -41.9754,
              -3.6969
            ],
            [
              -41.9759,
              -3.7023
            ],
            [
              -41.9753,
              -3.7059
            ],
            [
              -41.9754,
              -3.7111
            ],
            [
              -41.9768,
              -3.7161
            ],
            [
              -41.9758,
              -3.7228
            ],
            [
              -41.9768,
              -3.7262
            ],
            [
              -41.9781,
              -3.7288
            ],
            [
              -41.9785,
              -3.7309
            ],
            [
              -41.9777,
              -3.7369
            ],
            [
              -41.9782,
              -3.7401
            ],
            [
              -41.9775,
              -3.7429
            ],
            [
              -41.9766,
              -3.7483
            ],
            [
              -41.9757,
              -3.7517
            ],
            [
              -41.9754,
              -3.7541
            ],
            [
              -41.9768,
              -3.7573
            ],
            [
              -41.9766,
              -3.7604
            ],
            [
              -41.9755,
              -3.7631
            ],
            [
              -41.9753,
              -3.7649
            ],
            [
              -41.9759,
              -3.7663
            ],
            [
              -41.9791,
              -3.7695
            ],
            [
              -41.9809,
              -3.7719
            ],
            [
              -41.9816,
              -3.7738
            ],
            [
              -41.9813,
              -3.777
            ],
            [
              -41.9806,
              -3.7797
            ],
            [
              -41.9811,
              -3.784
            ],
            [
              -41.8984,
              -3.7967
            ],
            [
              -41.9019,
              -3.8641
            ],
            [
              -41.9031,
              -3.8869
            ],
            [
              -41.8656,
              -3.8483
            ],
            [
              -41.8355,
              -3.8484
            ],
            [
              -41.6864,
              -3.797
            ],
            [
              -41.6866,
              -3.7926
            ],
            [
              -41.6866,
              -3.7815
            ],
            [
              -41.7131,
              -3.771
            ],
            [
              -41.7418,
              -3.7662
            ],
            [
              -41.8183,
              -3.7534
            ],
            [
              -41.8239,
              -3.7533
            ],
            [
              -41.8252,
              -3.7548
            ],
            [
              -41.8259,
              -3.7548
            ],
            [
              -41.8278,
              -3.7533
            ],
            [
              -41.8298,
              -3.7534
            ],
            [
              -41.8666,
              -3.7209
            ],
            [
              -41.8976,
              -3.6981
            ],
            [
              -41.9041,
              -3.693
            ],
            [
              -41.9245,
              -3.6771
            ],
            [
              -41.9262,
              -3.6788
            ],
            [
              -41.9274,
              -3.6794
            ],
            [
              -41.9345,
              -3.6802
            ],
            [
              -41.9447,
              -3.6806
            ],
            [
              -41.948,
              -3.6795
            ],
            [
              -41.9504,
              -3.6767
            ],
            [
              -41.954,
              -3.6758
            ],
            [
              -41.9571,
              -3.6762
            ],
            [
              -41.9621,
              -3.6793
            ]
          ]
        ]
      },
      "properties": {
        "name": "São José do Divino",
        "codarea": "2210052",
        "isPiripiri": false,
        "isMask": false
      }
    }
  ]
});

export const MASK_GEOJSON = Object.freeze({
  "type": "FeatureCollection",
  "features": [
    {
      "type": "Feature",
      "properties": {
        "name": "OuterMask",
        "isMask": true,
        "isPiripiri": false
      },
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              -65,
              15
            ],
            [
              -25,
              15
            ],
            [
              -25,
              -30
            ],
            [
              -65,
              -30
            ],
            [
              -65,
              15
            ]
          ],
          [
            [
              -42.548,
              -4.345
            ],
            [
              -42.4826,
              -4.344
            ],
            [
              -42.4479,
              -4.3344
            ],
            [
              -42.4196,
              -4.3435
            ],
            [
              -42.4173,
              -4.3399
            ],
            [
              -42.1959,
              -4.3809
            ],
            [
              -42.1817,
              -4.3819
            ],
            [
              -42.1741,
              -4.3726
            ],
            [
              -42.1775,
              -4.3673
            ],
            [
              -42.1775,
              -4.3577
            ],
            [
              -42.1821,
              -4.3494
            ],
            [
              -42.1818,
              -4.3402
            ],
            [
              -42.178,
              -4.3263
            ],
            [
              -42.1841,
              -4.3075
            ],
            [
              -42.1935,
              -4.2974
            ],
            [
              -42.1852,
              -4.2867
            ],
            [
              -42.1868,
              -4.2777
            ],
            [
              -42.1946,
              -4.2709
            ],
            [
              -42.1786,
              -4.2696
            ],
            [
              -42.1606,
              -4.2709
            ],
            [
              -42.1548,
              -4.2742
            ],
            [
              -42.1333,
              -4.2721
            ],
            [
              -42.1252,
              -4.2735
            ],
            [
              -42.1221,
              -4.2667
            ],
            [
              -42.1112,
              -4.2661
            ],
            [
              -42.1002,
              -4.2706
            ],
            [
              -42.0635,
              -4.2739
            ],
            [
              -42.0415,
              -4.2714
            ],
            [
              -42.0306,
              -4.2667
            ],
            [
              -42.0113,
              -4.2674
            ],
            [
              -42.0005,
              -4.2722
            ],
            [
              -41.9966,
              -4.2452
            ],
            [
              -41.9969,
              -4.2078
            ],
            [
              -42.0154,
              -4.2
            ],
            [
              -42.0511,
              -4.1811
            ],
            [
              -42.0563,
              -4.191
            ],
            [
              -42.0632,
              -4.1917
            ],
            [
              -42.0768,
              -4.2053
            ],
            [
              -42.0938,
              -4.2031
            ],
            [
              -42.11,
              -4.2107
            ],
            [
              -42.1164,
              -4.207
            ],
            [
              -42.13,
              -4.2123
            ],
            [
              -42.1337,
              -4.2171
            ],
            [
              -42.1425,
              -4.2168
            ],
            [
              -42.1563,
              -4.2202
            ],
            [
              -42.1723,
              -4.2174
            ],
            [
              -42.1834,
              -4.2208
            ],
            [
              -42.193,
              -4.2169
            ],
            [
              -42.2078,
              -4.2257
            ],
            [
              -42.213,
              -4.2208
            ],
            [
              -42.2275,
              -4.2273
            ],
            [
              -42.2376,
              -4.2241
            ],
            [
              -42.2354,
              -4.2177
            ],
            [
              -42.2397,
              -4.2121
            ],
            [
              -42.2388,
              -4.2015
            ],
            [
              -42.234,
              -4.1949
            ],
            [
              -42.242,
              -4.1673
            ],
            [
              -42.2489,
              -4.1618
            ],
            [
              -42.2634,
              -4.1703
            ],
            [
              -42.2667,
              -4.1609
            ],
            [
              -42.2612,
              -4.1562
            ],
            [
              -42.2625,
              -4.1503
            ],
            [
              -42.2536,
              -4.1414
            ],
            [
              -42.2509,
              -4.1268
            ],
            [
              -42.2598,
              -4.1223
            ],
            [
              -42.2575,
              -4.1157
            ],
            [
              -42.2589,
              -4.1046
            ],
            [
              -42.2638,
              -4.0895
            ],
            [
              -42.2545,
              -4.0778
            ],
            [
              -42.2573,
              -4.0733
            ],
            [
              -42.2564,
              -4.0628
            ],
            [
              -42.2638,
              -4.0547
            ],
            [
              -42.2581,
              -4.0492
            ],
            [
              -42.2619,
              -4.0278
            ],
            [
              -42.2664,
              -4.025
            ],
            [
              -42.2645,
              -4.0108
            ],
            [
              -42.2595,
              -4.0053
            ],
            [
              -42.2471,
              -3.9996
            ],
            [
              -42.2374,
              -3.9976
            ],
            [
              -42.238,
              -3.9823
            ],
            [
              -42.2295,
              -3.9736
            ],
            [
              -42.2358,
              -3.9594
            ],
            [
              -42.2439,
              -3.9267
            ],
            [
              -42.2454,
              -3.9355
            ],
            [
              -42.2669,
              -3.9394
            ],
            [
              -42.2749,
              -3.9546
            ],
            [
              -42.2722,
              -3.9617
            ],
            [
              -42.2771,
              -3.9788
            ],
            [
              -42.288,
              -3.9759
            ],
            [
              -42.3012,
              -3.986
            ],
            [
              -42.3088,
              -3.9985
            ],
            [
              -42.3255,
              -3.9931
            ],
            [
              -42.3318,
              -3.9853
            ],
            [
              -42.3458,
              -3.9811
            ],
            [
              -42.359,
              -3.9743
            ],
            [
              -42.3734,
              -3.9847
            ],
            [
              -42.3887,
              -3.986
            ],
            [
              -42.4393,
              -3.9686
            ],
            [
              -42.4562,
              -3.9968
            ],
            [
              -42.5127,
              -4.0423
            ],
            [
              -42.5046,
              -4.0549
            ],
            [
              -42.5205,
              -4.0637
            ],
            [
              -42.5305,
              -4.0928
            ],
            [
              -42.5343,
              -4.1003
            ],
            [
              -42.542,
              -4.1045
            ],
            [
              -42.5561,
              -4.1047
            ],
            [
              -42.5901,
              -4.1329
            ],
            [
              -42.6072,
              -4.1303
            ],
            [
              -42.6102,
              -4.1323
            ],
            [
              -42.6231,
              -4.1293
            ],
            [
              -42.6467,
              -4.1309
            ],
            [
              -42.616,
              -4.2379
            ],
            [
              -42.548,
              -4.345
            ]
          ],
          [
            [
              -42.2439,
              -3.9267
            ],
            [
              -42.2358,
              -3.9594
            ],
            [
              -42.2295,
              -3.9736
            ],
            [
              -42.238,
              -3.9823
            ],
            [
              -42.2374,
              -3.9976
            ],
            [
              -42.2471,
              -3.9996
            ],
            [
              -42.2595,
              -4.0053
            ],
            [
              -42.2645,
              -4.0108
            ],
            [
              -42.2664,
              -4.025
            ],
            [
              -42.2619,
              -4.0278
            ],
            [
              -42.2581,
              -4.0492
            ],
            [
              -42.2638,
              -4.0547
            ],
            [
              -42.2564,
              -4.0628
            ],
            [
              -42.2573,
              -4.0733
            ],
            [
              -42.2545,
              -4.0778
            ],
            [
              -42.2638,
              -4.0895
            ],
            [
              -42.2589,
              -4.1046
            ],
            [
              -42.2575,
              -4.1157
            ],
            [
              -42.2598,
              -4.1223
            ],
            [
              -42.2509,
              -4.1268
            ],
            [
              -42.2536,
              -4.1414
            ],
            [
              -42.2625,
              -4.1503
            ],
            [
              -42.2612,
              -4.1562
            ],
            [
              -42.2667,
              -4.1609
            ],
            [
              -42.2634,
              -4.1703
            ],
            [
              -42.2489,
              -4.1618
            ],
            [
              -42.242,
              -4.1673
            ],
            [
              -42.234,
              -4.1949
            ],
            [
              -42.2388,
              -4.2015
            ],
            [
              -42.2397,
              -4.2121
            ],
            [
              -42.2354,
              -4.2177
            ],
            [
              -42.2376,
              -4.2241
            ],
            [
              -42.2275,
              -4.2273
            ],
            [
              -42.213,
              -4.2208
            ],
            [
              -42.2078,
              -4.2257
            ],
            [
              -42.193,
              -4.2169
            ],
            [
              -42.1834,
              -4.2208
            ],
            [
              -42.1723,
              -4.2174
            ],
            [
              -42.1563,
              -4.2202
            ],
            [
              -42.1425,
              -4.2168
            ],
            [
              -42.1337,
              -4.2171
            ],
            [
              -42.13,
              -4.2123
            ],
            [
              -42.1164,
              -4.207
            ],
            [
              -42.11,
              -4.2107
            ],
            [
              -42.0938,
              -4.2031
            ],
            [
              -42.0768,
              -4.2053
            ],
            [
              -42.0632,
              -4.1917
            ],
            [
              -42.0563,
              -4.191
            ],
            [
              -42.0511,
              -4.1811
            ],
            [
              -42.0154,
              -4.2
            ],
            [
              -41.9969,
              -4.2078
            ],
            [
              -41.9966,
              -4.2452
            ],
            [
              -41.9789,
              -4.2462
            ],
            [
              -41.964,
              -4.2341
            ],
            [
              -41.9544,
              -4.2207
            ],
            [
              -41.9332,
              -4.2259
            ],
            [
              -41.9189,
              -4.2239
            ],
            [
              -41.9213,
              -4.1841
            ],
            [
              -41.9328,
              -4.197
            ],
            [
              -41.8971,
              -4.0857
            ],
            [
              -41.9348,
              -4.0693
            ],
            [
              -41.92,
              -4.062
            ],
            [
              -41.9145,
              -4.0516
            ],
            [
              -41.9134,
              -4.0348
            ],
            [
              -41.9062,
              -4.0421
            ],
            [
              -41.8942,
              -4.0461
            ],
            [
              -41.8868,
              -4.0403
            ],
            [
              -41.8779,
              -4.0405
            ],
            [
              -41.8708,
              -4.0447
            ],
            [
              -41.8559,
              -4.0406
            ],
            [
              -41.8476,
              -3.9738
            ],
            [
              -41.9108,
              -3.9408
            ],
            [
              -41.9031,
              -3.8869
            ],
            [
              -41.8984,
              -3.7967
            ],
            [
              -41.9811,
              -3.784
            ],
            [
              -41.9816,
              -3.7738
            ],
            [
              -41.9753,
              -3.7649
            ],
            [
              -41.9754,
              -3.7541
            ],
            [
              -41.9785,
              -3.7309
            ],
            [
              -41.9758,
              -3.7228
            ],
            [
              -41.9754,
              -3.6969
            ],
            [
              -41.9733,
              -3.6898
            ],
            [
              -41.9621,
              -3.6793
            ],
            [
              -42.0503,
              -3.6803
            ],
            [
              -42.0503,
              -3.7913
            ],
            [
              -42.0351,
              -3.7913
            ],
            [
              -42.0246,
              -3.808
            ],
            [
              -42.0203,
              -3.8098
            ],
            [
              -42.0024,
              -3.8012
            ],
            [
              -41.995,
              -3.7995
            ],
            [
              -41.9868,
              -3.8059
            ],
            [
              -41.9798,
              -3.803
            ],
            [
              -41.974,
              -3.8095
            ],
            [
              -41.9878,
              -3.8232
            ],
            [
              -41.9891,
              -3.8314
            ],
            [
              -41.9839,
              -3.8395
            ],
            [
              -41.9772,
              -3.8433
            ],
            [
              -41.9798,
              -3.8511
            ],
            [
              -41.9785,
              -3.8603
            ],
            [
              -41.9911,
              -3.8705
            ],
            [
              -42.0091,
              -3.8749
            ],
            [
              -42.0272,
              -3.8744
            ],
            [
              -42.0441,
              -3.8767
            ],
            [
              -42.0519,
              -3.8859
            ],
            [
              -42.0677,
              -3.8861
            ],
            [
              -42.0625,
              -3.8951
            ],
            [
              -42.065,
              -3.905
            ],
            [
              -42.0724,
              -3.9181
            ],
            [
              -42.0923,
              -3.9158
            ],
            [
              -42.0982,
              -3.9108
            ],
            [
              -42.105,
              -3.9167
            ],
            [
              -42.1175,
              -3.9107
            ],
            [
              -42.1193,
              -3.8987
            ],
            [
              -42.1379,
              -3.9005
            ],
            [
              -42.1487,
              -3.9041
            ],
            [
              -42.1694,
              -3.8897
            ],
            [
              -42.1742,
              -3.8964
            ],
            [
              -42.1733,
              -3.9096
            ],
            [
              -42.1821,
              -3.913
            ],
            [
              -42.1871,
              -3.9058
            ],
            [
              -42.1946,
              -3.9095
            ],
            [
              -42.2044,
              -3.9189
            ],
            [
              -42.2119,
              -3.9156
            ],
            [
              -42.209,
              -3.9055
            ],
            [
              -42.2188,
              -3.8986
            ],
            [
              -42.2335,
              -3.9056
            ],
            [
              -42.2444,
              -3.9143
            ],
            [
              -42.2439,
              -3.9267
            ]
          ],
          [
            [
              -42.061,
              -4.434
            ],
            [
              -42.0584,
              -4.4035
            ],
            [
              -42.0793,
              -4.3742
            ],
            [
              -42.0269,
              -4.3542
            ],
            [
              -42.0005,
              -4.3441
            ],
            [
              -42.0005,
              -4.2722
            ],
            [
              -42.0113,
              -4.2674
            ],
            [
              -42.0306,
              -4.2667
            ],
            [
              -42.0415,
              -4.2714
            ],
            [
              -42.0635,
              -4.2739
            ],
            [
              -42.1002,
              -4.2706
            ],
            [
              -42.1112,
              -4.2661
            ],
            [
              -42.1221,
              -4.2667
            ],
            [
              -42.1252,
              -4.2735
            ],
            [
              -42.1333,
              -4.2721
            ],
            [
              -42.1548,
              -4.2742
            ],
            [
              -42.1606,
              -4.2709
            ],
            [
              -42.1786,
              -4.2696
            ],
            [
              -42.1946,
              -4.2709
            ],
            [
              -42.1868,
              -4.2777
            ],
            [
              -42.1852,
              -4.2867
            ],
            [
              -42.1935,
              -4.2974
            ],
            [
              -42.1841,
              -4.3075
            ],
            [
              -42.178,
              -4.3263
            ],
            [
              -42.1818,
              -4.3402
            ],
            [
              -42.1821,
              -4.3494
            ],
            [
              -42.1775,
              -4.3577
            ],
            [
              -42.1775,
              -4.3673
            ],
            [
              -42.1741,
              -4.3726
            ],
            [
              -42.1817,
              -4.3819
            ],
            [
              -42.1959,
              -4.3809
            ],
            [
              -42.1846,
              -4.391
            ],
            [
              -42.1768,
              -4.4012
            ],
            [
              -42.1816,
              -4.4112
            ],
            [
              -42.1792,
              -4.4163
            ],
            [
              -42.1674,
              -4.4235
            ],
            [
              -42.1658,
              -4.4374
            ],
            [
              -42.1668,
              -4.4516
            ],
            [
              -42.178,
              -4.4626
            ],
            [
              -42.1684,
              -4.464
            ],
            [
              -42.169,
              -4.4708
            ],
            [
              -42.1617,
              -4.4767
            ],
            [
              -42.1532,
              -4.4739
            ],
            [
              -42.1505,
              -4.4822
            ],
            [
              -42.061,
              -4.434
            ]
          ],
          [
            [
              -41.9213,
              -4.1841
            ],
            [
              -41.9214,
              -4.1814
            ],
            [
              -41.8045,
              -4.2022
            ],
            [
              -41.799,
              -4.1906
            ],
            [
              -41.7999,
              -4.1735
            ],
            [
              -41.7612,
              -4.2088
            ],
            [
              -41.6568,
              -4.2198
            ],
            [
              -41.5776,
              -4.1457
            ],
            [
              -41.5747,
              -4.1594
            ],
            [
              -41.5617,
              -4.1586
            ],
            [
              -41.5456,
              -4.1639
            ],
            [
              -41.5397,
              -4.1603
            ],
            [
              -41.5254,
              -4.1636
            ],
            [
              -41.5139,
              -4.175
            ],
            [
              -41.5038,
              -4.176
            ],
            [
              -41.4973,
              -4.1804
            ],
            [
              -41.4946,
              -4.1832
            ],
            [
              -41.4792,
              -4.1836
            ],
            [
              -41.4736,
              -4.1871
            ],
            [
              -41.4563,
              -4.1863
            ],
            [
              -41.4521,
              -4.192
            ],
            [
              -41.4396,
              -4.1817
            ],
            [
              -41.432,
              -4.1813
            ],
            [
              -41.4278,
              -4.174
            ],
            [
              -41.426,
              -4.1601
            ],
            [
              -41.4151,
              -4.1556
            ],
            [
              -41.41,
              -4.1485
            ],
            [
              -41.4002,
              -4.158
            ],
            [
              -41.3939,
              -4.1611
            ],
            [
              -41.3765,
              -4.1581
            ],
            [
              -41.3713,
              -4.1472
            ],
            [
              -41.3514,
              -4.1402
            ],
            [
              -41.3426,
              -4.1399
            ],
            [
              -41.3326,
              -4.1452
            ],
            [
              -41.3318,
              -4.1513
            ],
            [
              -41.313,
              -4.1472
            ],
            [
              -41.336,
              -4.0515
            ],
            [
              -41.4849,
              -4.0415
            ],
            [
              -41.5006,
              -4.0426
            ],
            [
              -41.5553,
              -4.0574
            ],
            [
              -41.6221,
              -4.0604
            ],
            [
              -41.6319,
              -4.1356
            ],
            [
              -41.7745,
              -4.1005
            ],
            [
              -41.7607,
              -4.0975
            ],
            [
              -41.7502,
              -4.0791
            ],
            [
              -41.738,
              -4.0719
            ],
            [
              -41.7364,
              -4.0635
            ],
            [
              -41.7379,
              -4.0453
            ],
            [
              -41.7718,
              -4.034
            ],
            [
              -41.8558,
              -4.0423
            ],
            [
              -41.8559,
              -4.0406
            ],
            [
              -41.8708,
              -4.0447
            ],
            [
              -41.8779,
              -4.0405
            ],
            [
              -41.8868,
              -4.0403
            ],
            [
              -41.8942,
              -4.0461
            ],
            [
              -41.9062,
              -4.0421
            ],
            [
              -41.9134,
              -4.0348
            ],
            [
              -41.9145,
              -4.0516
            ],
            [
              -41.92,
              -4.062
            ],
            [
              -41.9348,
              -4.0693
            ],
            [
              -41.8971,
              -4.0857
            ],
            [
              -41.9328,
              -4.197
            ],
            [
              -41.9213,
              -4.1841
            ]
          ],
          [
            [
              -42.0346,
              -4.5292
            ],
            [
              -42.0131,
              -4.5295
            ],
            [
              -41.9875,
              -4.5282
            ],
            [
              -41.964,
              -4.5293
            ],
            [
              -41.9218,
              -4.5439
            ],
            [
              -41.8954,
              -4.5693
            ],
            [
              -41.8792,
              -4.5901
            ],
            [
              -41.8603,
              -4.6046
            ],
            [
              -41.8402,
              -4.6246
            ],
            [
              -41.8501,
              -4.6313
            ],
            [
              -41.8569,
              -4.6431
            ],
            [
              -41.857,
              -4.6634
            ],
            [
              -41.8643,
              -4.6805
            ],
            [
              -41.8799,
              -4.6805
            ],
            [
              -41.8188,
              -4.6971
            ],
            [
              -41.778,
              -4.6921
            ],
            [
              -41.7768,
              -4.6888
            ],
            [
              -41.7453,
              -4.5904
            ],
            [
              -41.7393,
              -4.5699
            ],
            [
              -41.7556,
              -4.545
            ],
            [
              -41.7666,
              -4.5364
            ],
            [
              -41.7799,
              -4.5321
            ],
            [
              -41.7812,
              -4.5221
            ],
            [
              -41.7932,
              -4.5113
            ],
            [
              -41.8073,
              -4.51
            ],
            [
              -41.8113,
              -4.5049
            ],
            [
              -41.8198,
              -4.5025
            ],
            [
              -41.8204,
              -4.497
            ],
            [
              -41.8345,
              -4.4815
            ],
            [
              -41.8367,
              -4.4711
            ],
            [
              -41.8497,
              -4.4599
            ],
            [
              -41.8604,
              -4.4626
            ],
            [
              -41.8739,
              -4.4576
            ],
            [
              -41.8801,
              -4.4498
            ],
            [
              -41.8886,
              -4.4473
            ],
            [
              -41.8903,
              -4.4356
            ],
            [
              -41.8983,
              -4.4335
            ],
            [
              -41.9026,
              -4.4278
            ],
            [
              -41.9189,
              -4.4317
            ],
            [
              -41.9291,
              -4.432
            ],
            [
              -41.9412,
              -4.4235
            ],
            [
              -41.9587,
              -4.4246
            ],
            [
              -41.9669,
              -4.4155
            ],
            [
              -41.9679,
              -4.4047
            ],
            [
              -41.9875,
              -4.3948
            ],
            [
              -41.9905,
              -4.3889
            ],
            [
              -42.0079,
              -4.3808
            ],
            [
              -42.0125,
              -4.3844
            ],
            [
              -42.0193,
              -4.3811
            ],
            [
              -42.0216,
              -4.3721
            ],
            [
              -42.0164,
              -4.367
            ],
            [
              -42.0269,
              -4.3542
            ],
            [
              -42.0793,
              -4.3742
            ],
            [
              -42.0584,
              -4.4035
            ],
            [
              -42.061,
              -4.434
            ],
            [
              -42.0497,
              -4.4528
            ],
            [
              -42.0574,
              -4.464
            ],
            [
              -42.0557,
              -4.5278
            ],
            [
              -42.0346,
              -4.5292
            ]
          ],
          [
            [
              -41.313,
              -4.1472
            ],
            [
              -41.3318,
              -4.1513
            ],
            [
              -41.3326,
              -4.1452
            ],
            [
              -41.3426,
              -4.1399
            ],
            [
              -41.3514,
              -4.1402
            ],
            [
              -41.3713,
              -4.1472
            ],
            [
              -41.3765,
              -4.1581
            ],
            [
              -41.3939,
              -4.1611
            ],
            [
              -41.4002,
              -4.158
            ],
            [
              -41.41,
              -4.1485
            ],
            [
              -41.4151,
              -4.1556
            ],
            [
              -41.426,
              -4.1601
            ],
            [
              -41.4278,
              -4.174
            ],
            [
              -41.432,
              -4.1813
            ],
            [
              -41.4396,
              -4.1817
            ],
            [
              -41.4521,
              -4.192
            ],
            [
              -41.4563,
              -4.1863
            ],
            [
              -41.4736,
              -4.1871
            ],
            [
              -41.4792,
              -4.1836
            ],
            [
              -41.4946,
              -4.1832
            ],
            [
              -41.4973,
              -4.1804
            ],
            [
              -41.525,
              -4.2567
            ],
            [
              -41.495,
              -4.2745
            ],
            [
              -41.4876,
              -4.3037
            ],
            [
              -41.4532,
              -4.3013
            ],
            [
              -41.4153,
              -4.311
            ],
            [
              -41.414,
              -4.3147
            ],
            [
              -41.4275,
              -4.3211
            ],
            [
              -41.4184,
              -4.3482
            ],
            [
              -41.399,
              -4.3885
            ],
            [
              -41.3877,
              -4.4325
            ],
            [
              -41.3807,
              -4.4335
            ],
            [
              -41.363,
              -4.3384
            ],
            [
              -41.3568,
              -4.3429
            ],
            [
              -41.2405,
              -4.3757
            ],
            [
              -41.229,
              -4.3404
            ],
            [
              -41.1194,
              -4.3243
            ],
            [
              -41.1191,
              -4.3065
            ],
            [
              -41.1359,
              -4.2335
            ],
            [
              -41.0991,
              -4.1818
            ],
            [
              -41.0981,
              -4.1805
            ],
            [
              -41.1224,
              -4.1759
            ],
            [
              -41.135,
              -4.1768
            ],
            [
              -41.1426,
              -4.1857
            ],
            [
              -41.1651,
              -4.1876
            ],
            [
              -41.1769,
              -4.1766
            ],
            [
              -41.1768,
              -4.1691
            ],
            [
              -41.1833,
              -4.1584
            ],
            [
              -41.1873,
              -4.1606
            ],
            [
              -41.1962,
              -4.1476
            ],
            [
              -41.2044,
              -4.1461
            ],
            [
              -41.2135,
              -4.156
            ],
            [
              -41.2237,
              -4.1582
            ],
            [
              -41.2333,
              -4.1563
            ],
            [
              -41.2413,
              -4.1452
            ],
            [
              -41.2496,
              -4.1385
            ],
            [
              -41.259,
              -4.1468
            ],
            [
              -41.2657,
              -4.161
            ],
            [
              -41.2809,
              -4.17
            ],
            [
              -41.2946,
              -4.1658
            ],
            [
              -41.297,
              -4.1565
            ],
            [
              -41.3031,
              -4.1548
            ],
            [
              -41.305,
              -4.148
            ],
            [
              -41.313,
              -4.1472
            ]
          ],
          [
            [
              -41.6053,
              -4.4095
            ],
            [
              -41.5972,
              -4.4054
            ],
            [
              -41.5887,
              -4.4156
            ],
            [
              -41.5801,
              -4.4132
            ],
            [
              -41.568,
              -4.4148
            ],
            [
              -41.5647,
              -4.4097
            ],
            [
              -41.5496,
              -4.4047
            ],
            [
              -41.5442,
              -4.4075
            ],
            [
              -41.5349,
              -4.4044
            ],
            [
              -41.529,
              -4.4106
            ],
            [
              -41.5204,
              -4.406
            ],
            [
              -41.5187,
              -4.3997
            ],
            [
              -41.5109,
              -4.4003
            ],
            [
              -41.5057,
              -4.3887
            ],
            [
              -41.5061,
              -4.3747
            ],
            [
              -41.5015,
              -4.3573
            ],
            [
              -41.5108,
              -4.3482
            ],
            [
              -41.513,
              -4.3316
            ],
            [
              -41.5302,
              -4.3317
            ],
            [
              -41.5368,
              -4.321
            ],
            [
              -41.5414,
              -4.3288
            ],
            [
              -41.5503,
              -4.3209
            ],
            [
              -41.5594,
              -4.3188
            ],
            [
              -41.5608,
              -4.3103
            ],
            [
              -41.5687,
              -4.3062
            ],
            [
              -41.5786,
              -4.3093
            ],
            [
              -41.5823,
              -4.3037
            ],
            [
              -41.5937,
              -4.3022
            ],
            [
              -41.5966,
              -4.2952
            ],
            [
              -41.6084,
              -4.3018
            ],
            [
              -41.6065,
              -4.3108
            ],
            [
              -41.6165,
              -4.318
            ],
            [
              -41.6128,
              -4.3264
            ],
            [
              -41.6173,
              -4.3389
            ],
            [
              -41.6274,
              -4.34
            ],
            [
              -41.6365,
              -4.35
            ],
            [
              -41.6418,
              -4.3462
            ],
            [
              -41.6482,
              -4.3484
            ],
            [
              -41.6547,
              -4.3446
            ],
            [
              -41.6646,
              -4.3458
            ],
            [
              -41.6674,
              -4.3538
            ],
            [
              -41.6577,
              -4.3839
            ],
            [
              -41.6585,
              -4.3953
            ],
            [
              -41.6414,
              -4.4092
            ],
            [
              -41.6337,
              -4.4065
            ],
            [
              -41.6268,
              -4.4091
            ],
            [
              -41.6117,
              -4.4055
            ],
            [
              -41.6053,
              -4.4095
            ]
          ],
          [
            [
              -41.7453,
              -4.5904
            ],
            [
              -41.5122,
              -4.5807
            ],
            [
              -41.2935,
              -4.5561
            ],
            [
              -41.294,
              -4.6296
            ],
            [
              -41.2952,
              -4.8149
            ],
            [
              -41.268,
              -4.8116
            ],
            [
              -41.2597,
              -4.8086
            ],
            [
              -41.2559,
              -4.8006
            ],
            [
              -41.2332,
              -4.8101
            ],
            [
              -41.2325,
              -4.8045
            ],
            [
              -41.2254,
              -4.7978
            ],
            [
              -41.224,
              -4.7907
            ],
            [
              -41.2081,
              -4.7803
            ],
            [
              -41.2128,
              -4.772
            ],
            [
              -41.2339,
              -4.7688
            ],
            [
              -41.2478,
              -4.7618
            ],
            [
              -41.2503,
              -4.7566
            ],
            [
              -41.2352,
              -4.7465
            ],
            [
              -41.2367,
              -4.7388
            ],
            [
              -41.226,
              -4.7265
            ],
            [
              -41.2238,
              -4.7209
            ],
            [
              -41.2025,
              -4.7019
            ],
            [
              -41.1811,
              -4.6732
            ],
            [
              -41.1754,
              -4.6708
            ],
            [
              -41.1856,
              -4.662
            ],
            [
              -41.2028,
              -4.6382
            ],
            [
              -41.2293,
              -4.6201
            ],
            [
              -41.2334,
              -4.6102
            ],
            [
              -41.223,
              -4.5898
            ],
            [
              -41.222,
              -4.5778
            ],
            [
              -41.2398,
              -4.5736
            ],
            [
              -41.2354,
              -4.5702
            ],
            [
              -41.2215,
              -4.5675
            ],
            [
              -41.2141,
              -4.5527
            ],
            [
              -41.2084,
              -4.5488
            ],
            [
              -41.2038,
              -4.5284
            ],
            [
              -41.1908,
              -4.5155
            ],
            [
              -41.1879,
              -4.4861
            ],
            [
              -41.1776,
              -4.4677
            ],
            [
              -41.1785,
              -4.4594
            ],
            [
              -41.1752,
              -4.4495
            ],
            [
              -41.1774,
              -4.4433
            ],
            [
              -41.1651,
              -4.4226
            ],
            [
              -41.1597,
              -4.4106
            ],
            [
              -41.159,
              -4.3921
            ],
            [
              -41.1618,
              -4.3873
            ],
            [
              -41.158,
              -4.3787
            ],
            [
              -41.1491,
              -4.3672
            ],
            [
              -41.1421,
              -4.359
            ],
            [
              -41.1334,
              -4.3401
            ],
            [
              -41.1202,
              -4.3306
            ],
            [
              -41.1194,
              -4.3243
            ],
            [
              -41.229,
              -4.3404
            ],
            [
              -41.2405,
              -4.3757
            ],
            [
              -41.3568,
              -4.3429
            ],
            [
              -41.363,
              -4.3384
            ],
            [
              -41.3807,
              -4.4335
            ],
            [
              -41.3877,
              -4.4325
            ],
            [
              -41.399,
              -4.3885
            ],
            [
              -41.4184,
              -4.3482
            ],
            [
              -41.4275,
              -4.3211
            ],
            [
              -41.414,
              -4.3147
            ],
            [
              -41.4153,
              -4.311
            ],
            [
              -41.4532,
              -4.3013
            ],
            [
              -41.4876,
              -4.3037
            ],
            [
              -41.495,
              -4.2745
            ],
            [
              -41.525,
              -4.2567
            ],
            [
              -41.5608,
              -4.3103
            ],
            [
              -41.5594,
              -4.3188
            ],
            [
              -41.5503,
              -4.3209
            ],
            [
              -41.5414,
              -4.3288
            ],
            [
              -41.5368,
              -4.321
            ],
            [
              -41.5302,
              -4.3317
            ],
            [
              -41.513,
              -4.3316
            ],
            [
              -41.5108,
              -4.3482
            ],
            [
              -41.5015,
              -4.3573
            ],
            [
              -41.5061,
              -4.3747
            ],
            [
              -41.5057,
              -4.3887
            ],
            [
              -41.5109,
              -4.4003
            ],
            [
              -41.5187,
              -4.3997
            ],
            [
              -41.5204,
              -4.406
            ],
            [
              -41.529,
              -4.4106
            ],
            [
              -41.5349,
              -4.4044
            ],
            [
              -41.5442,
              -4.4075
            ],
            [
              -41.5496,
              -4.4047
            ],
            [
              -41.5647,
              -4.4097
            ],
            [
              -41.568,
              -4.4148
            ],
            [
              -41.5801,
              -4.4132
            ],
            [
              -41.5887,
              -4.4156
            ],
            [
              -41.5972,
              -4.4054
            ],
            [
              -41.6053,
              -4.4095
            ],
            [
              -41.6211,
              -4.4389
            ],
            [
              -41.6387,
              -4.4632
            ],
            [
              -41.7303,
              -4.5473
            ],
            [
              -41.7393,
              -4.5699
            ],
            [
              -41.7453,
              -4.5904
            ]
          ],
          [
            [
              -41.8559,
              -4.0406
            ],
            [
              -41.8558,
              -4.0423
            ],
            [
              -41.7718,
              -4.034
            ],
            [
              -41.7379,
              -4.0453
            ],
            [
              -41.7364,
              -4.0635
            ],
            [
              -41.738,
              -4.0719
            ],
            [
              -41.7502,
              -4.0791
            ],
            [
              -41.7607,
              -4.0975
            ],
            [
              -41.7745,
              -4.1005
            ],
            [
              -41.6319,
              -4.1356
            ],
            [
              -41.6221,
              -4.0604
            ],
            [
              -41.5553,
              -4.0574
            ],
            [
              -41.5006,
              -4.0426
            ],
            [
              -41.4849,
              -4.0415
            ],
            [
              -41.3659,
              -3.8848
            ],
            [
              -41.2786,
              -3.77
            ],
            [
              -41.3133,
              -3.7394
            ],
            [
              -41.3347,
              -3.6915
            ],
            [
              -41.3358,
              -3.7013
            ],
            [
              -41.3524,
              -3.6999
            ],
            [
              -41.3602,
              -3.7094
            ],
            [
              -41.371,
              -3.7147
            ],
            [
              -41.3759,
              -3.712
            ],
            [
              -41.4007,
              -3.7305
            ],
            [
              -41.4181,
              -3.7535
            ],
            [
              -41.4498,
              -3.7424
            ],
            [
              -41.4487,
              -3.7024
            ],
            [
              -41.4576,
              -3.6698
            ],
            [
              -41.4873,
              -3.6539
            ],
            [
              -41.5066,
              -3.6308
            ],
            [
              -41.5242,
              -3.6058
            ],
            [
              -41.6491,
              -3.64
            ],
            [
              -41.678,
              -3.6647
            ],
            [
              -41.7455,
              -3.6726
            ],
            [
              -41.7466,
              -3.5865
            ],
            [
              -41.7729,
              -3.5727
            ],
            [
              -41.7943,
              -3.6241
            ],
            [
              -41.8666,
              -3.7209
            ],
            [
              -41.8298,
              -3.7534
            ],
            [
              -41.8183,
              -3.7534
            ],
            [
              -41.7131,
              -3.771
            ],
            [
              -41.6866,
              -3.7815
            ],
            [
              -41.6864,
              -3.797
            ],
            [
              -41.8355,
              -3.8484
            ],
            [
              -41.8656,
              -3.8483
            ],
            [
              -41.9031,
              -3.8869
            ],
            [
              -41.9108,
              -3.9408
            ],
            [
              -41.8476,
              -3.9738
            ],
            [
              -41.8559,
              -4.0406
            ]
          ],
          [
            [
              -41.6053,
              -4.4095
            ],
            [
              -41.6117,
              -4.4055
            ],
            [
              -41.6268,
              -4.4091
            ],
            [
              -41.6337,
              -4.4065
            ],
            [
              -41.6414,
              -4.4092
            ],
            [
              -41.6585,
              -4.3953
            ],
            [
              -41.6577,
              -4.3839
            ],
            [
              -41.6674,
              -4.3538
            ],
            [
              -41.6646,
              -4.3458
            ],
            [
              -41.6547,
              -4.3446
            ],
            [
              -41.6482,
              -4.3484
            ],
            [
              -41.6418,
              -4.3462
            ],
            [
              -41.6365,
              -4.35
            ],
            [
              -41.6274,
              -4.34
            ],
            [
              -41.6173,
              -4.3389
            ],
            [
              -41.6128,
              -4.3264
            ],
            [
              -41.6165,
              -4.318
            ],
            [
              -41.6065,
              -4.3108
            ],
            [
              -41.6084,
              -4.3018
            ],
            [
              -41.5966,
              -4.2952
            ],
            [
              -41.5937,
              -4.3022
            ],
            [
              -41.5823,
              -4.3037
            ],
            [
              -41.5786,
              -4.3093
            ],
            [
              -41.5687,
              -4.3062
            ],
            [
              -41.5608,
              -4.3103
            ],
            [
              -41.525,
              -4.2567
            ],
            [
              -41.4973,
              -4.1804
            ],
            [
              -41.5038,
              -4.176
            ],
            [
              -41.5139,
              -4.175
            ],
            [
              -41.5254,
              -4.1636
            ],
            [
              -41.5397,
              -4.1603
            ],
            [
              -41.5456,
              -4.1639
            ],
            [
              -41.5617,
              -4.1586
            ],
            [
              -41.5747,
              -4.1594
            ],
            [
              -41.5776,
              -4.1457
            ],
            [
              -41.6568,
              -4.2198
            ],
            [
              -41.7612,
              -4.2088
            ],
            [
              -41.7999,
              -4.1735
            ],
            [
              -41.799,
              -4.1906
            ],
            [
              -41.8045,
              -4.2022
            ],
            [
              -41.9214,
              -4.1814
            ],
            [
              -41.9213,
              -4.1841
            ],
            [
              -41.9189,
              -4.2239
            ],
            [
              -41.9332,
              -4.2259
            ],
            [
              -41.9544,
              -4.2207
            ],
            [
              -41.964,
              -4.2341
            ],
            [
              -41.9789,
              -4.2462
            ],
            [
              -41.9966,
              -4.2452
            ],
            [
              -42.0005,
              -4.2722
            ],
            [
              -42.0005,
              -4.3441
            ],
            [
              -42.0269,
              -4.3542
            ],
            [
              -42.0164,
              -4.367
            ],
            [
              -42.0216,
              -4.3721
            ],
            [
              -42.0193,
              -4.3811
            ],
            [
              -42.0125,
              -4.3844
            ],
            [
              -42.0079,
              -4.3808
            ],
            [
              -41.9905,
              -4.3889
            ],
            [
              -41.9875,
              -4.3948
            ],
            [
              -41.9679,
              -4.4047
            ],
            [
              -41.9669,
              -4.4155
            ],
            [
              -41.9587,
              -4.4246
            ],
            [
              -41.9412,
              -4.4235
            ],
            [
              -41.9291,
              -4.432
            ],
            [
              -41.9189,
              -4.4317
            ],
            [
              -41.9026,
              -4.4278
            ],
            [
              -41.8983,
              -4.4335
            ],
            [
              -41.8903,
              -4.4356
            ],
            [
              -41.8886,
              -4.4473
            ],
            [
              -41.8801,
              -4.4498
            ],
            [
              -41.8739,
              -4.4576
            ],
            [
              -41.8604,
              -4.4626
            ],
            [
              -41.8497,
              -4.4599
            ],
            [
              -41.8367,
              -4.4711
            ],
            [
              -41.8345,
              -4.4815
            ],
            [
              -41.8204,
              -4.497
            ],
            [
              -41.8198,
              -4.5025
            ],
            [
              -41.8113,
              -4.5049
            ],
            [
              -41.8073,
              -4.51
            ],
            [
              -41.7932,
              -4.5113
            ],
            [
              -41.7812,
              -4.5221
            ],
            [
              -41.7799,
              -4.5321
            ],
            [
              -41.7666,
              -4.5364
            ],
            [
              -41.7556,
              -4.545
            ],
            [
              -41.7393,
              -4.5699
            ],
            [
              -41.7303,
              -4.5473
            ],
            [
              -41.6387,
              -4.4632
            ],
            [
              -41.6211,
              -4.4389
            ],
            [
              -41.6053,
              -4.4095
            ]
          ],
          [
            [
              -41.6548,
              -4.7763
            ],
            [
              -41.6187,
              -4.7601
            ],
            [
              -41.5962,
              -4.7557
            ],
            [
              -41.5601,
              -4.745
            ],
            [
              -41.5566,
              -4.7505
            ],
            [
              -41.5572,
              -4.7518
            ],
            [
              -41.5558,
              -4.7527
            ],
            [
              -41.5554,
              -4.7539
            ],
            [
              -41.5559,
              -4.7565
            ],
            [
              -41.5537,
              -4.7572
            ],
            [
              -41.5528,
              -4.7558
            ],
            [
              -41.5514,
              -4.7556
            ],
            [
              -41.5496,
              -4.7559
            ],
            [
              -41.5472,
              -4.7571
            ],
            [
              -41.5449,
              -4.7578
            ],
            [
              -41.5433,
              -4.7593
            ],
            [
              -41.5427,
              -4.762
            ],
            [
              -41.5428,
              -4.7638
            ],
            [
              -41.544,
              -4.7658
            ],
            [
              -41.5395,
              -4.7848
            ],
            [
              -41.5253,
              -4.8283
            ],
            [
              -41.4937,
              -4.8284
            ],
            [
              -41.4729,
              -4.8335
            ],
            [
              -41.451,
              -4.8255
            ],
            [
              -41.4442,
              -4.8412
            ],
            [
              -41.4348,
              -4.8611
            ],
            [
              -41.4124,
              -4.8751
            ],
            [
              -41.384,
              -4.8839
            ],
            [
              -41.3762,
              -4.8786
            ],
            [
              -41.3706,
              -4.8735
            ],
            [
              -41.3681,
              -4.8724
            ],
            [
              -41.3663,
              -4.8724
            ],
            [
              -41.3626,
              -4.8705
            ],
            [
              -41.3576,
              -4.8671
            ],
            [
              -41.3548,
              -4.8661
            ],
            [
              -41.3522,
              -4.8656
            ],
            [
              -41.3477,
              -4.8652
            ],
            [
              -41.3404,
              -4.8682
            ],
            [
              -41.3373,
              -4.8691
            ],
            [
              -41.3339,
              -4.8688
            ],
            [
              -41.3318,
              -4.8678
            ],
            [
              -41.3303,
              -4.8681
            ],
            [
              -41.3276,
              -4.8698
            ],
            [
              -41.3262,
              -4.8713
            ],
            [
              -41.325,
              -4.8713
            ],
            [
              -41.3211,
              -4.8684
            ],
            [
              -41.3164,
              -4.868
            ],
            [
              -41.3138,
              -4.868
            ],
            [
              -41.3119,
              -4.867
            ],
            [
              -41.3104,
              -4.8631
            ],
            [
              -41.3073,
              -4.8593
            ],
            [
              -41.3064,
              -4.8562
            ],
            [
              -41.305,
              -4.8529
            ],
            [
              -41.3029,
              -4.8494
            ],
            [
              -41.2955,
              -4.8527
            ],
            [
              -41.2924,
              -4.8551
            ],
            [
              -41.2893,
              -4.8606
            ],
            [
              -41.2884,
              -4.8603
            ],
            [
              -41.2865,
              -4.8565
            ],
            [
              -41.2841,
              -4.8547
            ],
            [
              -41.2784,
              -4.8534
            ],
            [
              -41.268,
              -4.8116
            ],
            [
              -41.2952,
              -4.8149
            ],
            [
              -41.294,
              -4.6296
            ],
            [
              -41.2935,
              -4.5561
            ],
            [
              -41.3409,
              -4.5615
            ],
            [
              -41.4334,
              -4.5718
            ],
            [
              -41.4858,
              -4.5777
            ],
            [
              -41.5122,
              -4.5807
            ],
            [
              -41.5867,
              -4.5838
            ],
            [
              -41.7294,
              -4.5898
            ],
            [
              -41.7453,
              -4.5904
            ],
            [
              -41.7768,
              -4.6888
            ],
            [
              -41.7469,
              -4.7029
            ],
            [
              -41.7466,
              -4.7033
            ],
            [
              -41.6992,
              -4.7614
            ],
            [
              -41.6954,
              -4.7659
            ],
            [
              -41.6896,
              -4.7642
            ],
            [
              -41.6548,
              -4.7763
            ]
          ],
          [
            [
              -41.313,
              -4.1472
            ],
            [
              -41.3096,
              -4.1441
            ],
            [
              -41.3071,
              -4.147
            ],
            [
              -41.305,
              -4.148
            ],
            [
              -41.3024,
              -4.147
            ],
            [
              -41.3019,
              -4.1483
            ],
            [
              -41.3022,
              -4.1517
            ],
            [
              -41.3031,
              -4.1548
            ],
            [
              -41.3021,
              -4.1569
            ],
            [
              -41.3011,
              -4.1567
            ],
            [
              -41.2994,
              -4.1554
            ],
            [
              -41.297,
              -4.1565
            ],
            [
              -41.2966,
              -4.1598
            ],
            [
              -41.2958,
              -4.1633
            ],
            [
              -41.2946,
              -4.1658
            ],
            [
              -41.295,
              -4.1675
            ],
            [
              -41.2941,
              -4.1682
            ],
            [
              -41.2929,
              -4.1676
            ],
            [
              -41.2909,
              -4.1689
            ],
            [
              -41.285,
              -4.1694
            ],
            [
              -41.2809,
              -4.17
            ],
            [
              -41.2792,
              -4.169
            ],
            [
              -41.277,
              -4.1686
            ],
            [
              -41.2766,
              -4.1667
            ],
            [
              -41.2713,
              -4.1654
            ],
            [
              -41.2674,
              -4.1631
            ],
            [
              -41.2657,
              -4.161
            ],
            [
              -41.2631,
              -4.1618
            ],
            [
              -41.2624,
              -4.1595
            ],
            [
              -41.2624,
              -4.157
            ],
            [
              -41.2619,
              -4.1554
            ],
            [
              -41.2622,
              -4.1541
            ],
            [
              -41.2611,
              -4.152
            ],
            [
              -41.2604,
              -4.1493
            ],
            [
              -41.2596,
              -4.1486
            ],
            [
              -41.259,
              -4.1468
            ],
            [
              -41.2597,
              -4.1457
            ],
            [
              -41.2594,
              -4.1445
            ],
            [
              -41.2581,
              -4.1439
            ],
            [
              -41.2567,
              -4.1424
            ],
            [
              -41.255,
              -4.1431
            ],
            [
              -41.2535,
              -4.1415
            ],
            [
              -41.2523,
              -4.1411
            ],
            [
              -41.2496,
              -4.1385
            ],
            [
              -41.2477,
              -4.1387
            ],
            [
              -41.2451,
              -4.1407
            ],
            [
              -41.2451,
              -4.1417
            ],
            [
              -41.2413,
              -4.1452
            ],
            [
              -41.2408,
              -4.1472
            ],
            [
              -41.2392,
              -4.1497
            ],
            [
              -41.2393,
              -4.1511
            ],
            [
              -41.2375,
              -4.1525
            ],
            [
              -41.2366,
              -4.1539
            ],
            [
              -41.2333,
              -4.1563
            ],
            [
              -41.2316,
              -4.1569
            ],
            [
              -41.2303,
              -4.1567
            ],
            [
              -41.229,
              -4.1553
            ],
            [
              -41.2276,
              -4.1554
            ],
            [
              -41.2263,
              -4.1563
            ],
            [
              -41.2249,
              -4.1582
            ],
            [
              -41.2237,
              -4.1582
            ],
            [
              -41.2222,
              -4.1558
            ],
            [
              -41.2184,
              -4.1567
            ],
            [
              -41.2173,
              -4.1574
            ],
            [
              -41.2153,
              -4.157
            ],
            [
              -41.2135,
              -4.156
            ],
            [
              -41.211,
              -4.1536
            ],
            [
              -41.2095,
              -4.1513
            ],
            [
              -41.209,
              -4.1497
            ],
            [
              -41.2093,
              -4.1469
            ],
            [
              -41.207,
              -4.1469
            ],
            [
              -41.2044,
              -4.1461
            ],
            [
              -41.2036,
              -4.1472
            ],
            [
              -41.2023,
              -4.1469
            ],
            [
              -41.2012,
              -4.1484
            ],
            [
              -41.1999,
              -4.1487
            ],
            [
              -41.1977,
              -4.1475
            ],
            [
              -41.1962,
              -4.1476
            ],
            [
              -41.1959,
              -4.1497
            ],
            [
              -41.1937,
              -4.1523
            ],
            [
              -41.1933,
              -4.1538
            ],
            [
              -41.1918,
              -4.1548
            ],
            [
              -41.1901,
              -4.1551
            ],
            [
              -41.1908,
              -4.1571
            ],
            [
              -41.1903,
              -4.1593
            ],
            [
              -41.1873,
              -4.1606
            ],
            [
              -41.1853,
              -4.1599
            ],
            [
              -41.1833,
              -4.1584
            ],
            [
              -41.181,
              -4.1607
            ],
            [
              -41.1814,
              -4.1621
            ],
            [
              -41.1808,
              -4.1637
            ],
            [
              -41.1798,
              -4.1645
            ],
            [
              -41.179,
              -4.1663
            ],
            [
              -41.1768,
              -4.1691
            ],
            [
              -41.1759,
              -4.1726
            ],
            [
              -41.1762,
              -4.1737
            ],
            [
              -41.1775,
              -4.1751
            ],
            [
              -41.1769,
              -4.1766
            ],
            [
              -41.1744,
              -4.1784
            ],
            [
              -41.1703,
              -4.1803
            ],
            [
              -41.1687,
              -4.1828
            ],
            [
              -41.1651,
              -4.1876
            ],
            [
              -41.1639,
              -4.1883
            ],
            [
              -41.1615,
              -4.1882
            ],
            [
              -41.1594,
              -4.1866
            ],
            [
              -41.1579,
              -4.1864
            ],
            [
              -41.1556,
              -4.1889
            ],
            [
              -41.1546,
              -4.1887
            ],
            [
              -41.1526,
              -4.1874
            ],
            [
              -41.1511,
              -4.1872
            ],
            [
              -41.1497,
              -4.1856
            ],
            [
              -41.147,
              -4.1858
            ],
            [
              -41.145,
              -4.1854
            ],
            [
              -41.1438,
              -4.186
            ],
            [
              -41.1426,
              -4.1857
            ],
            [
              -41.1402,
              -4.1828
            ],
            [
              -41.139,
              -4.1817
            ],
            [
              -41.1359,
              -4.1774
            ],
            [
              -41.135,
              -4.1768
            ],
            [
              -41.131,
              -4.1767
            ],
            [
              -41.1295,
              -4.1772
            ],
            [
              -41.128,
              -4.1764
            ],
            [
              -41.1258,
              -4.176
            ],
            [
              -41.1241,
              -4.1762
            ],
            [
              -41.1224,
              -4.1759
            ],
            [
              -41.1206,
              -4.1775
            ],
            [
              -41.1185,
              -4.1773
            ],
            [
              -41.1159,
              -4.1765
            ],
            [
              -41.1137,
              -4.178
            ],
            [
              -41.1114,
              -4.1791
            ],
            [
              -41.1095,
              -4.1795
            ],
            [
              -41.1069,
              -4.1791
            ],
            [
              -41.1058,
              -4.1797
            ],
            [
              -41.1036,
              -4.1798
            ],
            [
              -41.1017,
              -4.1804
            ],
            [
              -41.0981,
              -4.1805
            ],
            [
              -41.0909,
              -4.1703
            ],
            [
              -41.0939,
              -4.1699
            ],
            [
              -41.097,
              -4.1707
            ],
            [
              -41.1058,
              -4.1696
            ],
            [
              -41.1113,
              -4.1669
            ],
            [
              -41.1176,
              -4.1657
            ],
            [
              -41.1183,
              -4.1652
            ],
            [
              -41.121,
              -4.1605
            ],
            [
              -41.1231,
              -4.1582
            ],
            [
              -41.1237,
              -4.1562
            ],
            [
              -41.1254,
              -4.1545
            ],
            [
              -41.1268,
              -4.1507
            ],
            [
              -41.1258,
              -4.1485
            ],
            [
              -41.1253,
              -4.1449
            ],
            [
              -41.1281,
              -4.1393
            ],
            [
              -41.1343,
              -4.1317
            ],
            [
              -41.1421,
              -4.1256
            ],
            [
              -41.1431,
              -4.1242
            ],
            [
              -41.1408,
              -4.1236
            ],
            [
              -41.1394,
              -4.121
            ],
            [
              -41.1371,
              -4.1169
            ],
            [
              -41.1344,
              -4.1049
            ],
            [
              -41.1289,
              -4.0973
            ],
            [
              -41.1281,
              -4.0942
            ],
            [
              -41.1276,
              -4.0887
            ],
            [
              -41.1222,
              -4.0772
            ],
            [
              -41.1216,
              -4.0742
            ],
            [
              -41.122,
              -4.0722
            ],
            [
              -41.1275,
              -4.0661
            ],
            [
              -41.1279,
              -4.0639
            ],
            [
              -41.1272,
              -4.0614
            ],
            [
              -41.1258,
              -4.0603
            ],
            [
              -41.1164,
              -4.0541
            ],
            [
              -41.1141,
              -4.0518
            ],
            [
              -41.1132,
              -4.0498
            ],
            [
              -41.1132,
              -4.047
            ],
            [
              -41.1125,
              -4.0442
            ],
            [
              -41.1129,
              -4.0417
            ],
            [
              -41.1143,
              -4.0406
            ],
            [
              -41.1203,
              -4.0363
            ],
            [
              -41.1222,
              -4.037
            ],
            [
              -41.1239,
              -4.0371
            ],
            [
              -41.1302,
              -4.0354
            ],
            [
              -41.1337,
              -4.0352
            ],
            [
              -41.1431,
              -4.0368
            ],
            [
              -41.1533,
              -4.0349
            ],
            [
              -41.16,
              -4.0317
            ],
            [
              -41.1635,
              -4.0318
            ],
            [
              -41.1688,
              -4.0331
            ],
            [
              -41.1718,
              -4.0325
            ],
            [
              -41.176,
              -4.0288
            ],
            [
              -41.1807,
              -4.0277
            ],
            [
              -41.182,
              -4.0267
            ],
            [
              -41.1838,
              -4.0244
            ],
            [
              -41.1822,
              -4.0192
            ],
            [
              -41.1829,
              -4.018
            ],
            [
              -41.1855,
              -4.0172
            ],
            [
              -41.1886,
              -4.0176
            ],
            [
              -41.1916,
              -4.019
            ],
            [
              -41.1926,
              -4.0207
            ],
            [
              -41.1958,
              -4.0203
            ],
            [
              -41.1978,
              -4.0184
            ],
            [
              -41.1995,
              -4.0184
            ],
            [
              -41.2033,
              -4.0225
            ],
            [
              -41.206,
              -4.0243
            ],
            [
              -41.2089,
              -4.0256
            ],
            [
              -41.2107,
              -4.0258
            ],
            [
              -41.2141,
              -4.0242
            ],
            [
              -41.2221,
              -4.0271
            ],
            [
              -41.2229,
              -4.0284
            ],
            [
              -41.2244,
              -4.0286
            ],
            [
              -41.2268,
              -4.0272
            ],
            [
              -41.2309,
              -4.0289
            ],
            [
              -41.2403,
              -4.0308
            ],
            [
              -41.2502,
              -4.0378
            ],
            [
              -41.2521,
              -4.0378
            ],
            [
              -41.2547,
              -4.0371
            ],
            [
              -41.2567,
              -4.0348
            ],
            [
              -41.2556,
              -4.0326
            ],
            [
              -41.2555,
              -4.0297
            ],
            [
              -41.2544,
              -4.0277
            ],
            [
              -41.2529,
              -4.0265
            ],
            [
              -41.2507,
              -4.0268
            ],
            [
              -41.2495,
              -4.0264
            ],
            [
              -41.2446,
              -4.022
            ],
            [
              -41.2438,
              -4.0197
            ],
            [
              -41.2395,
              -4.0169
            ],
            [
              -41.2388,
              -4.0154
            ],
            [
              -41.2392,
              -4.0131
            ],
            [
              -41.2426,
              -4.0099
            ],
            [
              -41.2443,
              -4.0068
            ],
            [
              -41.2457,
              -4.0066
            ],
            [
              -41.2458,
              -4.0039
            ],
            [
              -41.2464,
              -4.0013
            ],
            [
              -41.2479,
              -3.9994
            ],
            [
              -41.2473,
              -3.997
            ],
            [
              -41.2474,
              -3.9932
            ],
            [
              -41.2492,
              -3.9899
            ],
            [
              -41.2477,
              -3.9891
            ],
            [
              -41.2468,
              -3.9879
            ],
            [
              -41.2442,
              -3.9864
            ],
            [
              -41.2441,
              -3.9842
            ],
            [
              -41.2447,
              -3.983
            ],
            [
              -41.2444,
              -3.9798
            ],
            [
              -41.2438,
              -3.9793
            ],
            [
              -41.2416,
              -3.9799
            ],
            [
              -41.2401,
              -3.9792
            ],
            [
              -41.2396,
              -3.9771
            ],
            [
              -41.2386,
              -3.9757
            ],
            [
              -41.2388,
              -3.9739
            ],
            [
              -41.2382,
              -3.9728
            ],
            [
              -41.2338,
              -3.9706
            ],
            [
              -41.2343,
              -3.9678
            ],
            [
              -41.2313,
              -3.9665
            ],
            [
              -41.2289,
              -3.9681
            ],
            [
              -41.2202,
              -3.9415
            ],
            [
              -41.2289,
              -3.9117
            ],
            [
              -41.23,
              -3.9109
            ],
            [
              -41.2326,
              -3.9108
            ],
            [
              -41.2333,
              -3.9103
            ],
            [
              -41.2356,
              -3.906
            ],
            [
              -41.239,
              -3.9035
            ],
            [
              -41.2417,
              -3.9005
            ],
            [
              -41.2453,
              -3.8983
            ],
            [
              -41.2457,
              -3.8964
            ],
            [
              -41.2447,
              -3.8933
            ],
            [
              -41.2466,
              -3.8845
            ],
            [
              -41.2476,
              -3.8823
            ],
            [
              -41.2535,
              -3.8759
            ],
            [
              -41.2554,
              -3.8729
            ],
            [
              -41.2589,
              -3.8703
            ],
            [
              -41.2597,
              -3.8687
            ],
            [
              -41.26,
              -3.8648
            ],
            [
              -41.2613,
              -3.864
            ],
            [
              -41.2669,
              -3.8627
            ],
            [
              -41.2678,
              -3.8612
            ],
            [
              -41.2669,
              -3.8605
            ],
            [
              -41.2668,
              -3.8589
            ],
            [
              -41.2701,
              -3.8544
            ],
            [
              -41.2704,
              -3.8523
            ],
            [
              -41.2681,
              -3.8483
            ],
            [
              -41.269,
              -3.8459
            ],
            [
              -41.2686,
              -3.8445
            ],
            [
              -41.2713,
              -3.8419
            ],
            [
              -41.2707,
              -3.8378
            ],
            [
              -41.272,
              -3.8365
            ],
            [
              -41.2737,
              -3.8357
            ],
            [
              -41.2751,
              -3.8339
            ],
            [
              -41.2752,
              -3.8302
            ],
            [
              -41.2769,
              -3.8256
            ],
            [
              -41.278,
              -3.8245
            ],
            [
              -41.279,
              -3.8246
            ],
            [
              -41.2814,
              -3.8268
            ],
            [
              -41.2827,
              -3.8268
            ],
            [
              -41.2847,
              -3.8255
            ],
            [
              -41.2867,
              -3.8227
            ],
            [
              -41.2879,
              -3.8225
            ],
            [
              -41.2894,
              -3.8255
            ],
            [
              -41.2925,
              -3.8258
            ],
            [
              -41.2942,
              -3.8295
            ],
            [
              -41.2952,
              -3.8302
            ],
            [
              -41.2967,
              -3.8294
            ],
            [
              -41.299,
              -3.8261
            ],
            [
              -41.3008,
              -3.8263
            ],
            [
              -41.2987,
              -3.8232
            ],
            [
              -41.2944,
              -3.8186
            ],
            [
              -41.2898,
              -3.8148
            ],
            [
              -41.2805,
              -3.8055
            ],
            [
              -41.2756,
              -3.8023
            ],
            [
              -41.2708,
              -3.7968
            ],
            [
              -41.2648,
              -3.7916
            ],
            [
              -41.2626,
              -3.7888
            ],
            [
              -41.2541,
              -3.775
            ],
            [
              -41.2538,
              -3.7734
            ],
            [
              -41.2548,
              -3.7703
            ],
            [
              -41.2605,
              -3.7625
            ],
            [
              -41.2612,
              -3.7575
            ],
            [
              -41.2615,
              -3.7519
            ],
            [
              -41.2613,
              -3.7462
            ],
            [
              -41.26,
              -3.7393
            ],
            [
              -41.2585,
              -3.7328
            ],
            [
              -41.2574,
              -3.7299
            ],
            [
              -41.2531,
              -3.7242
            ],
            [
              -41.2519,
              -3.7233
            ],
            [
              -41.2472,
              -3.7221
            ],
            [
              -41.2394,
              -3.7207
            ],
            [
              -41.2385,
              -3.7199
            ],
            [
              -41.2381,
              -3.7178
            ],
            [
              -41.2383,
              -3.7158
            ],
            [
              -41.2393,
              -3.7128
            ],
            [
              -41.2418,
              -3.711
            ],
            [
              -41.2454,
              -3.7109
            ],
            [
              -41.2474,
              -3.7099
            ],
            [
              -41.2502,
              -3.7066
            ],
            [
              -41.2554,
              -3.7033
            ],
            [
              -41.2583,
              -3.7036
            ],
            [
              -41.2717,
              -3.7034
            ],
            [
              -41.2793,
              -3.7007
            ],
            [
              -41.283,
              -3.697
            ],
            [
              -41.2861,
              -3.6922
            ],
            [
              -41.2877,
              -3.6909
            ],
            [
              -41.2908,
              -3.6897
            ],
            [
              -41.2999,
              -3.6875
            ],
            [
              -41.3077,
              -3.6848
            ],
            [
              -41.3169,
              -3.6866
            ],
            [
              -41.3208,
              -3.6868
            ],
            [
              -41.3225,
              -3.6878
            ],
            [
              -41.3265,
              -3.6873
            ],
            [
              -41.3289,
              -3.6863
            ],
            [
              -41.3318,
              -3.6858
            ],
            [
              -41.3342,
              -3.684
            ],
            [
              -41.3347,
              -3.6915
            ],
            [
              -41.3133,
              -3.7394
            ],
            [
              -41.2786,
              -3.77
            ],
            [
              -41.3659,
              -3.8848
            ],
            [
              -41.4504,
              -3.9961
            ],
            [
              -41.4849,
              -4.0415
            ],
            [
              -41.336,
              -4.0515
            ],
            [
              -41.313,
              -4.1472
            ]
          ],
          [
            [
              -41.9621,
              -3.6793
            ],
            [
              -41.9694,
              -3.685
            ],
            [
              -41.9724,
              -3.6882
            ],
            [
              -41.9733,
              -3.6898
            ],
            [
              -41.9754,
              -3.6969
            ],
            [
              -41.9759,
              -3.7023
            ],
            [
              -41.9753,
              -3.7059
            ],
            [
              -41.9754,
              -3.7111
            ],
            [
              -41.9768,
              -3.7161
            ],
            [
              -41.9758,
              -3.7228
            ],
            [
              -41.9768,
              -3.7262
            ],
            [
              -41.9781,
              -3.7288
            ],
            [
              -41.9785,
              -3.7309
            ],
            [
              -41.9777,
              -3.7369
            ],
            [
              -41.9782,
              -3.7401
            ],
            [
              -41.9775,
              -3.7429
            ],
            [
              -41.9766,
              -3.7483
            ],
            [
              -41.9757,
              -3.7517
            ],
            [
              -41.9754,
              -3.7541
            ],
            [
              -41.9768,
              -3.7573
            ],
            [
              -41.9766,
              -3.7604
            ],
            [
              -41.9755,
              -3.7631
            ],
            [
              -41.9753,
              -3.7649
            ],
            [
              -41.9759,
              -3.7663
            ],
            [
              -41.9791,
              -3.7695
            ],
            [
              -41.9809,
              -3.7719
            ],
            [
              -41.9816,
              -3.7738
            ],
            [
              -41.9813,
              -3.777
            ],
            [
              -41.9806,
              -3.7797
            ],
            [
              -41.9811,
              -3.784
            ],
            [
              -41.8984,
              -3.7967
            ],
            [
              -41.9019,
              -3.8641
            ],
            [
              -41.9031,
              -3.8869
            ],
            [
              -41.8656,
              -3.8483
            ],
            [
              -41.8355,
              -3.8484
            ],
            [
              -41.6864,
              -3.797
            ],
            [
              -41.6866,
              -3.7926
            ],
            [
              -41.6866,
              -3.7815
            ],
            [
              -41.7131,
              -3.771
            ],
            [
              -41.7418,
              -3.7662
            ],
            [
              -41.8183,
              -3.7534
            ],
            [
              -41.8239,
              -3.7533
            ],
            [
              -41.8252,
              -3.7548
            ],
            [
              -41.8259,
              -3.7548
            ],
            [
              -41.8278,
              -3.7533
            ],
            [
              -41.8298,
              -3.7534
            ],
            [
              -41.8666,
              -3.7209
            ],
            [
              -41.8976,
              -3.6981
            ],
            [
              -41.9041,
              -3.693
            ],
            [
              -41.9245,
              -3.6771
            ],
            [
              -41.9262,
              -3.6788
            ],
            [
              -41.9274,
              -3.6794
            ],
            [
              -41.9345,
              -3.6802
            ],
            [
              -41.9447,
              -3.6806
            ],
            [
              -41.948,
              -3.6795
            ],
            [
              -41.9504,
              -3.6767
            ],
            [
              -41.954,
              -3.6758
            ],
            [
              -41.9571,
              -3.6762
            ],
            [
              -41.9621,
              -3.6793
            ]
          ]
        ]
      }
    }
  ]
});

export const REGIAO_BOUNDS = Object.freeze({
  "south": -4.8839,
  "north": -3.5727,
  "west": -42.6467,
  "east": -41.0909,
  "center": {
    "lat": -4.2283,
    "lng": -41.8688
  }
});

export const MUNICIPIOS_BOUNDS = Object.freeze({
  "Barras": {
    "south": -4.3819,
    "north": -3.9267,
    "west": -42.6467,
    "east": -41.9966,
    "center": {
      "lat": -4.1543,
      "lng": -42.321650000000005
    }
  },
  "Batalha": {
    "south": -4.2462,
    "north": -3.6793,
    "west": -42.2667,
    "east": -41.8476,
    "center": {
      "lat": -3.9627499999999998,
      "lng": -42.05715
    }
  },
  "Boa Hora": {
    "south": -4.4822,
    "north": -4.2661,
    "west": -42.1959,
    "east": -42.0005,
    "center": {
      "lat": -4.37415,
      "lng": -42.098200000000006
    }
  },
  "Brasileira": {
    "south": -4.2198,
    "north": -4.034,
    "west": -41.9348,
    "east": -41.313,
    "center": {
      "lat": -4.1269,
      "lng": -41.623900000000006
    }
  },
  "Capitão de Campos": {
    "south": -4.6971,
    "north": -4.3542,
    "west": -42.0793,
    "east": -41.7393,
    "center": {
      "lat": -4.52565,
      "lng": -41.9093
    }
  },
  "Domingos Mourão": {
    "south": -4.4335,
    "north": -4.1385,
    "west": -41.525,
    "east": -41.0981,
    "center": {
      "lat": -4.286,
      "lng": -41.31155
    }
  },
  "Lagoa de São Francisco": {
    "south": -4.4156,
    "north": -4.2952,
    "west": -41.6674,
    "east": -41.5015,
    "center": {
      "lat": -4.3554,
      "lng": -41.584450000000004
    }
  },
  "Milton Brandão": {
    "south": -4.8839,
    "north": -4.5561,
    "west": -41.7768,
    "east": -41.268,
    "center": {
      "lat": -4.72,
      "lng": -41.5224
    }
  },
  "Pedro II": {
    "south": -4.8149,
    "north": -4.2567,
    "west": -41.7453,
    "east": -41.1194,
    "center": {
      "lat": -4.5358,
      "lng": -41.43235
    }
  },
  "Piracuruca": {
    "south": -4.1356,
    "north": -3.5727,
    "west": -41.9108,
    "east": -41.2786,
    "center": {
      "lat": -3.85415,
      "lng": -41.5947
    }
  },
  "Piripiri": {
    "south": -4.5699,
    "north": -4.1457,
    "west": -42.0269,
    "east": -41.4973,
    "center": {
      "lat": -4.357799999999999,
      "lng": -41.762100000000004
    }
  },
  "São João da Fronteira": {
    "south": -4.1889,
    "north": -3.684,
    "west": -41.4849,
    "east": -41.0909,
    "center": {
      "lat": -3.93645,
      "lng": -41.2879
    }
  },
  "São José do Divino": {
    "south": -3.8869,
    "north": -3.6758,
    "west": -41.9816,
    "east": -41.6864,
    "center": {
      "lat": -3.78135,
      "lng": -41.834
    }
  }
});
